<template >
  <!-- 商品管理 -->
  <!-- 查看库存信息 -->
  <div class="goods checks">
    <el-dialog title="库存明细" :visible.sync="dialogTableVisibletable">
      <el-table :data="gridData" height="200">
        <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
        <el-table-column property="Id" align="center" label="订单编号" width="150"></el-table-column>
        <el-table-column property="Remark" align="center" label="订单类型" width="200"></el-table-column>
        <el-table-column property="CTime" align="center" label="日期"></el-table-column>
        <el-table-column property="Counts" align="center" label="库存状态"></el-table-column>
        <el-table-column property="AllCounts" align="center" label="剩余"></el-table-column>
      </el-table>
      <el-button style="width:100px;margin-left:43%;margin-top:20px"
        @click="dialogTableVisibletable = false" type="primary">关闭</el-button>
    </el-dialog>
    <!--商品管理-->
    <div v-show="isGoods">
      <div class="main_container">
        <div class="fuji" @click="show3 = !show3">
          <div class="goodslist1">
            <span style="margin-left:21px;margin-top:5px">搜索/查询</span>
            <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
          </div>
          <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
        </div>
        <el-collapse-transition>
          <div style="padding:0 12px" v-show="show3">
            <el-col :span="24" class="toolbar pad_left">
              <el-form
                :inline="true"
                class="lablepadding"
                :model="filters"
                style="margin-top:0px;display:flex;height:55px">
                <!-- 顶部搜索框 -->
                <el-form-item style="display:flex;width:100%" label="关键词语：">
                  <el-input
                    :title="filters.name"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    v-model="filters.name"
                    placeholder="商品编码 / 标题"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  style="display:flex;width:100%;margin-left:30px;"
                  label="品 牌 商："
                  class="select letter">
                  <el-cascader v-model="filters.pinpaishang"
                    style="width:100%"
                    placeholder="请选择"
                    :options="options3"
                    filterable
                    clearable
                    @change="handleChange"
                  ></el-cascader>
                </el-form-item>
                <el-form-item
                  style="display:flex;width:100%;margin-left:30px;"
                  label="商品品类："
                  class="select"
                >
                  <el-select
                    filterable
                    v-model="filters.brandTypeId"
                    placeholder="请选择"
                    style="background:#fff;width:100%"
                    ref="mySelect"
                    @change="getbrandarr"
                  >
                    <el-option
                      :label="item.Name"
                      :value="item.Id"
                      v-for="(item,index) in brandTypearr"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <el-form
                :inline="true"
                class="lablepadding"
                style="display:flex;position: relative;"
                :model="filters"
              >
                <el-form-item style="display:flex;width:100%;" label="商品品牌：" class="select">
                  <el-select
                    filterable
                    v-model="filters.brandId"
                    placeholder="请选择"
                    style="background:#fff;width:100%"
                    ref="mySelect1"
                  >
                    <el-option
                      :label="item.Name"
                      :value="item.Id"
                      v-for="(item,index) in brandarr"
                      :key="index"
                    ></el-option>
                    <!-- <el-option label="小程序" value="beijing"></el-option> -->
                  </el-select>
                </el-form-item>
                <el-form-item
                  style="display:flex;width:100%;margin-left:30px;"
                  label="商品状态："
                  class="select"
                >
                  <el-select
                    v-model="filters.xuanstatusId"
                    placeholder="请选择"
                    style="background:#fff;width:100%;"
                  >
                    <el-option
                      :label="item.Name"
                      :value="item.Id"
                      v-for="(item,index) in statusptions"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  style="display:flex;width:100%;margin-left:30px;"
                  label="销售类型："
                  class="select"
                >
                  <el-select
                    v-model="filters.goodsActiveId"
                    placeholder="请选择"
                    style="background:#fff;width:100%"
                  >
                    <el-option
                      :label="item.Name"
                      :value="item.Id"
                      v-for="(item,index) in xiaoshouoptions1"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <el-form style>
                <el-form-item style="float:right">
                  <el-button
                    style="border-color:none;height:36px;line-height:1px"
                    class="toolbar_search"
                    @click="onsubmit"
                  >查询</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </div>
        </el-collapse-transition>
      </div>
      <!--列表-->
      <template>
        <el-col :span="24" class="goods_table pad_left">
          <div style="border-bottom:1px solid #eee">
            <p sty class="model_top_title">快捷操作</p>
          </div>
          <div style="display:flex;margin-left:22px;margin-top:15px;padding-right:22px">
            <p
              @click="BatchGoods(0)"
              style="margin:0px;margin-right:5px"
              :class="screenWidth == 1536||screenWidth == 1535?'add_new_btn butstyle1':'add_new_btn butstyle'"
               v-show="menuAction.indexOf(1189)>-1"
            >上 架</p>
            <p
              @click="BatchGoods(1)"
              style="margin:0px;margin-right:5px;width:84px"
              :class="screenWidth == 1536||screenWidth == 1535?'add_new_btn butstyle1':'add_new_btn butstyle'"
              v-show="menuAction.indexOf(1190)>-1"
            >下 架</p>
            <p
              @click="BatchGoods(2)"
              style="margin:0px;margin-right:5px;width:84px"
              :class="screenWidth == 1536||screenWidth == 1535?'add_new_btn butstyle1':'add_new_btn butstyle'"
              v-show="menuAction.indexOf(1191)>-1"
            >首页展示</p>
            <p
              @click="BatchGoods(3)"
              style="margin:0px;margin-right:5px;width:84px"
              :class="screenWidth == 1536||screenWidth == 1535?'add_new_btn butstyle1':'add_new_btn butstyle'"
              v-show="menuAction.indexOf(1192)>-1"
            >取消首页展示</p>
            <p
              @click="BatchGoods(4)"
              style="margin:0px;margin-right:5px;width:84px"
              :class="screenWidth == 1536||screenWidth == 1535?'add_new_btn butstyle1':'add_new_btn butstyle'"
              v-show="menuAction.indexOf(1193)>-1"
            >今日推荐</p>
            <p
              @click="BatchGoods(5)"
              style="margin:0px;margin-right:5px;width:84px"
              :class="screenWidth == 1536||screenWidth == 1535?'add_new_btn butstyle1':'add_new_btn butstyle'"
              v-show="menuAction.indexOf(1194)>-1"
            >取消今日推荐</p>
            <!-- <p
              @click="BatchGoods(6)"
              style="margin:0px;margin-right:5px;width:84px"
              :class="screenWidth == 1536||screenWidth == 1535?'add_new_btn butstyle1':'add_new_btn butstyle'"
              v-show="menuAction.indexOf(1195)>-1"
            >会员专享</p>
            <p
              @click="BatchGoods(7)"
              style="margin:0px;margin-right:5px;width:84px"
              :class="screenWidth == 1536||screenWidth == 1535?'add_new_btn butstyle1':'add_new_btn butstyle'"
              v-show="menuAction.indexOf(1196)>-1"
            >取消会员专享</p> -->
            <p
              @click="BatchGoods(8)"
              style="margin:0px;margin-right:5px;width:84px"
              :class="screenWidth == 1536||screenWidth == 1535?'add_new_btn butstyle1':'add_new_btn butstyle'"
              v-show="menuAction.indexOf(1197)>-1"
            >置 顶</p>
            <p
              @click="BatchGoods(9)"
              style="margin:0px;margin-right:5px;width:84px"
              :class="screenWidth == 1536||screenWidth == 1535?'add_new_btn butstyle1':'add_new_btn butstyle'"
              v-show="menuAction.indexOf(1198)>-1"
            >取消置顶</p>
            <p @click="setnumber" style="margin:0px;margin-right:5px;width:84px"
              :class="screenWidth == 1536||screenWidth == 1535?'add_new_btn butstyle1':'add_new_btn butstyle'"
               v-show="menuAction.indexOf(1199)>-1">调价</p>
            <p @click="scokt()" style="margin:0px;margin-right:5px;width:84px"
              :class="screenWidth == 1536||screenWidth == 1535?'add_new_btn butstyle1':'add_new_btn butstyle'"
              v-show="menuAction.indexOf(1200)>-1">调库存</p>
            <p @click="congin(1)" style="margin:0px;margin-right:5px;width:84px;padding:0 5px"
              :class="screenWidth == 1536||screenWidth == 1535?'add_new_btn butstyle1':'add_new_btn butstyle'"
              v-show="menuAction.indexOf(1211)>-1&&screenWidth>=1530">可用优惠券</p>
             <!-- <p @click="congin(2)" style="margin:0px;margin-right:5px;width:84px;"
              :class="screenWidth == 1536||screenWidth == 1535?'add_new_btn butstyle1':'add_new_btn butstyle'"
              v-show="menuAction.indexOf(1212)>-1&&screenWidth>=1530">可享会员折扣</p> -->
            <p @click="endRecom()" style="margin:0px;margin-right:5px;width:84px"
              :class="screenWidth == 1536||screenWidth == 1535?'add_new_btn butstyle1':'add_new_btn butstyle'"
              v-show="menuAction.indexOf(4250) > -1">商品推荐</p>
          </div>
          <div v-show="screenWidth<1530" style="display:flex;margin-left:22px;margin-top:10px;padding-right:22px"> 
            <p
             @click="congin(1)"
              style="margin:0px;margin-right:5px;width:84px;"
              class="add_new_btn butstyle"
              v-show="menuAction.indexOf(1211)>-1"
            >可用优惠券</p>
             <p
             @click="congin(2)"
              style="margin:0px;margin-right:5px;width:84px;"
              class="add_new_btn butstyle"
              v-show="menuAction.indexOf(1212)>-1"
            >可享会员折扣</p>
            </div>
          <div class="model_section">
            <p class="model_top_title">商品管理</p>

            <!-- <p  class="add_new_btn">上架</p>
                <p  class="add_new_btn">下架</p>
            <p @click="showNext()" class="add_new_btn">+新增</p>-->
            <p v-show="menuAction.indexOf(1188)>-1" style="width:80px" @click="showNext()" class="add_new_btn">+新 增</p>
          </div>
          <div class="table_container">
            <div class="table_inner_container">
              <el-table
                :data="users"
                class="goods_tab"
                stripe
                border
                style="height:auto"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" align="center" width="55"></el-table-column>

                <el-table-column prop="GoodModelCode" label="产品型号" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.GoodModelCode"
                      :label="scope.row.GoodModelCode"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.GoodModelCode}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="Title" label="名称" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.Title"
                      :label="scope.row.Title"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.Title}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="BrandBusinessName" label="所属品牌商" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.BrandBusinessName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.BrandBusinessName}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="所属品牌" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.BrandName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.BrandName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="BrandTypeName" label="所属品类" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.BrandTypeName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.BrandTypeName}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="甄惠装价" align="center">
                  <template slot-scope="scope">￥{{scope.row.TzrPrice}}</template>
                  <template scope="scope">
                    <span
                      :title="'￥'+scope.row.TzrPrice"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >￥{{scope.row.TzrPrice}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="市场价格" align="center">
                  <template slot-scope="scope">
                     <span
                      :title="'￥'+scope.row.MarketPrice"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >￥{{scope.row.MarketPrice}}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="IsVIPOnlyName" label="会员专享" align="center">
                  <template scope="scope">
                    <span :title="scope.row.IsVIPOnlyName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.IsVIPOnlyName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="IsVIPDiscountName" label="享受会员折扣" width="90px" align="center">
                  <template scope="scope">
                    <span :title="scope.row.IsVIPDiscountName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.IsVIPDiscountName}}</span>
                  </template>
                </el-table-column> -->
                <el-table-column prop="IsTopName" label="是否置顶" align="center">
                  <template scope="scope">
                    <span :title="scope.row.IsTopName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.IsTopName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="IsUseCouponName" label="可用优惠券" width="80px" align="center">
                  <template scope="scope">
                    <span :title="scope.row.IsUseCouponName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.IsUseCouponName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="IsShowHomeName" label="首页展示" align="center">
                  <template scope="scope">
                    <span :title="scope.row.IsShowHomeName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.IsShowHomeName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="IsTodayName" label="今日推荐" align="center">
                  <template scope="scope">
                    <span :title="scope.row.IsTodayName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.IsTodayName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="Stock" label="库存" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.Stock"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.Stock}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="GoodsActiveName" label="销售类型" width="72px" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.GoodsActiveName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.GoodsActiveName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="StatusName" label="状态" width="59px" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.StatusName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.StatusName}}</span>
                  </template>
                  <!-- <template slot-scope="scope">
                    <span v-if="scope.row.status==1" class="ac_btn_fail">过期下架</span>
                    <span v-if="scope.row.status==2">停售下架</span>
                    <span v-if="scope.row.status==3" class="ac_btn_normal">正常</span>
                  </template>-->
                </el-table-column>
                <!-- <el-table-column prop="CTime" fixed="right" label="设置销量" :width="tdwidth>1360?'203':'122'" align="center">
                  <template scope="scope">
                    <span
                      style="color:#6786b4;margin-left:8px;cursor: pointer;"
                      @click="volume(scope)"
                    >
                      <i class="el-icon-setting"></i>
                      设置商品销量
                    </span>
                    <span>(销量:{{scope.row.SalesCount}})</span>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" prop="CTime" label="添加评论" :width="tdwidth>1360?'223':'137'" align="center">
                  <template scope="scope">
                    <span
                      style="color:#6786b4;margin-left:8px;cursor: pointer;"
                      @click="comment(scope)"
                    >
                      <i class="el-icon-document"></i>
                      设置内测商品评价
                    </span>
                     <span>(评价数:{{scope.row.InnerCommentCounts}})</span>
                  </template>
                </el-table-column>-->
                <el-table-column prop label="操作" width="250px" align="center" fixed="right">
                  <template scope="scope">
                    <div class="goods_operations action_container">
                      <!-- <p v-if="menuAction.indexOf(1066)>-1">
                        <el-switch
                          v-model="scope.row.IsShowHome"
                          @change="changehome(scope.row)"
                          active-color="#F56C6C"
                          inactive-color="#ddd"
                          active-text="首页展示"
                          inactive-text
                        ></el-switch>
                      </p>
                      <p v-if="menuAction.indexOf(1067)>-1">
                        <el-switch
                          v-model="scope.row.IsToday"
                          @change="today(scope.row)"
                          active-color="#F56C6C"
                          inactive-color="#ddd"
                          active-text="今日推荐"
                          inactive-text
                        ></el-switch>
                      </p>-->
                      <p @click="chakan(scope.row)" v-if="menuAction.indexOf(61)>-1">
                        <i class="el-icon-view"></i>
                        查看
                      </p>
                      <p @click="endEdit(scope.row)" v-if="menuAction.indexOf(62)>-1">
                        <i class="el-icon-edit-outline"></i>
                        编辑
                      </p>
                      <span
                        style="color:#6786b4;margin-left:8px;cursor: pointer;"
                        @click="volume(scope)"
                        v-if="menuAction.indexOf(1201)>-1"
                      >
                        <i class="el-icon-setting"></i>
                        销量
                      </span>
                      <!-- <span>(销量:{{scope.row.SalesCount}})</span> -->
                      <span
                        style="color:#6786b4;margin-left:8px;cursor: pointer;"
                        @click="comment(scope)"
                         v-if="menuAction.indexOf(1202)>-1"
                      >
                        <i class="el-icon-document"></i>
                        评价
                      </span>
                      <!-- <span>(评价数:{{scope.row.InnerCommentCounts}})</span> -->
                      <!-- <span v-if="menuAction.indexOf(63)>-1">
                        <p @click="xiajia(scope.row)" v-if="scope.row.StatusId==1">
                          <i class="el-icon-sold-out"></i>
                          <span>下架</span>
                        </p>
                        <p @click="shangjia(scope.row)" v-if="scope.row.StatusId==4">
                          <i class="el-icon-sold-out"></i>
                          <span>已下架</span>
                        </p>
                      </span>-->

                      <!-- <span>
                        <p @click="guoqi(scope.row)" v-if="scope.row.StatusId==1">
                          <i class="fa fa-clock-o" aria-hidden="true"></i>
                          过期
                        </p>
                      <p @click="shangjia(scope.row)" v-if="scope.row.StatusId==3">-->
                      <!-- <i class="el-icon-sold-out"></i>
                          <span>已过期</span>
                        </p>
                        <p @click="kucun(scope.row)" v-if="menuAction.indexOf(61)>-1">
                          <i class="el-icon-tickets"></i>
                          库存明细
                      </p>-->
                      <!-- <p @click="setnumber(scope.row)">
                          <i class="el-icon-setting"></i>
                          设置价格
                      </p>-->
                      <!-- </span> -->

                      <!-- <p @click="tingyong(scope.row)" >
                       
                        <i class="fa fa-clock-o" aria-hidden="true"></i>
                        停用
                      </p>-->
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" style="padding-top:10px;" class="toolbar_footer">
                <el-pagination
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :page-size="10"
                  :current-page="pageIndex"
                  :total="total"
                  style="float:right;"
                ></el-pagination>
              </el-col>
            </div>
          </div>
        </el-col>
      </template>
    </div>
    <!-- 商品管理  新增界面 -->
    <el-col :span="24" class="add_goods pad_left" v-show="isAdd">
      <div class="model_section">
        <el-col :span="24" style>
          <p class="model_top_title" v-if="shownew">商品管理新增</p>
          <p class="model_top_title" v-else>商品管理编辑</p>
        </el-col>
      </div>

      <div class="add_all">
        <!-- 商品基本信息 -->
        <div class="goods_msg">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>商品基本信息</p>
            </el-col>
          </div>
          <!-- 基本信息具体内容 -->

          <div class="msg_content content">
            <el-form style="display:flex;width:100%;">
              <el-form-item
                class="width100"
                label="品　　类:"
                style="width:42%;margin-left: 64px;display:flex"
                :rules="[
                  { required: true}
                ]"
                prop
              >
                <el-select
                  filterable
                  v-model="newpinleiId"
                  placeholder="请选择"
                   @change="getbrandarr1">
                  <el-option
                    v-for="item in newpinleioptions"
                    :key="item.Id"
                    :value="item.Id"
                    :label="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="width100"
                label="品　　牌:"
                style="width:42.5%;margin-left:35px;display:flex"
                :rules="[
                  { required: true}
                ]" prop>
                <el-select v-model="newpinpaiId" filterable placeholder="请选择">
                  <el-option
                    v-for="item in addbrand"
                    :key="item.Id"
                    :value="item.Id"
                    :label="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-form style="display:flex;width:100%;">
              <el-form-item label="产品型号:" class="width100" style="width:42%;margin-left: 64px;display:flex" :rules="[{ required: true}]">
                <el-input maxlength="50" show-word-limit v-model="GoodModelCode"></el-input>
              </el-form-item>
              <!-- <el-form-item label="所属省份:" class="width100 more100"  style="width:42%;margin-left:45px;display:flex"  prop="name">
                     <i style="margin-right:5px">省</i>
                <el-input
                  placeholder="请输入内容"
                  v-model="newprovinceName"
                  :disabled="true"
                
                ></el-input>
                <i  style="margin:0 5px">市</i>
                <el-input
                  placeholder="请输入内容"
                  v-model="newcityName"
                  :disabled="true"
                 
                ></el-input>
              </el-form-item>-->
            </el-form>
            <el-form style="display:flex;width:100%;">
              <!-- <el-form-item label="合作类型:" class="width100 "  style="width:41.2%;margin-left: 73px;display:flex"  prop="name">
                    <el-input v-model="hezuotype" :disabled="true"></el-input>
                  </el-form-item>
                  <el-form-item label="合作周期:" class="width100 data100" style="width:42%;margin-left:45px;display:flex"  prop="name">
                    <el-date-picker type="daterange" :disabled="true" v-model="valuedata" value-format="yyyy-MM-dd" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                  </el-form-item>-->
            </el-form>
            <el-form class="changstyle">
              <el-form-item style="margin-left:26px;" label="详情页产品图片:" label-width="102px" :rules="[ { required: true} ]">
                <div class="upPictures">
                <!-- 详情页产品图片拖拽 -->
                <draggable v-model="detailImgUrlarr1" @update="dragDetailsPic" :options="{animation:500}">
                  <transition-group>
                    <div class="block" v-for="(item,index) in detailImgUrlarr1" :key="index" :data-img="item"
                     @click.stop="$imgPreview">
                      <div style="float:left;margin-right:10px" class="tuimg">
                        <el-image style="width: 80px; height:80px" :src="item"></el-image>
                        <div class="chahao" @click.stop="deldetail(index)">
                          <img src="../../assets/img/aicon36.png" alt />
                        </div>
                      </div>
                    </div>
                  </transition-group>
                </draggable>
                <!-- 上传详情页产品图片 -->
                <el-upload action multiple list-type="picture-card" v-if="flag < 20"
                  :before-upload="beforeAvatarUpload" accept=".png, .jpg,.jpeg">
                  <!-- :limit="5" :on-exceed="handleExceed" -->
                  <img v-if="form.ImgUrl" ref="big1" :src="form.ImgUrl" class="avatar" width="100%"/>
                  <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                  <div class="el-upload__tip" style="margin-top:15px;" slot="tip">
                    <img src="../../assets/img/aicon15_09.jpg" alt style="margin-bottom:5px" />
                    建议分类竖图尺寸750px*750px以上且比例为1：1，商品详情图尺寸为支持jpg、png等格式
                  </div>
                </el-upload>
                </div>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </el-form>
            <el-form style="display:flex;width:100%;">
              <el-form-item
                label="标　　题:"
                class="width100"
                style="width:42%;margin-left: 64px;display:flex"
                :rules="[
      { required: true}
    ]"
                prop
              >
                <el-input type="text" v-model="Title" maxlength="30" show-word-limit></el-input>
              </el-form-item>
              <el-form-item
                label="标　　语:"
                class="width100"
                style="width:42%;margin-left:45px;display:flex"
                prop="name"
              >
                <el-input type="text" v-model="Slogan" maxlength="30" show-word-limit></el-input>
              </el-form-item>
            </el-form>
            <el-form style="display:flex;width:100%;">
              <el-form-item
                label="产品库存:"
                class="width100"
                style="width:42%;margin-left: 64px;display:flex"
                :rules="[
      { required: true}
    ]"
                prop
              >
                <el-input v-model="form.weistock"  maxlength="8"  show-word-limit onkeyup="value=value.replace(/[^\d\.]/g,'')"></el-input>
              </el-form-item>
              <el-form-item
                label="单　　位:"
                class="width100"
                style="width:42.5%;margin-left:35px;display:flex"
                :rules="[
      { required: true}
    ]"
                prop
              >
                <el-select v-model="danweiId" placeholder="请选择">
                  <el-option
                    v-for="item in danwei"
                    :key="item.id"
                    :value="item.Id"
                    :label="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>

            <el-form style="display:flex;width:100%;">
              <el-form-item
                label="产品优势:"
                class="width100"
                style="width:41%;margin-left: 73px;display:flex"
                prop="name"
              >
                <el-input type="textarea" v-model="Advantage" maxlength="60" show-word-limit></el-input>
              </el-form-item>
              <el-form-item
                label="备　　注:"
                class="width100"
                style="width:42%;margin-left:50px;display:flex"
                prop="name"
              >
                <el-input type="textarea" v-model="Remark" maxlength="100" show-word-limit></el-input>
              </el-form-item>
            </el-form>
            <!-- 旧样式 -->
            <el-form class="msg_form">
              <!-- <el-form-item label="品类:" label-width="105px" prop="name">
                 
                <el-select
                  filterable
                  v-model="newpinleiId"
                  placeholder="请选择"
                  style="width:200px"
                  @change="selectpinlei(newpinleiId)"
                >
                  <el-option
                    v-for="item in newpinleioptions"
                    :key="item.Id"
                    :value="item.Id"
                    :label="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>-->
              <!-- <el-form-item label="品牌:" label-width="105px" prop="name">
                <el-select v-model="newpinpaiId" filterable placeholder="请选择" style="width:140px">
                  <el-option
                    v-for="item in newpinpaioptions.agentBrandList"
                    :key="item.Id"
                    :value="item.Id"
                    :label="item.Name"
                  ></el-option>
                </el-select>
                <i>省</i>
                <el-input
                  placeholder="请输入内容"
                  v-model="newprovinceName"
                  :disabled="true"
                  style="width:140px"
                ></el-input>
                <i>市</i>
                <el-input
                  placeholder="请输入内容"
                  v-model="newcityName"
                  :disabled="true"
                  style="width:140px"
                ></el-input>
              </el-form-item>-->
              <!-- <el-form-item label="产品型号:" label-width="105px" prop="name">
                <el-input v-model="GoodModelCode" style="width:200px"></el-input>
              </el-form-item>-->
              <!-- 合作类型 -->
              <!-- <div class="cooperation_type">
                <el-form-item label="合作类型:" prop="name" label-width="105px">
                  <el-input v-model="hezuotype" style="width:200px" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item
                  label="合作开始时间:"
                  label-width="115px"
                  prop="name"
                  style="width:370px"
                  v-show="showtime"
                >
                  <el-date-picker
                    type="date"
                    :editable="false"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    v-model="coperdate1"
                    style="width: 200px"
                    :disabled="true"
                  ></el-date-picker>
                  <img src="../../assets/img/aicon10_03.jpg" alt />
                </el-form-item>
                <el-form-item
                  label="合作截止时间:"
                  prop="name"
                  label-width="100px"
                  style="width:400px"
                  v-show="showtime"
                >
                  <el-date-picker
                    type="date"
                    :editable="false"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    v-model="coperdate2"
                    style="width: 200px"
                    :disabled="true"
                  ></el-date-picker>
                  <img src="../../assets/img/aicon10_03.jpg" alt />
                </el-form-item>
              </div>-->
              <!-- <el-form-item label="首页产品图片:" label-width="102px">
                <div v-for="(item,index) in indexImgUrlarr" :key="index"
                  :data-img="item.ImgData" @click.stop="$imgPreview">
                  <div style="float:left;margin-right:20px" class="tuimg">
                    <el-image style="width: 80px; height:80px" :src="item.ImgData"></el-image>
                    <div class="chahao" @click.stop="delshou(index)">
                      <img src="../../assets/img/aicon36.png" alt />
                    </div>
                  </div>
                </div>

                <el-upload action list-type="picture-card" :on-change="handleshouedetail">
                  <img v-if="form.ImgUrl" :src="form.ImgUrl" class="avatar" width="100%" />
                  <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                  <div class="el-upload__tip" slot="tip">
                    <img src="../../assets/img/aicon15_09.jpg" alt style="margin-bottom:5px" />
                    首页横图尺寸为585px*245px，分类竖图尺寸275px*350px，商品详情图尺寸为支持jpg、png等格式
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>-->

              <!-- <el-form-item label="详情页产品图片:" label-width="102px">
                <div v-for="(item,index) in detailImgUrlarr" :key="index"
                  :data-img="item.ImgData" @click.stop="$imgPreview">
                  <div style="float:left;margin-right:20px" class="tuimg">
                    <el-image style="width: 80px; height:80px" :src="item.ImgData"></el-image>
                    <div class="chahao" @click.stop="deldetail(index)">
                      <img src="../../assets/img/aicon36.png" alt />
                    </div>
                  </div>
                </div>

                <el-upload
                  action
                  list-type="picture-card"
                  :before-upload="beforeAvatarUpload"
                  :limit="3"
                  :on-exceed="handleExceed">
                  <img v-if="form.ImgUrl" ref="big1" :src="form.ImgUrl" class="avatar" width="100%" />
                  <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                  <div class="el-upload__tip" style="margin-top:15px;" slot="tip">
                    <img src="../../assets/img/aicon15_09.jpg" alt style="margin-bottom:5px" />
                    建议分类竖图尺寸750px*750px以上且比例为1：1，商品详情图尺寸为支持jpg、png等格式
                  </div>
                </el-upload>

                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>-->
              <!-- <el-form-item label="标题:" label-width="105px">
                <el-input
                  type="text"
                  v-model="Title"
                  style="width:450px"
                  maxlength="30"
                  show-word-limit
                ></el-input>
              </el-form-item>-->
              <!-- <el-form-item label="标语:" label-width="105px">
                <el-input
                  type="text"
                  v-model="Slogan"
                  style="width:450px"
                  maxlength="30"
                  show-word-limit
                ></el-input>
              </el-form-item>-->
              <!-- <el-form-item label="产品优势:" label-width="105px">
                <el-input
                  type="text"
                  v-model="Advantage"
                  style="width:1000px"
                  maxlength="60"
                  show-word-limit
                ></el-input>
              </el-form-item>-->
              <el-form-item
                label="颜　　色:"
                class="color_msg width100"
                style="margin-left:21px"
                label-width="105px"
                :rules="[
                  { required: true}
                ]"
                prop
              >
                <div class="table_color_box" style="width:76.5%">
                  <div
                    class="item"
                    style="width: 100%;display: flex;justify-content: space-around;"
                  >
                    <div :style="screenWidth>=1918?'margin-left:144px':''" class="color">名称</div>
                    <div :style="screenWidth>=1918?'margin-left:144px':''" class="img_vox">图片</div>
                    <div :style="screenWidth>=1918?'margin-left:144px':''" class="action_del">操作</div>
                  </div>
                  <div
                    class="item"
                    style="    display: flex;justify-content: space-around;"
                    v-for="(item,index) in colorList"
                    :key="index"
                  >
                    <div class="color">
                      <el-input :style="screenWidth>=1918?'width:456px':'width:250px'" maxlength="50" show-word-limit v-model="colorList[index].ImgName"></el-input>
                    </div>
                    <div class="img_vox" @click="imgchaun(index)">
                      <el-upload
                      :style="screenWidth>=1918?'margin-left:284px':''"
                        action
                        list-type="picture-card"
                        :index="index"
                        class="table_pic"
                        :before-upload="beforeAvatarUpload1">
                        <img
                          v-if="colorList[index].ImgData"
                          :src="BaseUrl+colorList[index].ImgData"
                          class="avatar"
                          width="100%"/>
                        <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                      </el-upload>
                    </div>
                    <div  :style="screenWidth>=1918?'margin-left:405px':''" class="action_del">
                      <span @click="delColor(index)">删除</span>
                    </div>
                  </div>
                </div>

                <div class="color_btn" @click="addColor">新增</div>
              </el-form-item>
              <!-- <div style="overflow:hidden">
              
                <el-form-item label="库存:" label-width="105px" prop="name" style="float:left;">
                  <el-input
                    v-model="form.weistock"
                    style="width:144px"
                    onkeyup="value=value.replace(/[^\d\.]/g,'')"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label
                  prop="name"
                  label-width="0px"
                  style="float:left;margin-left:20px"
                ></el-form-item>
                <el-form-item label="单位:" label-width="105px" prop="name" style="float:left;">
                  <el-select v-model="danweiId" placeholder="请选择" style="width:144px">
                    <el-option
                      v-for="item in danwei"
                      :key="item.id"
                      :value="item.Id"
                      :label="item.Name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>-->

              <!-- <el-form-item label="备注:" label-width="105px">
                <el-input
                  type="textarea"
                  v-model="Remark"
                  style="width:1000px"
                  maxlength="100"
                  show-word-limit
                ></el-input>
              </el-form-item>-->
              <el-form-item
                class="width100"
                style="margin-left:21px;width:36.5%"
                label="物流方式:"
                prop="name"
                label-width="105px"
              >
                <el-select v-model="wuliuId" placeholder="请选择">
                  <el-option
                    v-for="item in wuliu"
                    :key="item.Id"
                    :value="item.Id"
                    :label="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="运费说明:"
                class="width100"
                style="margin-left:21px;width:36.5%"
                label-width="105px"
              >
                <el-input type="text" v-model="FreightDesc" maxlength="30" show-word-limit></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 商品详情 / 参数 -->
        <div class="goods_parameter">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>商品详情 / 参数</p>
            </el-col>
          </div>
          <!-- 商品详情具体内容 -->
          <div class="parameter_content content" v-if="quyuarr.length>0">
            <el-form class="parameter_form">
              <!-- 左侧 -->
              <div class="parameter_form_l" v-for="(item,index) in quyuarr" :key="index">
                <el-form-item
                  :label="item.Name"
                  prop="name"
                  label-width="105px"
                  v-show="item.ControlTypeId==1"
                >
                  <el-input v-model="GoodsParams[index].DataValue" style="width:360px" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item :label="item.Name" label-width="105px" v-show="item.ControlTypeId==3">
                  <div class="whether">
                    <div>
                      <i>
                        <img
                          :src="item.sel?src2:src1"
                          alt
                          @click="changeImg(index,0)"
                          :bangding="index"
                          :selId="quyuarr[index]"
                        />
                      </i>
                      是
                    </div>
                    <div>
                      <i>
                        <img
                          :src="item.sel?src1:src2"
                          :bangding="index"
                          :selId="quyuarr[index]"
                          alt
                          @click="changeImg(index,1)"
                        />
                      </i>
                      否
                    </div>
                  </div>
                </el-form-item>

                <el-form-item :label="item.Name" label-width="105px" v-show="item.ControlTypeId==2">
                  <el-select
                    v-model="GoodsParams[index].DataValue"
                    placeholder="请选择"
                    style="background:#fff"
                  >
                    <el-option
                      :label="item.Name"
                      :value="item.Id"
                      v-for="(item) in item.BaseDatas"
                      :key="item.Id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
        <!-- 产品其他参数 -->
        <!-- <div class="other">
          <div class="msg_title">
              <el-col :span="24" style>
               <p>商品详情/其他参数<span style="color:#bfbfbf;font-size:12px;margin-left:20px;">添加更多商品参数，若无可不填写</span></p>
              </el-col>
          </div>
        
               <div>
                 <span>序号</span>
                 <span>参数名称</span>
                 <span>值</span>
                 <span>操作</span>
               </div>

        </div>-->
        <div class="goods_shop">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>
                商品详情/其他参数
                <span
                  style="color:#bfbfbf;font-size:12px;margin-left:20px;"
                >添加更多商品参数，若无可不填写</span>
              </p>
            </el-col>
          </div>
          <!-- 其他参数 内容 -->
          <div class="shop_content">
            <el-form>
              <el-form-item label="其他参数:">
                <div class="table_color_box">
                  <div class="item">
                    <div style="width:60px;text-align:90px; padding: 10px 15px;">序号</div>
                    <div style="color:#888;width: 300px; padding: 10px 15px;">参数名称</div>
                    <div class="img_vox">值</div>
                    <div class="action_del">操作</div>
                  </div>
                  <div class="item" v-for="(item,index) in othertable" :key="index">
                    <div style="width:60px;text-align:90px; padding: 10px 15px;">{{index+1}}</div>
                    <div class="color">
                      <el-input style="width:300px" v-model="othertable[index].PName" maxlength="50"></el-input>
                    </div>
                    <div class="img_vox">
                      <el-input style="width:300px" v-model="othertable[index].PValue" maxlength="50"></el-input>
                    </div>
                    <div class="action_del">
                      <span @click="delother(index)">删除</span>
                    </div>
                  </div>
                </div>
                <div class="shop_btn" v-show="addothers" @click="addother()">新增</div>
                <div class="shop_btn" style="padding:0 5px;" @click="deleteother()">全部删除</div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 产品优势 -->
        <div class="goods_advantage">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>产品优势</p>
            </el-col>
          </div>
          <!-- 优势的图片 -->
          <el-form class="advantage_pic">
            <el-form-item label="图片:" label-width="80px">
              <!-- 产品优势图拖拽 -->
              <draggable v-model="youImgUrlarr1" @update="dragAdvantagePic" :options="{animation:500}">
                <transition-group>
                  <div class="block" v-for="(item,index) in youImgUrlarr1" :key="index" :data-img="item"
                    @click.stop="$imgPreview">
                    <div style="float:left;" class="tuimg">
                      <el-image style="width: 80px; height:80px" :src="item"></el-image>
                      <div class="chahao" @click.stop="delyoushi(index)">
                        <img src="../../assets/img/aicon36.png" alt />
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
              <!-- 产品优势 + -->
              <el-upload action multiple list-type="picture-card" v-if="flag2 < 30"
              :before-upload="handleproductyou" :limit="5" :on-exceed="handleExceed" accept=".png, .jpg,.jpeg">
                <img v-if="form.ImgUrl" :src="form.ImgUrl" class="avatar" width="100%" />
                <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                <div class="el-upload__tip" slot="tip">
                  <img src="../../assets/img/aicon15_09.jpg" alt style="margin-bottom:5px" />
                  PC宽度为0~1200px，小程序宽度为700px，支持jpg、png等格式
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
            </el-form-item>
          </el-form>
        </div>
        <!-- 应用效果 -->
        <div class="goods_advantage" v-show="advantage">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>应用效果</p>
            </el-col>
          </div>
          <!-- 应用效果 图片 -->
          <div class="advantage_pic">
            <el-form>
              <el-form-item label="图片:">
                <div v-for="(item,index) in xiaoguoImgUrlarr" :key="index"
                  :data-img="item.ImgData" @click.stop="$imgPreview">
                  <div style="float:left;margin-right:20px" class="tuimg">
                    <el-image style="width: 80px; height:80px" :src="item.ImgData"></el-image>
                    <div class="chahao" @click.stop="delxiaoguo(index)">
                      <img src="../../assets/img/aicon36.png" alt />
                    </div>
                  </div>
                </div>

                <el-upload action list-type="picture-card" :on-change="handlexiaoguo" accept=".png, .jpg,.jpeg">
                  <img v-if="form.ImgUrl" :src="form.ImgUrl" class="avatar" width="100%" />
                  <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                  <div class="el-upload__tip xijie" slot="tip">
                    <img src="../../assets/img/aicon15_09.jpg" alt style="margin-bottom:5px" />
                    PC宽度为0~1200px，小程序宽度为700px，支持jpg、png等格式
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 产品细节 -->
        <div class="goods_advantage" v-show="advantage">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>产品细节</p>
            </el-col>
          </div>
          <!-- 产品细节 图片 -->
          <div class="advantage_pic">
            <el-form>
              <el-form-item label="图片:">
                <div v-for="(item,index) in xijieImgUrlarr" :key="index"
                  :data-img="item.ImgData"
                  @click.stop="$imgPreview">
                  <div style="float:left;margin-right:20px" class="tuimg">
                    <el-image style="width: 80px; height:80px" :src="item.ImgData"></el-image>
                    <div class="chahao" @click.stop="delxijieimg(index)">
                      <img src="../../assets/img/aicon36.png" alt />
                    </div>
                  </div>
                </div>

                <el-upload action list-type="picture-card" :on-change="handlexijie" accept=".png, .jpg ,.jpeg">
                  <img v-if="form.ImgUrl" :src="form.ImgUrl" class="avatar" width="100%" />
                  <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                  <div class="el-upload__tip xijie" slot="tip">
                    <img src="../../assets/img/aicon15_09.jpg" alt style="margin-bottom:5px" />
                    PC宽度为0~1200px，小程序宽度为700px，支持jpg、png等格式
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 产品检测报告 -->
        <div class="goods_advantage">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>产品检测报告</p>
            </el-col>
          </div>
          <!-- 产品检测 图片 -->
           <div class="advantage_pic">
            <el-form>
              <el-form-item label="图片:" label-width="80px">
                <!-- 产品检测图拖拽 -->
                <draggable v-model="jianceImgUrlarr1" @update="dragTestingPic" :options="{animation:500}">
                  <transition-group>
                    <div class="block" v-for="(item,index) in jianceImgUrlarr1" :key="index" :data-img="item"
                      @click.stop="$imgPreview">
                      <div style="float:left;margin-right:10px;" class="tuimg">
                        <el-image style="width: 80px; height:80px" :src="item"></el-image>
                        <div class="chahao" @click.stop="deljianceimg(index)">
                          <img src="../../assets/img/aicon36.png" alt />
                        </div>
                      </div>
                    </div>
                  </transition-group>
                </draggable>
                <!-- 产品检测 -->
                <el-upload action multiple style="margin-top:5px" list-type="picture-card" v-if="flag3 < 30"
                :before-upload="handlejiance" :limit="5" :on-exceed="handleExceed" accept=".png, .jpg,.jpeg">
                  <img v-if="form.ImgUrl" :src="form.ImgUrl" class="avatar" width="100%" />
                  <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                  <div class="el-upload__tip" slot="tip">
                    <img src="../../assets/img/aicon15_09.jpg" alt style="margin-bottom:5px" />
                    PC宽度为0~1200px，小程序宽度为700px，支持jpg、png等格式
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </el-form>
          </div>
        </div>
          <!-- <div class="advantage_pic">
            <el-form>
              <el-form-item label="图片:">
                <div v-for="(item,index) in jianceImgUrlarr1" :key="index" :data-img="item"
                  @click.stop="$imgPreview">
                  <div style="float:left;margin-right:20px" class="tuimg">
                    <el-image style="width: 80px; height:80px" :src="item"></el-image>
                    <div class="chahao" @click.stop="deljianceimg(index)">
                      <img src="../../assets/img/aicon36.png" alt />
                    </div>
                  </div>
                </div>

                <el-upload action list-type="picture-card" :on-change="handlejiance">
                  <img v-if="form.ImgUrl" :src="form.ImgUrl" class="avatar" width="100%" />
                  <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                  <div class="el-upload__tip xijie" slot="tip">
                    <img src="../../assets/img/aicon15_09.jpg" alt style="margin-bottom:5px" />
                    PC宽度为0~1200px，小程序宽度为700px，支持jpg、png等格式
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </el-form>
          </div>
        </div> -->
        <!-- 在售店面 -->
        <div class="goods_shop">
          <!-- <div class="msg_title">
            <el-col :span="24" style>
              <p>在售店面</p>
            </el-col>
          </div>-->
          <!-- 在售店面 内容 -->
          <!-- <div class="shop_content">
            <el-form>
              <el-form-item label="在售店面:">
                <div class="table_color_box">
                  <div class="item">
                    <div class="color">店面名称</div>
                    <div class="img_vox">店面地址</div>
                    <div class="action_del">操作</div>
                  </div>
                  <div class="item" v-for="(item,index) in shoplist" :key="index">
                    <div class="color">
                      <el-input style="width:300px" v-model="shoplist[index].Name"></el-input>
                    </div>
                    <div class="img_vox">
                      <el-input style="width:300px" v-model="shoplist[index].Address"></el-input>
                    </div>
                    <div class="action_del">
                      <span @click="delshop(index)">删除</span>
                    </div>
                  </div>
                </div>
                <div class="shop_btn" @click="addshop">新增</div>
              </el-form-item>
            </el-form>
          </div>-->
        </div>
        <!-- 售后政策 -->
        <div class="goods_policy">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>售后政策</p>
            </el-col>
          </div>
          <!-- 售后政策 内容 -->
          <div class="policy_content">
            <el-form>
              <el-form-item label="售后政策:">
                <el-input type="textarea" maxlength="500" show-word-limit :rows="5" style="width:1000px" v-model="AfterPolicy"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 注意事项 -->
        <div class="goods_policy">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>注意事项</p>
            </el-col>
          </div>
          <!-- 注意事项 内容 -->
          <div class="policy_content">
            <el-form>
              <el-form-item label="注意事项:">
                <el-input type="textarea" maxlength="500" show-word-limit :rows="5" style="width:1000px" v-model="NeedAttention"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="goods_footer" v-if="actid">
        <!-- <p @click="editSubmit" v-if="shownew" >111</p> -->
        <!-- <p @click="newbianSubmit" v-else>保存</p> -->
        <p @click="showGoods()">取 消</p>
        <p @click="endBack()">下一步</p>
      </div>
      <div class="goods_footer" v-else>
        <p @click="showGoods()">取 消</p>
        <p @click="endBack()">下一步</p>
      </div>
    </el-col>
    <!--新增 下一步 界面-->
    <el-col
      id="scoll"
      :span="24"
      class="add_goods_next main_container"
      v-loading="loading2"
      element-loading-text="拼命保存中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      v-show="isNext"
    >
      <div class="model_section">
        <el-col :span="24" style>
          <p class="model_top_title" v-if="shownew">商品管理新增</p>
          <p class="model_top_title" v-else>商品管理编辑</p>
        </el-col>
      </div>
      <div class="table_container">
        <!-- <el-form
        :inline="true"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm">
        <el-form-item style="width:470px;margin-left:35px;"  label="是否使用优惠券：" prop="name">
         <template>
            <el-radio v-model="radio" @change="clickitem()" label=0>否</el-radio>
            <el-radio style="margin-left:230px" v-model="radio" label=1>是</el-radio>
        </template>
        </el-form-item>
        <el-form-item style="width:600px;" v-show="radio==1" label-width="50px"  label="每满">
            <el-input v-model="money" style="width:150px;" placeholder="请输入金额"></el-input>
            <span style="color:#888;font-size:13px;">
             元，可使用100元优惠券
            </span>
        </el-form-item>
        </el-form>-->
        <el-form :model="form" label-width="100px" ref="editForm" class="next_form">
          <el-form-item label="销售类型:">
            <el-select
              v-model="options"
              filterable
              placeholder="请选择"
              @change="changeOption(options)"
              style="width:15%;">
              <el-option
                v-for="item in xiaoshouoptions"
                :key="item.Id"
                :value="item.Id"
                :label="item.Name"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 样品尾货 -->
          <!-- vip价 -->
          <div class="vip" v-show="isVip">
            <el-form-item label="VIP价:" prop="name">
              <el-input
                v-model="VipPrice"
                style="width:144px"
                onkeyup="value=value.replace(/[^\d\.]/g,'')"
              ></el-input>
              <i>元 +</i>
              <el-input
                v-model="Score"
                style="width:144px"
                onkeyup="value=value.replace(/[^\d\.]/g,'')"
              ></el-input>
              <i>积分,</i>
              <i>累计分享</i>
              <el-input
                v-model="SharingDays"
                style="width:144px"
                onkeyup="value=value.replace(/[^\d\.]/g,'')"
              ></el-input>
              <i>天免积分</i>
            </el-form-item>
          </div>
          <div class="sample" v-show="isSample">
            <el-form-item label="市场价:" prop="name">
              <el-input
                @blur="changeblur()"
                v-model="form.shichangprice"
                style="width:144px"
                onkeyup="value=value.replace(/^(\s+|\.+|\D)/,'').replace(/(\d+)(\.)(\d)(\.)/,'$1$2$3').replace(/(\d+)(\.)(\.)/,'$1$2').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
              ></el-input>
              <i>元</i>
            </el-form-item>
            <el-form-item label="甄惠装价:">
              <el-input
                @blur="changeblur()"
                v-model="form.tzprice"
                style="width:144px"
                onkeyup="value=value.replace(/^(\s+|\.+|\D)/,'').replace(/(\d+)(\.)(\d)(\.)/,'$1$2$3').replace(/(\d+)(\.)(\.)/,'$1$2').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
              ></el-input>
              <i>元</i>
            </el-form-item>
            <el-form-item label="佣金比例:">
              <el-input maxlength="2"
                v-model="form.yongjin"
                style="width:144px"
                onkeyup="this.value=this.value.replace(/\D/g,'')"/>
              <i>%</i>
            </el-form-item>
            <!-- <el-form-item label="库存:">
              <el-input
                v-model="form.weistock"
                style="width:144px"
                onkeyup="value=value.replace(/[^\d\.]/g,'')"
              ></el-input>
              <i>个</i>
            </el-form-item>-->
          </div>
          <!-- 预售 -->
          <div class="advance" v-show="isAdvance">
            <el-form-item label="预售截止日期:" style="width:50%">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="yuETime"
                :editable="false"
                value-format="yyyy-MM-dd"
                style="width: 200px;"
                :picker-options="pickerOptions2"
              ></el-date-picker>

              <img src="../../assets/img/aicon10_03.jpg" alt />
            </el-form-item>
            <el-form-item label="发货起始日期:" style="width:50%">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="yuSTime"
                :editable="false"
                value-format="yyyy-MM-dd"
                style="width: 200px;"
                :picker-options="pickerOptions3"
              ></el-date-picker>

              <img src="../../assets/img/aicon10_03.jpg" alt />
            </el-form-item>
          </div>
          <!-- 特卖 -->
          <div class="special" v-show="isSpecial">
            <el-form-item label="截止日期:" style="width:50%">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="ETime"
                :editable="false"
                value-format="yyyy-MM-dd"
                style="width: 200px;"
                :picker-options="pickerOptions1"
              ></el-date-picker>
              <img src="../../assets/img/aicon10_03.jpg" alt />
            </el-form-item>
          </div>

          <!-- 团购 -->
          <!-- <div class="group" v-show="isGroup">
            <el-form-item label="市场价:" prop="name">
              <el-input v-model="tuanmarketprice" style="width:144px"></el-input>
              <i>元</i>
            </el-form-item>
            <el-form-item label="起团价:" prop="name">
              <el-input v-model="tuan" style="width:144px"></el-input>
              <i>元</i>
            </el-form-item>
            <el-form-item label="佣金比例:">
              <el-input v-model="tuanCostRate" style="width:144px"></el-input>
              <i>%</i>
            </el-form-item>
            <el-form-item label="团购定金:" prop="name">
              <el-input v-model="form.theme" style="width:144px"></el-input>
              <i>元</i>
            </el-form-item>
            <el-form-item label="起团人数:" prop="name">
              <el-input v-model="form.theme" style="width:144px"></el-input>
              <i>人</i>
            </el-form-item>
            <el-form-item label="最终团购价:" prop="name">
              <el-input v-model="tuanFinalPrice" style="width:144px"></el-input>
              <i>元</i>
            </el-form-item>
            <el-form-item label="团购人数:" prop="name">
              <el-input v-model="form.theme" style="width:144px"></el-input>
              <i>人</i>
            </el-form-item>
            <el-form-item label="团购截止日期:" style="width:50%">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="filters.date1"
                style="width: 200px;"
              ></el-date-picker>
              <img src="../../assets/img/aicon10_03.jpg" alt>
            </el-form-item>
          </div>-->
        </el-form>
        <div class="next_footer">
          <p @click="editSubmit" v-if="shownew">保 存</p>
          <p @click="bianSubmit" v-else>保存</p>
          <p @click="showAdd()" v-if="shownew">上一步</p>
          <p @click="editAdd()" v-else>上一步</p>
          <p @click="cancelmodel" style="background:#fff;color:#F56C6C;border:1px solid #F56C6C">取 消</p>
        </div>
      </div>
    </el-col>

    <!-- 查看 -->
    <el-col :span="24" class="add_goods_next main_container" v-show="ischaNext">
      <div class="model_section">
        <el-col :span="24" style>
          <p class="model_top_title">商品管理查看</p>
        </el-col>
      </div>
      <div class="table_container">
        <!-- <el-form
        :inline="true"
          ref="ruleForm"
          label-width="110px"
          class="demo-ruleForm">
        <el-form-item style="width:470px;margin-left:35px;"  label="是否使用优惠券：" prop="name">
         <template>
            <el-radio :disabled="true"  v-model="radio" label=0>否</el-radio>
            <el-radio :disabled="true" style="margin-left:230px" v-model="radio" label=1>是</el-radio>
        </template>
        </el-form-item>
        <el-form-item style="width:600px;" v-show="radio==1" label-width="50px"  label="每满">
            <el-input :disabled="true" v-model="money" style="width:150px;" placeholder="请输入金额"></el-input>
            <span style="color:#888;font-size:13px;">
             元，可使用100元优惠券
            </span>
        </el-form-item>
        </el-form>-->
        <el-form :model="form" label-width="100px" ref="editForm" class="next_form">
          <el-form-item label="销售类型:">
            <el-select
              v-model="options"
              placeholder="请选择"
              @change="changeOption(options)"
              :disabled="true"
              style="width:15%;">
              <el-option
                v-for="item in xiaoshouoptions"
                :key="item.Id"
                :value="item.Id"
                :label="item.Name"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 样品尾货 -->
          <div class="sample" v-show="isSample">
            <el-form-item label="市场价:" prop="name">
              <el-input
                @blur="changeblur()"
                onkeyup="value=value.replace(/[^\d\.]/g,'').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
                v-model="form.shichangprice"
                style="width:144px"
                :disabled="true"
              ></el-input>
              <i>元</i>
            </el-form-item>
            <el-form-item label="甄惠装价:">
              <el-input
                @blur="changeblur()"
                onkeyup="value=value.replace(/[^\d\.]/g,'').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
                v-model="form.tzprice"
                style="width:144px"
                :disabled="true"
              ></el-input>
              <i>元</i>
            </el-form-item>
            <el-form-item label="佣金比例:">
              <el-input maxlength="2"
                v-model="form.yongjin"
                style="width:144px"
                :disabled="true"
                onkeyup="this.value=this.value.replace(/\D/g,'')"/>
              <i>%</i>
            </el-form-item>
            <el-form-item label="库存:">
              <el-input
                onkeyup="value=value.replace(/[^\d\.]/g,'')"
                v-model="form.weistock"
                style="width:144px"
                :disabled="true"
              ></el-input>
              <i>个</i>
            </el-form-item>
          </div>
          <!-- 预售 -->
          <div class="advance" v-show="isAdvance">
            <el-form-item label="预售截止日期:" style="width:50%">
              <el-date-picker
                :editable="false"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                v-model="yuETime"
                style="width: 200px;"
                :picker-options="pickerOptions2"
                :disabled="true"
              ></el-date-picker>

              <img src="../../assets/img/aicon10_03.jpg" alt />
            </el-form-item>
            <el-form-item label="发货起始日期:" style="width:50%">
              <el-date-picker
                :editable="false"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                v-model="yuSTime"
                style="width: 200px;"
                :picker-options="pickerOptions3"
                :disabled="true"
              ></el-date-picker>

              <img src="../../assets/img/aicon10_03.jpg" alt />
            </el-form-item>
          </div>
          <!-- 特卖 -->
          <div class="special" v-show="isSpecial">
            <el-form-item label="截止日期:" style="width:50%">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="ETime"
                style="width: 200px;"
                :editable="false"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions1"
                :disabled="true"
              ></el-date-picker>
              <img src="../../assets/img/aicon10_03.jpg" alt />
            </el-form-item>
          </div>
          <!-- vip价 -->
          <div class="vip" v-show="isVip">
            <el-form-item label="VIP价:" prop="name">
              <el-input v-model="VipPrice" style="width:144px" :disabled="true"></el-input>
              <i>元 +</i>
              <el-input v-model="Score" style="width:144px" :disabled="true"></el-input>
              <i>积分,</i>
              <i>累计分享</i>
              <el-input v-model="SharingDays" style="width:144px" :disabled="true"></el-input>
              <i>天免积分</i>
            </el-form-item>
          </div>
          <!-- 团购 -->
          <!-- <div class="group" v-show="isGroup">
            <el-form-item label="市场价:" prop="name">
              <el-input v-model="tuanmarketprice" style="width:144px" :disabled="true"></el-input>
              <i>元</i>
            </el-form-item>
            <el-form-item label="起团价:" prop="name">
              <el-input v-model="tuan" style="width:144px" :disabled="true"></el-input>
              <i>元</i>
            </el-form-item>
            <el-form-item label="佣金比例:">
              <el-input v-model="tuanCostRate" style="width:144px" :disabled="true"></el-input>
              <i>%</i>
            </el-form-item>
            <el-form-item label="团购定金:" prop="name">
              <el-input v-model="form.theme" style="width:144px" :disabled="true"></el-input>
              <i>元</i>
            </el-form-item>
            <el-form-item label="起团人数:" prop="name">
              <el-input v-model="form.theme" style="width:144px" :disabled="true"></el-input>
              <i>人</i>
            </el-form-item>
            <el-form-item label="最终团购价:" prop="name">
              <el-input v-model="tuanFinalPrice" style="width:144px" :disabled="true"></el-input>
              <i>元</i>
            </el-form-item>
            <el-form-item label="团购人数:" prop="name">
              <el-input v-model="form.theme" style="width:144px" :disabled="true"></el-input>
              <i>人</i>
            </el-form-item>
            <el-form-item label="团购截止日期:" style="width:50%">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="filters.date1"
                style="width: 200px;"
                :disabled="true"
              ></el-date-picker>
              <img src="../../assets/img/aicon10_03.jpg" alt>
            </el-form-item>
          </div>-->
        </el-form>
        <div class="next_footer">
          <p @click="confirmView">确 定</p>

          <p
            @click="seecancelmodel"
            style="background:#fff;color:#F56C6C;border:1px solid #F56C6C"
          >取 消</p>
        </div>
      </div>
    </el-col>
    <!-- 查看下一步 -->
    <el-col :span="24" class="add_goods pad_left" v-show="ischaAdd">
      <div class="model_section">
        <el-col :span="24" style>
          <p class="model_top_title">商品管理查看</p>
        </el-col>
      </div>

      <div class="add_all">
        <!-- 商品基本信息 -->
        <div class="goods_msg">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>商品基本信息</p>
            </el-col>
          </div>
          <!-- 基本信息具体内容 -->
          <div class="msg_content content">
            <el-form style="display:flex;width:100%;">
              <el-form-item
                class="width100"
                label="品　　类:"
                style="width:42%;margin-left: 64px;display:flex"
                :rules="[{ required: true}]" prop>
                <el-select
                  filterable
                  v-model="newpinleiId"
                  placeholder="请选择"
                  :disabled="true"
                  @change="selectpinlei(newpinleiId)">
                  <el-option
                    v-for="item in newpinleioptions"
                    :key="item.Id"
                    :value="item.Id"
                    :label="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="width100"
                label="品　　牌:"
                style="width:42.5%;margin-left:35px;display:flex"
                :rules="[
      { required: true}
    ]"
                prop
              >
                <el-select :disabled="true" v-model="newpinpaiId" filterable placeholder="请选择">
                  <el-option
                    v-for="item in newpinpaioptions.agentBrandList"
                    :key="item.Id"
                    :value="item.Id"
                    :label="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-form style="display:flex;width:100%;">
              <el-form-item label="产品型号:" class="width100" style="width:42%;margin-left: 64px;display:flex"
                :rules="[{ required: true}]" prop>
                <el-input :disabled="true" v-model="GoodModelCode"></el-input>
              </el-form-item>
              <!-- <el-form-item label="所属省份:" class="width100 more100"  style="width:42%;margin-left:45px;display:flex"  prop="name">
                <i style="margin-right:5px">省</i>
                <el-input placeholder="请输入内容" v-model="newprovinceName" :disabled="true"></el-input>
                <i style="margin:0 5px">市</i>
                <el-input placeholder="请输入内容" v-model="newcityName" :disabled="true"></el-input>
              </el-form-item>-->
            </el-form>
            <el-form style="display:flex;width:100%;">
              <!-- <el-form-item label="合作类型:" class="width100 "  style="width:41.2%;margin-left: 73px;display:flex"  prop="name">
                   <el-input v-model="hezuotype" :disabled="true"></el-input>
                 </el-form-item>
                  <el-form-item label="合作周期:" class="width100 data100" style="width:42%;margin-left:45px;display:flex"  prop="name">
                      <el-date-picker
                       :disabled="true"
                          v-model="valuedata"
                            value-format="yyyy-MM-dd"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                      </el-date-picker>
              </el-form-item>-->
            </el-form>
            <!-- 查看dom -->
            <el-form class="changstyle">
              <el-form-item style="margin-left:26px;" label="详情页产品图片:" label-width="102px"
                :rules="[ { required: true} ]" prop>
                <div class="upPictures">
                <div class="block" v-for="(item,index) in detailImgUrlarr" :key="index" :data-img="item.ImgData"
                  @click.stop="$imgPreview">
                  <div style="float:left;margin-right:10px;margin-top:5px" class="tuimg">
                    <el-image style="width: 80px; height:80px" :src="item.ImgData"></el-image>
                    <!-- <div class="chahao">
                      <img src="../../assets/img/aicon36.png" alt />
                    </div> -->
                  </div>
                </div>

                <!-- 查看详情页产品图片 -->
                <el-upload action multiple v-show="false" list-type="picture-card" v-if="flag < 20"
                  :before-upload="beforeAvatarUpload">
                  <!-- :limit="5" :on-exceed="handleExceed" -->
                  <img v-if="form.ImgUrl" ref="big1" :src="form.ImgUrl" class="avatar" width="100%" />
                  <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                  <div class="el-upload__tip" style="margin-top:15px;" slot="tip">
                    <img src="../../assets/img/aicon15_09.jpg" alt style="margin-bottom:5px" />
                    建议分类竖图尺寸750px*750px以上且比例为1：1，商品详情图尺寸为支持jpg、png等格式
                  </div>
                </el-upload>
                </div>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </el-form>
            <el-form style="display:flex;width:100%;">
              <el-form-item
                label="标　　题:"
                class="width100"
                style="width:42%;margin-left: 64px;display:flex"
                :rules="[
      { required: true}
    ]"
                prop
              >
                <el-input
                  type="text"
                  v-model="Title"
                  :disabled="true"
                  maxlength="30"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item
                label="标　　语:"
                class="width100"
                style="width:42%;margin-left:45px;display:flex"
                prop="name"
              >
                <el-input
                  type="text"
                  v-model="Slogan"
                  :disabled="true"
                  maxlength="30"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-form>
            <el-form style="display:flex;width:100%;">
              <el-form-item
                label="产品库存:"
                class="width100"
                style="width:42%;margin-left: 64px;display:flex"
                :rules="[
      { required: true}
    ]"
                prop
              >
                <el-input
                  v-model="form.weistock"
                  :disabled="true"
                  onkeyup="value=value.replace(/[^\d\.]/g,'')"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="单　　位:"
                class="width100"
                style="width:42.5%;margin-left:35px;display:flex"
                :rules="[
      { required: true}
    ]"
                prop
              >
                <el-select :disabled="true" v-model="danweiId" placeholder="请选择">
                  <el-option
                    v-for="item in danwei"
                    :key="item.id"
                    :value="item.Id"
                    :label="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>

            <el-form style="display:flex;width:100%;">
              <el-form-item
                label="产品优势:"
                class="width100"
                style="width:41%;margin-left: 73px;display:flex"
                prop="name"
              >
                <el-input
                  type="textarea"
                  v-model="Advantage"
                  :disabled="true"
                  maxlength="60"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item
                label="备　　注:"
                class="width100"
                style="width:42%;margin-left:50px;display:flex"
                prop="name"
              >
                <el-input
                  type="textarea"
                  :disabled="true"
                  v-model="Remark"
                  maxlength="100"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-form>
            <el-form class="msg_form">
              <!-- <el-form-item label="产品型号:" label-width="105px" prop="name">
                <el-input v-model="GoodModelCode" style="width:200px" :disabled="true"></el-input>
              </el-form-item>-->
              <!-- <el-form-item label="品类:" label-width="105px" prop="name">
                <el-select
                  v-model="newpinleiId"
                  placeholder="请选择"
                  style="width:200px"
                  :disabled="true"
                  @change="selectpinlei(newpinleiId)"
                >
                  <el-option
                    v-for="item in newpinleioptions"
                    :key="item.Id"
                    :value="item.Id"
                    :label="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="品牌:" label-width="105px" prop="name">
                <el-select
                  v-model="newpinpaiId"
                  placeholder="请选择"
                  style="width:140px"
                  :disabled="true"
                >
                  <el-option
                    v-for="item in newpinpaioptions.agentBrandList"
                    :key="item.Id"
                    :value="item.Id"
                    :label="item.Name"
                  ></el-option>
                </el-select>
                <i>省</i>
                <el-select
                  v-model="newprovinceId"
                  placeholder="请选择"
                  style="width:140px"
                  :disabled="true"
                  @change="selectoptions(newprovinceId)"
                >
                  <el-option
                    v-for="item in newprovince"
                    :key="item.id"
                    :value="item.Id"
                    :label="item.Name"
                  ></el-option>
                </el-select>
                <i>市</i>
                <el-select
                  v-model="newcityId"
                  placeholder="请选择"
                  style="width:200px"
                  :disabled="true"
                  @change="seleccity(newcityId)"
                >
                  <el-option
                    v-for="item in newcity"
                    :key="item.id"
                    :value="item.Id"
                    :label="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>-->
              <!-- 合作类型 -->
              <!-- <div class="cooperation_type"> -->
              <!-- <el-form-item label="合作类型:" prop="name" label-width="105px"> -->
              <!-- <el-select v-model="hezuoId" placeholder="请选择" style="width:200px">
                    <el-option
                      v-for="item in hezuotype"
                      :key="item.id"
                      :value="item.Id"
                      :label="item.Name"
                    ></el-option>
              </el-select>-->
              <!-- <el-input v-model="hezuotype" style="width:200px" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item
                  label="合作开始时间:"
                  label-width="115px"
                  prop="name"
                  style="width:370px"
                  v-show="showtime"
                >
                  <el-date-picker
                    type="date"
                    :editable="false"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    v-model="filters.date1"
                    style="width: 200px"
                    :disabled="true"
                  ></el-date-picker>
                  <img src="../../assets/img/aicon10_03.jpg" alt />
                </el-form-item>
                <el-form-item
                  label="合作截止时间:"
                  prop="name"
                  label-width="100px"
                  style="width:400px"
                  v-show="showtime"
                >
                  <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    :editable="false"
                    value-format="yyyy-MM-dd"
                    v-model="filters.date1"
                    style="width: 200px"
                    :disabled="true"
                  ></el-date-picker>
                  <img src="../../assets/img/aicon10_03.jpg" alt />
                </el-form-item>
              </div>-->
              <!-- <el-form-item label="首页产品图片:" label-width="102px">
                <div v-for="(item,index) in indexImgUrlarr" :key="index" :data-img="item.ImgData"
                  @click.stop="$imgPreview">
                  <div style="float:left;margin-right:20px" class="tuimg">
              <el-image style="width: 80px; height:80px" :src="item.ImgData"></el-image>-->
              <!-- <div class="chahao" @click="delshou(index)">&times;</div> -->
              <!-- </div>
              </div>-->

              <!-- <el-upload
                  action
                   
                  list-type="picture-card"
                  :on-change="handleshouedetail"
                
                >
                  <img v-if="form.ImgUrl" :src="form.ImgUrl" class="avatar" width="100%">
                  <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                  <div class="el-upload__tip" slot="tip">
                    <img src="../../assets/img/aicon15_09.jpg" alt style="margin-bottom:5px">
                    首页横图尺寸为585px*245px，分类竖图尺寸275px*350px，商品详情图尺寸为支持jpg、png等格式
                  </div>
              </el-upload>-->
              <!-- <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>-->

              <!-- <el-form-item label="详情页产品图片:" label-width="102px">
                <div v-for="(item,index) in detailImgUrlarr" :key="index" :data-img="item.ImgData"
                  @click.stop="$imgPreview">
                  <div style="float:left;margin-right:20px" class="tuimg">
                    <el-image style="width: 80px; height:80px" :src="item.ImgData"></el-image>
                  </div>
                </div>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
              <el-form-item label="标题:" label-width="105px">
                <el-input
                  type="text"
                  v-model="Title"
                  style="width:450px"
                  maxlength="30"
                  show-word-limit
                  :disabled="true"
                ></el-input>
              </el-form-item>
              <el-form-item label="标语:" label-width="105px">
                <el-input
                  type="text"
                  v-model="Slogan"
                  style="width:450px"
                  maxlength="30"
                  show-word-limit
                  :disabled="true"
                ></el-input>
              </el-form-item>
              <el-form-item label="产品优势:" label-width="105px">
                <el-input
                  type="text"
                  v-model="Advantage"
                  style="width:1000px"
                  maxlength="60"
                  show-word-limit
                  :disabled="true"
                ></el-input>
              </el-form-item>-->
              <el-form-item
                label="颜色:"
                class="color_msg"
                style="margin-left:21px"
                :rules="[
      { required: true}
    ]"
                prop
                label-width="105px"
              >
                <div class="table_color_box" style="width:76.5%">
                  <div
                    class="item"
                    style="width: 100%;display: flex;justify-content: space-around;"
                  >
                    <div :style="screenWidth>=1918?'margin-left:144px':''" class="color">名称</div>
                    <div :style="screenWidth>=1918?'margin-left:144px':''" class="img_vox">图片</div>
                    <div :style="screenWidth>=1918?'margin-left:144px':''" class="action_del">操作</div>
                  </div>
                  <div
                    class="item"
                    style="    display: flex;justify-content: space-around;"
                    v-for="(item,index) in colorList"
                    :key="index"
                  >
                    <div class="color">
                      <el-input
                       :style="screenWidth>=1918?'width:456px':'width:250px'"
                        v-model="colorList[index].ImgName"
                        :disabled="true"
                      ></el-input>
                    </div>
                    <div class="img_vox" @click="imgchaun(index)">
                      <el-upload
                      :style="screenWidth>=1918?'margin-left:284px':''"
                        action
                        list-type="picture-card"
                        :index="index"
                        class="table_pic"
                        :disabled="true"
                      >
                        <img
                          v-if="colorList[index].ImgData"
                          :src="BaseUrl+colorList[index].ImgData"
                          class="avatar"
                          width="100%"
                        />
                        <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                      </el-upload>
                    </div>
                    <div :style="screenWidth>=1918?'margin-left:405px':''" class="action_del">
                      <span>删除</span>
                    </div>
                  </div>
                </div>

                <!-- <div class="color_btn" @click="addColor">新增</div> -->
              </el-form-item>

              <el-form-item
                class="width100"
                style="margin-left:21px;width:36.5%"
                label="物流方式:"
                prop="name"
                label-width="105px"
              >
                <el-select v-model="wuliuId" placeholder="请选择" :disabled="true">
                  <el-option
                    v-for="item in wuliu"
                    :key="item.id"
                    :value="item.Id"
                    :label="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="width100"
                style="margin-left:21px;width:36.5%"
                label="运费说明:"
                label-width="105px"
              >
                <el-input
                  type="text"
                  v-model="FreightDesc"
                  maxlength="30"
                  show-word-limit
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 商品详情 / 参数 -->
        <div class="goods_parameter">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>商品详情 / 参数</p>
            </el-col>
          </div>
          <!-- 商品详情具体内容 -->
          <div class="parameter_content content">
            <el-form class="parameter_form">
              <!-- 左侧 -->
              <div class="parameter_form_l" v-for="(item,index) in quyuarr" :key="index">
                <el-form-item
                  :label="item.Name"
                  prop="name"
                  label-width="105px"
                  v-show="item.ControlTypeId==1"
                >
                  <el-input maxlength="50"
                    v-model="GoodsParams[index].DataValue"
                    style="width:360px"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="item.Name" label-width="105px" v-show="item.ControlTypeId==3">
                  <div class="whether">
                    <div>
                      <i>
                        <img
                          :src="item.sel?src2:src1"
                          alt
                          :bangding="index"
                          :selId="quyuarr[index]"
                        />
                      </i>
                      是
                    </div>
                    <div>
                      <i>
                        <img
                          :src="item.sel?src1:src2"
                          :bangding="index"
                          :selId="quyuarr[index]"
                          alt
                        />
                      </i>
                      否
                    </div>
                  </div>
                </el-form-item>

                <el-form-item :label="item.Name" label-width="105px" v-show="item.ControlTypeId==2">
                  <el-select
                    v-model="GoodsParams[index].DataValue"
                    placeholder="请选择"
                    style="background:#fff"
                    :disabled="true"
                  >
                    <el-option
                      :label="item.Name"
                      :value="item.Id"
                      v-for="(item,index) in item.BaseDatas"
                      :key="index"
                    ></el-option>
                    <!-- <el-option label="小程序" value="beijing"></el-option> -->
                  </el-select>
                </el-form-item>
              </div>
              <!-- 右侧 -->
              <!-- <div class="parameter_form_r">
                <el-form-item label="价格:" prop="name" label-width="105px">
                  <el-input v-model="form.theme" style="width:144px"></el-input>
                  <i style="color:#888;font-size:12px;margin-left:10px">元</i>
                </el-form-item>
                <el-form-item label="风格:" prop="name" label-width="105px">
                  <el-input v-model="form.theme" style="width:360px"></el-input>
                </el-form-item>
                <el-form-item label="尺寸:" prop="name" label-width="105px">
                  <el-input v-model="form.theme" style="width:360px"></el-input>
                </el-form-item>
                <el-form-item label="饰面材质:" label-width="105px">
                  <el-input type="text" v-model="text" style="width:360px"></el-input>
                </el-form-item>
                <el-form-item label="是否带转盘:" label-width="105px">
                  <div class="whether">
                    <div>
                      <i>
                        <img :src="isOk?src1:src2" alt @click="changeImg()">
                      </i>
                      是
                    </div>
                    <div>
                      <i>
                        <img :src="isOk?src2:src1" alt @click="changeImg()">
                      </i>
                      否
                    </div>
                  </div>
                </el-form-item>
              </div>-->
            </el-form>
          </div>
        </div>
        <div class="goods_shop">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>
                商品详情/其他参数
                <span
                  style="color:#bfbfbf;font-size:12px;margin-left:20px;"
                >添加更多商品参数，若无可不填写</span>
              </p>
            </el-col>
          </div>
          <!-- 其他参数 内容 -->
          <div class="shop_content">
            <el-form>
              <el-form-item label="其他参数:">
                <div class="table_color_box">
                  <div class="item">
                    <div style="width:90px;text-align:90px; padding: 10px 15px;">序号</div>
                    <div style="color:#888;width: 340px; padding: 10px 15px;">参数名称</div>
                    <div class="img_vox">值</div>
                    <div class="action_del">操作</div>
                  </div>
                  <div class="item" v-for="(item,index) in othertable" :key="index">
                    <div style="width:90px;text-align:90px; padding: 10px 15px;">{{index+1}}</div>
                    <div class="color">
                      <el-input
                        style="width:300px"
                        :disabled="true"
                        v-model="othertable[index].PName"
                      ></el-input>
                    </div>
                    <div class="img_vox">
                      <el-input
                        style="width:300px"
                        :disabled="true"
                        v-model="othertable[index].PValue"
                      ></el-input>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 产品优势 -->
        <div class="goods_advantage">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>产品优势</p>
            </el-col>
          </div>
          <!-- 优势的图片 -->
          <div class="advantage_pic">
            <el-form>
              <el-form-item label="图片:" label-width="80px">
                <div v-for="(item,index) in youImgUrlarr" :key="index" :data-img="item.ImgData"
                  @click.stop="$imgPreview">
                  <div style="float:left;margin-right:20px" class="tuimg">
                    <el-image style="width: 80px; height:80px" :src="item.ImgData"></el-image>
                    <!-- <div class="chahao" @click="delyoushi(index)">&times;</div> -->
                  </div>
                </div>

                <!-- <el-upload
                  action
                   
                  list-type="picture-card"
                  :on-change="handleproductyou"
                >
                  <img v-if="form.ImgUrl" :src="form.ImgUrl" class="avatar" width="100%">
                  <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                  <div class="el-upload__tip" slot="tip">
                    <img src="../../assets/img/aicon15_09.jpg" alt style="margin-bottom:5px">
                    PC宽度为0~1200px，小程序宽度为700px，支持jpg、png等格式
                  </div>
                </el-upload>-->
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 应用效果 -->
        <div class="goods_advantage" v-show="advantage">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>应用效果</p>
            </el-col>
          </div>
          <!-- 应用效果 图片 -->
          <div class="advantage_pic">
            <el-form>
              <el-form-item label="图片:">
                <div v-for="(item,index) in xiaoguoImgUrlarr" :key="index" :data-img="item.ImgData"
                  @click.stop="$imgPreview">
                  <div style="float:left;margin-right:20px" class="tuimg">
                    <el-image style="width: 80px; height:80px" :src="item.ImgData"></el-image>
                    <!-- <div class="chahao" @click="delxiaoguo(index)">&times;</div> -->
                  </div>
                </div>

                <!-- <el-upload action   list-type="picture-card" :on-change="handlexiaoguo">
                  <img v-if="form.ImgUrl" :src="form.ImgUrl" class="avatar" width="100%">
                  <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                  <div class="el-upload__tip xijie" slot="tip">
                    <img src="../../assets/img/aicon15_09.jpg" alt style="margin-bottom:5px">
                    PC宽度为0~1200px，小程序宽度为700px，支持jpg、png等格式
                  </div>
                </el-upload>-->
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 产品细节 -->
        <div class="goods_advantage" v-show="advantage">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>产品细节</p>
            </el-col>
          </div>
          <!-- 产品细节 图片 -->
          <div class="advantage_pic">
            <el-form>
              <el-form-item label="图片:">
                <div v-for="(item,index) in xijieImgUrlarr" :key="index" :data-img="item.ImgData"
                  @click.stop="$imgPreview">
                  <div style="float:left;margin-right:20px" class="tuimg">
                    <el-image style="width: 80px; height:80px" :src="item.ImgData"></el-image>
                    <!-- <div class="chahao" @click="delxijieimg(index)">&times;</div> -->
                  </div>
                </div>

                <!-- <el-upload action   list-type="picture-card" :on-change="handlexijie">
                  <img v-if="form.ImgUrl" :src="form.ImgUrl" class="avatar" width="100%">
                  <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                  <div class="el-upload__tip xijie" slot="tip">
                    <img src="../../assets/img/aicon15_09.jpg" alt style="margin-bottom:5px">
                    PC宽度为0~1200px，小程序宽度为700px，支持jpg、png等格式
                  </div>
                </el-upload>-->
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 在售店面 -->
        <div class="goods_shop">
          <!-- <div class="msg_title">
            <el-col :span="24" style>
              <p>在售店面</p>
            </el-col>
          </div>-->
          <!-- 在售店面 内容 -->
          <!-- <div class="shop_content">
            <el-form>
              <el-form-item label="在售店面:">
                <div class="table_color_box">
                  <div class="item">
                    <div class="color">店面名称</div>
                    <div class="img_vox">店面地址</div>
                  </div>
                  <div class="item" v-for="(item,index) in shoplist" :key="index">
                    <div class="color">
                      <el-input style="width:300px" v-model="shoplist[index].Name" :disabled="true"></el-input>
                    </div>
                    <div class="img_vox">
                      <el-input
                        style="width:300px"
                        v-model="shoplist[index].Address"
                        :disabled="true"
                      ></el-input>
                    </div>
                  </div>
          </div>-->
          <!-- <div class="shop_btn" @click="addshop">返回</div> -->
          <!-- </el-form-item>
            </el-form>
          </div>-->
        </div>
        <!-- 售后政策 -->
        <div class="goods_policy">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>售后政策</p>
            </el-col>
          </div>
          <!-- 售后政策 内容 -->
          <div class="policy_content">
            <el-form>
              <el-form-item label="售后政策:">
                <el-input
                  type="textarea"
                  :rows="5"
                  style="width:1000px"
                  v-model="AfterPolicy"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 注意事项 -->
        <div class="goods_policy">
          <div class="msg_title">
            <el-col :span="24" style>
              <p>注意事项</p>
            </el-col>
          </div>
          <!-- 注意事项 内容 -->
          <div class="policy_content">
            <el-form>
              <el-form-item label="注意事项:">
                <el-input
                  type="textarea"
                  :rows="5"
                  style="width:1000px"
                  v-model="NeedAttention"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="goods_footer">
          <p @click="chashowAdd()">下一步</p>
        </div>
      </div>
    </el-col>
    <!-- 跟进记录 -->
    <div class="uploadtop">
      <el-dialog title="商品评价"
        :visible.sync="dialogVisibledelete"
        :before-close="handleClosezhun"
        :close-on-click-modal="false" center width="60%">
        <span>
          <template>
            <el-table :data="commentarr" stripe border style>
              <el-table-column prop="UserName" label="评论人姓名" width="200px" align="center">
                <template scope="scope">
                  <span
                    :title="scope.row.UserName"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.UserName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="UserFace" label="评论人头像" width="200px" align="center">
                <template scope="scope">
                  <img style="width:44px;height:44px" :src="scope.row.UserFace" />
                </template>
              </el-table-column>
              <el-table-column prop="ColorName" align="center" width="120px" label="	评价商品颜色名称">
                <template scope="scope">
                  <span
                    :title="scope.row.ColorName"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.ColorName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="RContent" width="200px" align="center" label="评论内容">
                <template scope="scope">
                  <span
                    :title="scope.row.RContent"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.RContent}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="GoodSatisfaction" align="center" width label="	商品评分">
                <template scope="scope">
                  <span
                    :title="scope.row.GoodSatisfaction"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.GoodSatisfaction}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="BusinessSatisfaction" align="center" width label="	商家评分">
                <template scope="scope">
                  <span
                    :title="scope.row.BusinessSatisfaction"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.BusinessSatisfaction}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="CTime" align="center" width label="	评价时间">
                <template scope="scope">
                  <span
                    :title="scope.row.CTime"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.CTime}}</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <div style="overflow:hidden">
            <el-pagination
              layout="prev, pager, next"
              @current-change="handleCurrentChange1"
              :page-size="5"
              :current-page="pageIndex1"
              :total="total1"
              style="float:right;margin-top:15px"
            ></el-pagination>
          </div>
          <div style="height:1px;background:#eee;margin-top:15px"></div>
          <div style="margin-top:10px" class="region1">评论设置</div>
          <!-- <el-input
          type="textarea"
          style="margin-top:30px;"
          v-model="remark"
          placeholder="请输入跟进记录（200字以内）"
          :autosize="{ minRows: 2, maxRows: 6}"
          maxlength="200"
          show-word-limit
          ></el-input>-->
          <el-form class="elformbottom" style="margin-top:10px">
            <el-form-item class="elform123" style="display:flex" label="商品颜色：">
              <el-select style="width:100%" v-model="colorId">
                <el-option
                  v-for="item in colorarr"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="elform123" style="display:flex" label="用户头像：">
              <el-upload
                class="avatar-uploader1"
                action
                accept=".png, .jpg, .jpeg"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUploadtouxiang"
              >
                <img
                  v-if="LogoUrl1"
                  style="border-radius: 50%;width:100px;height:100px"
                  :src="LogoUrl1"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon1"></i>
              </el-upload>
            </el-form-item>
            <p style="color:#888;margin-top:0px;margin-left:81px;">建议尺寸：132*132，支持的图片格式：jpg、png。</p>
            <el-form-item style="display:flex" label="用户名称：">
              <el-input maxlength="30" v-model="UserName" placeholder="请输入用户名称"></el-input>
            </el-form-item>
            <el-form-item style="display:flex" label="评价内容：">
              <el-input
                v-model="RContent"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 6}"
                maxlength="500"
                style="min-height:88px !important"
                placeholder="请输入评价内容"
              ></el-input>
            </el-form-item>
            <el-form-item style="display:flex" label="商品服务：">
              <el-rate :colors="colorred" v-model="value1"></el-rate>
            </el-form-item>
            <el-form-item style="display:flex" label="商家服务：">
              <el-rate :colors="colorred" v-model="value2"></el-rate>
            </el-form-item>
            <el-form-item style="display:flex" label="评论时间：">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="valuetime"
                type="datetime"
                :editable="false"
                placeholder="选择日期时间"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </span>
        <span slot="footer" style="text-align:center" class="dialog-footer">
          <div style="text-align:center">
            <el-button type="danger" @click="followUp()">保 存</el-button>
          </div>
        </span>
      </el-dialog>
    </div>
    <!-- PC电商推荐-弹框 -->
    <el-dialog title="PC电商推荐" :visible.sync="isToProductRecommendation" class="add_order_cancle" width="30%">
      <el-form>
        <el-form-item label="商品推荐:" style="width:100%" label-width="80px">
          <el-checkbox v-model="sameBrand">同品牌商品推荐</el-checkbox>
          <el-checkbox v-model="sameCategory">同品类商品推荐</el-checkbox>
        </el-form-item>
      </el-form>
      <!-- 弹框按钮 确定/取消 -->
      <div style="padding-left:0;text-align:center">
        <button type="button" @click="isToProductRecommendation = false"
          class="el-button el-button--default cancle normal_btn">取消</button>
        <button type="button" @click="editRecomSubmit()"
          class="el-button el-button--default search_btn normal_btn">保存</button>
      </div>
    </el-dialog>
  </div>
</template>

<!--分页-->
<script>
import util from "../../common/util";
import NProgress from "nprogress";
import {
  getUserListPage,
  removeUser,
  editUser,
  addUser,
  hometui
} from "../../api/api";

function getBase64Image(img) {
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, img.width, img.height);
  var dataURL = canvas.toDataURL("image/png"); // 可选其他值 image/jpeg
  return dataURL;
}

function main(src, cb) {
  var image = new Image();
  image.src = src + "?v=" + Math.random(); // 处理缓存
  image.crossOrigin = "*"; // 支持跨域图片
  image.onload = function() {
    var base64 = getBase64Image(image);
    cb && cb(base64);
  };
}
import { uploadOSS } from '../../utils/oss';
import {getOssFile, postAddFile,getRecommendInfo, postSetRecommend, SelectBrandTypeBaseDataByCondition} from '../../api/newOss';
import { getkind, goodslist, getquyu, gethezuo, SelectBBListByCondition, SelectGoodsBrandByBrandType,
  changegood, chagoodinfo, byIdfindinfo1, SelectGoodsStockFlowByGoodsId, UpoadImg,
  UpdateGoodsSalesCount, SelectTempGoodsColor, SelectTempGoodsComments, InsertTempGoodsReview,
  BatchUpdateGoods, BatchUpdateGoodsStocks, BatchUpdateGoodsPrice, UploadImgForDB, BatchUpdateImgSortNumber,
  BatchUpdateGoodsIsUseCoupon, BatchUpdateGoodsIsApplyVIPDiscount } from "../../api/api";
import draggable from 'vuedraggable';

export default {
  name: "goods",
  data() {
    return {
      addbrand:[],
      BaseUrl:"",
      newUserType: "", // 超级管理员?
      youImgUrlarr1:[],
      detailImgUrlarr1:[],
      fileName: "",
      imgarrCutting: "",
      imgarrCuttingOne: "",
      imgarrCuttingTwo: "",
      jianceImgUrlarr1:[],
      tdwidth: document.body.clientWidth,
      shopgoodsId: [],
      commentarr: [],
      RContent: "",
      goodId: "",
      valuetime: "",
      value1: "",
      value2: "",
      LogoUrl1: "",
      colorred: ["#F56C6C", "#F56C6C", "#F56C6C"],
      LogoUrl: "",
      colorId: "",
      UserName: "",
      colorarr: [],
      remark: "",
      total1: 0,
      pageIndex1: 1,
      followList: [],
      dialogVisibledelete: false,
      timer: false,
      styleId1: "178",
      screenWidth: document.body.clientWidth,
      iseditable: false,
      value6: "",
      valuedata: [],
      show3: false,
      addothers: true,
      othertable: [],
      advantage: false,
      dialogTableVisibletable: false,
      gridData: [],
      kucunId: "",
      showmoney: false,
      money: 0,
      // loading3:false,
      loading2: false,
      radio: "1",
      bignum: 3,
      img: "",
      isSize: false,
      ischaNext: false,
      ischaAdd: false,
      shownew: true,
      // 是/否按钮
      isOk: true,
      src1: require("../../assets/img/bicon64_03.jpg"),
      src2: require("../../assets/img/bicon64_05.jpg"),
      // 输入框字数
      text: "",
      // 图片
      dialogImageUrl: "",
      dialogVisible: false,
      // 输入框
      isSample: false,
      isAdvance: false,
      isSpecial: false,
      isVip: false,
      isGroup: false,
      // 销售类型
      saleOption: [
        { id: 1, name: "样品、尾货" },
        { id: 2, name: "预售" },
        { id: 3, name: "团购" },
        { id: 4, name: "特卖" },
        { id: 5, name: "VIP商品" }
      ],
      filters: {
        name: "",
        options: "",
        option1: "",
        option2: "",
        pinpaishang: '',
        date1: "",
        date2: "",
        brandId: 0,
        brandTypeId: 0,
        xuanstatusId: -1,
        goodsActiveId: 0
      },
      users: [],
      colorList: [],
      total: 1,
      page: 1,
      options: "",
      option1: "",
      option2: "",
      option3: "",
      option4: "",
      option5: "",
      option6: "",
      form: {
        id: 0,
        theme: "",
        link: "",
        option2: "",
        shichangprice: "",
        tzprice: "",
        yongjin: 8,
        weistock: ""
      },
      // goods是否显示
      isGoods: true,
      // 新增 下一步页面
      isNext: false,
      //  新增页面
      isAdd: false,
      //品牌
      brandoptions: "",
      //品类
      pinleiptions: "",
      //商品状态
      statusptions: "",
      pageIndex: 1,
      pageSize: 10,
      isExpire: false,
      //销售类型
      xiaoshouoptions: "",
      xiaoshouoptions1: [],
      //新增商品品类
      newpinleioptions: "",
      newpinleiId: 0,
      //新增商品品牌
      newpinpaioptions: "",
      newpinpaiId: "",
      //省份
      newprovince: "",
      newprovinceId: "",
      newprovinceName: "",
      newcity: "",
      newcityId: "",
      newcityName: "",
      quyuarr: [],
        firstDetail: [],
      indexImgUrlarr: [],
      // 详情页图片
      detailImgUrlarr: [],
      // 详情页图片id
      detailImgIdarr: [],
      // 产品优势
      youImgUrlarr: [],
      // 产品优势图片id
      youImgIdarr: [],
      //效果图
      xiaoguoImgUrlarr: [],
      xijieImgUrlarr: [],
      // 产品检测
      jianceImgUrlarr: [],
      // 产品检测图片id
      jianceImgIdarr: [],
      //合作类型
      hezuotype: "",
      showtime: true,
      //获取销售单位
      danwei: "",
      danweiId: "",
      //获取物流
      wuliu: [],
      wuliuId: 0,
      //商品信息
      goodsinfo: {},
      colorname: "",
      GoodsParams: [],
      colorimg: "",
      colorindex: "",
      shoplist: [],
      Remark: "",
      FreightDesc: "",
      NeedAttention: "",
      AfterPolicy: "",
      show: "",
      Title: "",
      Slogan: "",
      Advantage: "",
      ETime: "",
      GoodModelCode: "",
      BbId: localStorage.BbId,
      yuETime: "",
      yuSTime: "",
      VipPrice: "",
      Score: "",
      SharingDays: "",
      swalhtml: "123",
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      pickerOptions3: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      pickerOptions4: {
        disabledDate: time => {
          let beginDateVal = this.filters.date1;

          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
            );
          }
        }
      },
      goodsinfo: [],
      editgoodsid: "",
      editgoodsimgs: [],
      actid: "",
      newgoodparams: "",
      coperdate1: "",
      coperdate2: "",
      options3: [],
      cbId: "",
      bcid: "",
      brandTypearr: [],
      brandarr: [],
      goodIdarr: [],
      TzrPrice1:"",
      MarketPrice1:"",
      scokt1:"",
      isToProductRecommendation: false,
      sameBrand: true,
      sameCategory: false,
      flag: 0,
      flag2: 0,
      flag3: 0
    };
  },
  props: ["menuAction"],
  components: {
    draggable
  },
  methods: {
    // 商品推荐
    endRecom() {
      if (this.goodIdarr.length == 0) {
        this.$swal({
          text: "请选择需要操作的商品",
          type: "warning"
        });
        return false;
      }
      // 判断选中的是单条还是多条
      if (this.goodIdarr.length == 1) {
        var addParams = {
          goodsId: this.goodIdarr[0]
        };
        getRecommendInfo(addParams).then(data => {
          if (data.resultCode == 1) {
            this.sameBrand = data.resultObj.isRecommendBrand
            this.sameCategory = data.resultObj.isRecommendBrandType
          } else {
            this.$swal({
              text: data.resultMsg,
              type: "warning"
            })
          }
        })
      } else {
        this.sameBrand = false;
        this.sameCategory = true;
      }
      this.isToProductRecommendation = true;
    },
    // 保存商品推荐按钮
    editRecomSubmit() {
      if(this.sameBrand == false && this.sameCategory == false){
        this.$swal({
          type:'warning',
          text: '请至少选中一项',
        })
        return false;
      }
      var loginParams = {
        goodsIds: this.goodIdarr,
        isRecommendBrand: this.sameBrand, // 同品牌商品推荐
        isRecommendBrandType: this.sameCategory // 同品类商品推荐
      };
      postSetRecommend(loginParams).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            text: data.resultMsg,
            type: "success"
          })
        } else {
          this.$swal({
            text: data.resultMsg,
            type: "warning"
          })
        }
        this.isToProductRecommendation = false;
      })
    },
    // 可用优惠券
    congin(num){
      var that = this
      if (this.goodIdarr.length == 0) {
        this.$swal({
          text: "请选择需要操作的商品",
          type: "warning"
        });
        return false;
      }
     this.$swal(
        {
          title: "   ",
          text:num == 1?"您是否确认需要将选择的商品设置为可用优惠券状态吗？":"您是否确认需要将选择的商品设置为可享受会员折扣吗？",
          // html: true,
          type: "warning",
          allowOutsideClick:true,
          allowEscapeKey:true,
          customClass: "disinput",
           reverseButtons:true,
          confirmButtonText: num == 1?"设置优惠券可用":"设置享受会员折扣",
          showCancelButton: true,
          cancelButtonText: num == 1?"取消优惠券可用":"取消享受会员折扣"
        }).then(val=>{
           if(val.value){
             if(num == 1){
                var obj = {
               goodsIds:that.goodIdarr.join(","),
               operId:localStorage.Id,
               isUseCoupon:1
             }
             BatchUpdateGoodsIsUseCoupon(obj).then(data=>{
               if(data.ResultCode == 1){
                 that.getgoodlist();
                 that.$swal({
                   type : "success",
                   html:data.ResultMsg
                 })
               }
             })
             }else{
                            var obj = {
               goodsIds:that.goodIdarr.join(","),
                operId:localStorage.Id,
                isVIPApplyDiscount:1
             }
             BatchUpdateGoodsIsApplyVIPDiscount(obj).then(data=>{
               if(data.ResultCode == 1){
                 that.getgoodlist();
                 that.$swal({
                   type : "success",
                   html:data.ResultMsg
                 })
               }
             })
             }
           }else if(val.dismiss == "cancel"){
                if(num == 1){
                var obj = {
               goodsIds:that.goodIdarr.join(","),
               operId:localStorage.Id,
               isUseCoupon:0
             }
             BatchUpdateGoodsIsUseCoupon(obj).then(data=>{
               if(data.ResultCode == 1){
                 that.getgoodlist();
                 that.$swal({
                   type : "success",
                   html:data.ResultMsg
                 })
               }
             })
             }else{
                            var obj = {
               goodsIds:that.goodIdarr.join(","),
                operId:localStorage.Id,
                isVIPApplyDiscount:0
             }
             BatchUpdateGoodsIsApplyVIPDiscount(obj).then(data=>{
               if(data.ResultCode == 1){
                 that.getgoodlist();
                 that.$swal({
                   type : "success",
                   html:data.ResultMsg
                 })
               }
             })
             }
           }
        })
    },
//     function(val){
//            if(num == 1){
//              var obj = {
//                goodsIds:that.goodIdarr.join(","),
//                operId:localStorage.Id,
//                isUseCoupon:val?1:0
//              }
//              BatchUpdateGoodsIsUseCoupon(obj).then(data=>{
//                if(data.ResultCode == 1){
//                  that.getgoodlist();
//                  that.$swal({
//                    type : "success",
//                    text:data.ResultMsg
//                  })
//                }
//              })
//            }else{
//              var obj = {
//                goodsIds:that.goodIdarr.join(","),
//                 operId:localStorage.Id,
//                 isVIPApplyDiscount:val?1:0
//              }
//              BatchUpdateGoodsIsApplyVIPDiscount(obj).then(data=>{
//                if(data.ResultCode == 1){
//                  that.getgoodlist();
//                  that.$swal({
//                    type : "success",
//                    text:data.ResultMsg
//                  })
//                }
//              })
//            }
//         }
    scokt() {
      if (this.goodIdarr.length == 0) {
        this.$swal({
          text: "请选择需要操作的商品",
          type: "warning"
        });
        return false;
      }
      this.$swal({
        title: "设置商品库存",
        text: "在下方输入框内输入当前商品库存",
        input: "text",
        inputPlaceholder: "请输入当前商品库存",
        inputValue:  this.scokt1,
        showCancelButton: true,
        reverseButtons:true,
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(inputVal => {
        if (!inputVal.value && inputVal.value != "") {
          return false;
        }

        if (!this.makeNumber(inputVal.value)) {
          this.$swal({
            type: "warning",
            text: "请输入正确的库存，并且要是(1~99999999)正整数"
          });
        } else if (inputVal.value == "") {
          this.$swal({
            type: "warning",
            text: "请输入正确的库存，并且要是(1~99999999)正整数"
          });
        } else if (inputVal.value > 99999999) {
          this.$swal({
            type: "warning",
          text: "请输入正确的库存，并且要是(1~99999999)正整数"
          });
        }else if (inputVal.value < 1) {
          this.$swal({
            type: "warning",
          text: "请输入正确的库存，并且要是(1~99999999)正整数"
          });
        } else {
          var obj = {
            goodsIds: this.goodIdarr.join(","),
            operId: localStorage.Id,
            stock: inputVal.value
          };
          BatchUpdateGoodsStocks(obj).then(data => {
            if (data.ResultCode == 1) {
              this.getgoodlist();
              this.$swal({
                type: "success",
                html: data.ResultMsg
              });
            }
          });
        }
      });
    },
    //批量操作
    BatchGoods(val) {
      if (this.goodIdarr.length == 0) {
        this.$swal({
          type: "warning",
          text: "请选择需要操作的商品"
        });
        return false;
      }
      var obj = {
        goodsIds: this.goodIdarr.join(","),
        operId: localStorage.Id,
        operType: val
      };
      BatchUpdateGoods(obj).then(data => {
        if (data.ResultCode == 1) {
          this.$swal({
            type: "success",
            html: data.ResultMsg
          });
          this.getgoodlist();
        }
      });
    },
    //点击复选框
    handleSelectionChange(val) {
      if(val.length == 1){
        this.TzrPrice1 = val[0].TzrPrice
        this.MarketPrice1 = val[0].MarketPrice
        this.scokt1 = val[0].Stock
      }else{
         this.TzrPrice1 = ''
        this.MarketPrice1 = ''
        this.scokt1 = ''
      }
      this.goodIdarr = [];
      val.forEach(element => {
        this.goodIdarr.push(element.Id);
      });
    },
      //获取品牌
    getbrandarr1() {  
      this.getquyu();
        var obj = {
          userId: localStorage.Id,
          brandTypeId: this.newpinleiId == ""?0: this.newpinleiId
        };
        SelectGoodsBrandByBrandType(obj).then(data => {
          if (data.ResultCode == 1) {
            this.addbrand = data.ResultObj;
            this.addbrand.unshift({
              Id: 0,
              Name: "全部"
            });
          }
        });
      
    },
    //获取品牌
    getbrandarr() {
      this.filters.brandId = 0
        var obj = {
          userId: localStorage.Id,
          brandTypeId: this.filters.brandTypeId
        };
        SelectGoodsBrandByBrandType(obj).then(data => {
          if (data.ResultCode == 1) {
            this.brandarr = data.ResultObj;
            this.brandarr.unshift({
              Id: 0,
              Name: "全部"
            });
          }
        });
      
    },
    //获取品类
    getBrandType() {
      var obj = {
        userId: localStorage.Id
      };
      SelectBrandTypeBaseDataByCondition(obj).then(data => {
        if (data.ResultCode == 1) {
          this.getbrandarr1()
          this.brandTypearr = data.ResultObj;
          this.newpinleioptions = data.ResultObj;
          this.brandTypearr.unshift({
            Id: 0,
            Name: "全部"
          });
        }
      });
    },
    handleChange(val) {
      this.cbId = val[0];
      this.bcid = val[1];
    },
    //获取城市下的品牌商
    getBrandByCityId() {
      var obj = {
        userId: localStorage.Id
      };
      SelectBBListByCondition(obj).then(data => {
        var obj2 = {};
        var obj1 = {};
         this.options3.unshift({
             value:0,
             label:"全部"
           })
        data.ResultObj.map(item => {
          obj2 = item;
          obj2["value"] = item["CityId"];
          obj2["label"] = item["CityName"];
          obj2["children"] = item["BbModel"];
          obj2.children.map(item => {
            obj1 = item;
            obj1["value"] = item["Id"];
            obj1["label"] = item["Name"];
          });
           obj2.children.unshift({
              value:0,
             label:"全部"
           })
          this.options3.push(obj2);
        });
      });
    },
    setnumber() {
      if (this.goodIdarr.length == 0) {
        this.$swal({
          type: "warning",
          text: "请选择需要操作的商品"
        });
        return false;
      }
      var that = this;
       let timer = null
       timer = setInterval(() => {
         if(document.getElementById("sc")){
           document.getElementById("sc").value = that.MarketPrice1
           clearInterval(timer)
         }
       }, 30);
      swal(
        {
          title: "<small>调整商品价格</small>!",
          text:
            `<p><span style='margin-left:15px'>市场价：</span> <input type='text' value='1'  id='sc'></p> 
            <p>甄惠装价： <input type='text' ${this.TzrPrice1?'value = "'+this.TzrPrice1+'"':""} id='tzr'></p>`,
          html: true,
          type: "prompt",
          customClass: "disinput",
          confirmButtonText: "确定",
          showCancelButton: true,
          cancelButtonText: "取消"
        },
        function(val) {
         if(val+""=="false"){
         }else if(val == ""){
           that.$swal({
                type: "warning",
                text: "请输入正确的价格,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
              });
         }
          if (val) {
            if (
              isNaN(document.getElementById("sc").value) ||
              isNaN(document.getElementById("tzr").value)
            ) {
              that.$swal({
                type: "warning",
                text: "请输入正确的价格,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
              });
            } else {
              if (
                !that.ishavedian(document.getElementById("sc").value) ||
                !that.ishavedian(document.getElementById("tzr").value)
              ) {
                that.$swal({
                  type: "warning",
                  text: "请输入正确的价格,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
                });
              }else if(document.getElementById("sc").value<0.01||document.getElementById("tzr").value<0.01){
                 that.$swal({
                  type: "warning",
                  text: "请输入正确的价格,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
                });
              }else if(document.getElementById("sc").value>99999999.99||document.getElementById("tzr").value>99999999.99){
                 that.$swal({
                  type: "warning",
                  text: "请输入正确的价格,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
                });
              } else {
                var obj = {
                  goodsIds: that.goodIdarr.join(","),
                  operId: localStorage.Id,
                  marketPrice: document.getElementById("sc").value,
                  tzrPrice: document.getElementById("tzr").value
                };
                BatchUpdateGoodsPrice(obj).then(data => {
                  if (data.ResultCode == 1) {
                    that.getgoodlist();
                    that.$swal({
                      type: "success",
                      html: data.ResultMsg
                    });
                  }
                });
              }
            }
          }else{
          }
        }
      );
    },
    changeblur() {
      this.form.tzprice = String(this.form.tzprice)
        .replace(/^(\s+|\.+|\D)/, "")
        .replace(/(\d+)(\.)(\d)(\.)/, "$1$2$3")
        .replace(/(\d+)(\.)(\.)/, "$1$2")
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      this.form.shichangprice = String(this.form.shichangprice)
        .replace(/^(\s+|\.+|\D)/, "")
        .replace(/(\d+)(\.)(\d)(\.)/, "$1$2$3")
        .replace(/(\d+)(\.)(\.)/, "$1$2")
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
    },
    followUp() {
      if (this.colorId == "") {
        this.$swal({
          type: "warning",
          text: "请选择颜色"
        });
        return false;
      } else if (this.LogoUrl == "") {
        this.$swal({
          type: "warning",
          text: "请上传用户头像"
        });
        return false;
      } else if (this.UserName == "") {
        this.$swal({
          type: "warning",
          text: "请输入用户名称"
        });
        return false;
      } else if (this.RContent == "") {
        this.$swal({
          type: "warning",
          text: "请输入评论内容"
        });
        return false;
      } else if (this.value1 == "") {
        this.$swal({
          type: "warning",
          text: "请选择商品评分"
        });
        return false;
      } else if (this.value2 == "") {
        this.$swal({
          type: "warning",
          text: "请选择商家评分"
        });
        return false;
      } else if (this.valuetime == "" || this.valuetime + "" == "null") {
        this.$swal({
          type: "warning",
          text: "请选择评价时间"
        });
        return false;
      }
      var obj = {
        GoodsId: this.goodId,
        Colorid: this.colorId,
        UserName: this.UserName,
        UserFace: this.LogoUrl,
        RContent: this.RContent,
        GoodSatisfaction: this.value1,
        BusinessSatisfaction: this.value2,
        CTime: this.valuetime
      };
      InsertTempGoodsReview(obj).then(data => {
        if (data.ResultCode == 1) {
          this.getgoodcomments();
          this.colorId = "";
          this.UserName = "";
          this.LogoUrl = "";
          this.LogoUrl1 = "";
          this.RContent = "";
          this.value1 = "";
          this.value2 = "";
          this.valuetime = "";
          this.pageIndex1 = 1;
          this.$swal({
            type: "success",
            text: "保存成功"
          });
        }
      });
    },
    getgoodcomments() {
      var obj = {
        goodsId: this.goodId,
        pageIndex: this.pageIndex1,
        pageSize: 5
      };
      SelectTempGoodsComments(obj).then(data => {
        if (data.ResultCode == 1) {
          // this.colorId = data.ResultObj[0].Colorid
          // this.UserName = data.ResultObj[0].UserName
          // this.LogoUrl = data.ResultObj[0].UserFace
          // this.LogoUrl1 = data.ResultObj[0].UserFace
          // this.RContent = data.ResultObj[0].RContent
          // this.value1 = data.ResultObj[0].GoodSatisfaction
          // this.value2 = data.ResultObj[0].BusinessSatisfaction
          // this.valuetime = data.ResultObj[0].CTime
          this.commentarr = data.ResultObj;
          this.total1 = data.RowsCount;
        } else {
          this.commentarr = [];
          this.total1 = 0;
        }
      });
    },
    getcolorarr() {
      var obj = {
        goodsId: this.goodId
      };
      SelectTempGoodsColor(obj).then(data => {
        if (data.ResultCode == 1) {
          this.colorarr = data.ResultObj;
        }
      });
    },
    handleAvatarSuccess() {},
    beforeAvatarUploadtouxiang(file) {
      const isSize = new Promise(function(resolve, reject) {
        let width = 132;
        let height = 132;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          var that = this;
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function(e) {
            var obj = {
              files: e.target.result,
              operId: localStorage.Id,
              uploadType: 4
            };
            UpoadImg(obj).then(data => {
              if (data.ResultCode == 1) {
                that.LogoUrl1 = localStorage.BaseUrl + data.ResultMsg;
                that.LogoUrl = data.ResultMsg;
              }
            });
          };
          return file;
        },
        () => {
          this.$swal({
            text: "上传图片宽高尺寸应为132*132",
            type: "warning"
          });
          return Promise.reject();
        }
      );
      return isSize;
      // var that = this;
      // var reader = new FileReader();
      // reader.readAsDataURL(file);
      // reader.onload = function(e) {
      //   that.LogoUrl = e.target.result;
      // };
      // return file;
    },
    handleCurrentChange1(val) {
      this.pageIndex1 = val;
      this.getgoodcomments();
    },
    handleClosezhun() {
      this.dialogVisibledelete = false;
    },
    comment(scope) {
      this.dialogVisibledelete = true;
      this.goodId = scope.row.Id;
      this.getcolorarr();
      this.pageIndex1 = 1;
      this.getgoodcomments();
      this.colorId = "";
      this.UserName = "";
      this.LogoUrl = "";
      this.LogoUrl1 = "";
      this.RContent = "";
      this.value1 = "";
      this.value2 = "";
      this.valuetime = "";
    },
    volume(scope) {
      this.$swal({
        title: "设置商品销量",
        text: "在下方输入框内输入当前商品销量",
        input: "text",
        inputPlaceholder: "请输入当前商品销量",
        inputValue: scope.row.SalesCount,
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(inputVal => {
        if (!inputVal.value && inputVal.value != "") {
          return false;
        }

        if (!this.makeNumber(inputVal.value)) {
          this.$swal({
            type: "warning",
            text: "请输入正确的销量，并且要是正整数"
          });
        } else if (inputVal.value == "") {
          this.$swal({
            type: "warning",
            text: "请输入正确的销量，并且要是正整数"
          });
        } else if (inputVal.value > 99999999) {
          this.$swal({
            type: "warning",
            text: "请输入正确的销量，并且要是正整数"
          });
        } else {
          var obj = {
            GoodsId: scope.row.Id,
            SalesCount: inputVal.value
          };
          UpdateGoodsSalesCount(obj).then(data => {
            if (data.ResultCode == 1) {
              this.getgoodlist();
              this.$swal({
                type: "success",
                text: "保存成功"
              });
            }
          });
        }
      });
    },
    changetime() {
      if (this.value6 + "" == "null") {
        this.value6 = ["", ""];
      }
      this.filters.date1 = this.value6[0];
      this.filters.date2 = this.value6[1];
    },
    arrlength() {
      alert(1);
    },
    //查看库存
    kucun(scope) {
      this.dialogTableVisibletable = true;
      var obj = {
        goodsId: scope.Id
      };
      SelectGoodsStockFlowByGoodsId(obj).then(data => {
        if (data.ResultCode == 4) {
          this.gridData = [];
        } else if (data.ResultCode == 1) {
          this.gridData = data.ResultObj;
        }
      });
    },
    clickitem() {
      this.money = 0;
    },
    //是否今日推荐
    today(scope) {
      var loginParams = {
        isShow: scope.IsToday,
        showType: 2,
        goodsId: scope.Id
      };
      hometui(loginParams)
        .then(data => {
          that.getweidailist();
          // localStorage.setItem("token", res.token);
        })
        .catch(err => {
        });
    },
    //是否展示首页
    changehome(scope) {
      var loginParams = {
        isShow: scope.IsShowHome,
        showType: 1,
        goodsId: scope.Id
      };
      hometui(loginParams)
        .then(data => {
          that.getweidailist();
          // localStorage.setItem("token", res.token);
        })
        .catch(err => {
        });
    },
    // 限制图片上传数量
    handleExceed(files, fileList) {
      this.$message.warning(
        `每次上传限制选择 5 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeAvatarUpload1(file) {
      const isSize = new Promise(function(resolve, reject) {
        let width = 50;
        let height = 50;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width / img.height == 1;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          //reader.readAsDataURL(file[file.length - 1].raw);
          var _this = this;
          let newcolorindex = _this.colorindex;
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function(e) {
            var obj ={
              base64Img:e.target.result,
              operId:localStorage.Id,
              uploadType:0
            }
            UploadImgForDB(obj).then(data=>{
              if(data.ResultCode == 1){
               let newcolorList = _this.colorList;
              for (var i = 0; i < newcolorList.length; i++) {
                if (i == newcolorindex) {
                  newcolorList[i].ImgData = data.ResultMsg
                }
              }
              _this.detailImgIdarr.push(data.ResultObj)
              var obj ={
                dtGoodsImg: _this.detailImgIdarr.join(',') // 最新排列顺序
              }
              // 排序接口
              BatchUpdateImgSortNumber(obj).then(data=>{
                if(data.ResultCode == 1){}
              })
              }
            })
            // let newcolorList = _this.colorList;
            
            // for (var i = 0; i < newcolorList.length; i++) {
            //   if (i == newcolorindex) {
            //     newcolorList[i].ImgData = _this.colorimg;
            //   }
            // }
          };
          return file;
        },
        () => {
          // this.$message.error("上传的图片宽高比例为1:1");
          this.$swal({
            type: "warning",
            text: "上传的图片宽高比例为1:1"
          });
          return Promise.reject();
        }
      );
      return isSize;
    },
    // 上传详情页产品图片
    beforeAvatarUpload(file) {
      // 判断图片格式
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' ||file.type === 'image/jpeg';
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 1;
      //  if(this.$refs.big1.length > 3){
      //    this.$refs.big1[3].style.display = "none"
      //  }
      if (!isJPG) {
        this.$swal({
          type: "warning",
          text: "上传图片只支持jpg、png等格式!"
        });
        return;
      }
      if (!isLt2M) {
        this.$swal({
          type: "warning",
          text: "上传图片大小不能超过 1MB!"
        });
        return;
      }
      
      const isSize = new Promise(function(resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = function() {
          let valid = img.width / img.height == 1; // 控制传正方形图片
          valid ? resolve() : reject();
        };
      })
      isSize.then(() => {
        var _this = this;
        this.flag += 1;
        if (this.flag > 20) {
          this.$swal({
            type: "warning",
            text: "最多传入20张图片"
          });
          return false;
        }
        // if (_this.detailImgUrlarr.length > 4) {
        //   this.$swal({
        //     type: "warning",
        //     text: "最多传入5张图片"
        //   });
        //   return false;
        // }
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          // var obj ={
          //   base64Img:e.target.result,
          //   operId:localStorage.Id,
          //   uploadType:0
          // }
          // 上传详情页产品图片接口
          // UploadImgForDB(obj).then(data=>{
          //   if(data.ResultCode == 1){
          //     var obj1 = {
          //       ImgName: "详情页产品图片",
          //       ImgData:String(data.ResultObj),
          //       ImgType: 1
          //     }
          //     _this.detailImgUrlarr1.push(localStorage.BaseUrl+data.ResultMsg)
          //     _this.detailImgUrlarr.push(obj1)

          //     _this.detailImgIdarr.push(data.ResultObj)
          //     var obj ={
          //       dtGoodsImg: _this.detailImgIdarr.join(',') // 数组转换字符串之后 最新排列顺序
          //     }
          //     BatchUpdateImgSortNumber(obj).then(data=>{
          //       if(data.ResultCode == 1){}
          //     })
          //   }
          // })

          /* oss 直传图片 */
          var aaa = {
            type: 20
          };
          getOssFile(aaa).then(data => {
            this.fileName = file.name;
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
            }
          })
          var newOssPic = await uploadOSS(file,0);
          _this.detailImgUrlarr1.push(newOssPic);
          _this.imgarrCutting = newOssPic.replace(localStorage.BaseOssUrl,'')

          // 上传文件记录并返回id
          var bbb = {
            name: this.fileName,
            url: _this.imgarrCutting,
            uploader: localStorage.Id
          };
          postAddFile(bbb).then(data => {
            if (data.resultCode == 1) {
              var obj1 = {
                ImgName: "详情页产品图片",
                ImgData:String(data.resultObj),
                ImgType: 1
              }
              _this.detailImgUrlarr.push(obj1)
              _this.detailImgIdarr.push(data.resultObj);
              var abc ={
                dtGoodsImg: _this.detailImgIdarr.join(',') // 数组转换字符串之后 最新排列顺序
              }
              // 排序接口
              BatchUpdateImgSortNumber(abc).then(data=>{
                if(data.ResultCode == 1){}
              })
            }
          });

          // let obj = {
          //   ImgName: "详情页产品图片",
          //   ImgData: e.target.result,
          //   ImgType: 1
          // };
          // _this.detailImgUrlarr.push(obj);
        };
      }).catch(() => {
        this.$swal({
          type: "warning",
          text: "上传的图片必须是宽高比例为1:1"
        });
      });
    },
    // 详情页图片-拖拽方法
    dragDetailsPic (evt) {
      evt.preventDefault();
      // var oldArr = []
      // for (var i=0; i<len; i++){
      //   oldArr.push(i)
      // }
      var oldArr = this.detailImgIdarr
      var moveId = oldArr.splice(evt.oldIndex, 1)[0]
      oldArr.splice(evt.newIndex, 0, moveId)
      var obj ={
        dtGoodsImg: oldArr.join(',') // 最新排列顺序
      }
      this.firstDetail=obj.dtGoodsImg;
        // 排序接口
      BatchUpdateImgSortNumber(obj).then(data=>{
        if(data.ResultCode == 1){} else {
          this.$swal({
            text: "调整失败",
            type: "warning"
          });
        }
      })
      // console.log('拖动前的索引 :' + evt.oldIndex)
      // console.log('拖动后的索引 :' + evt.newIndex)
    },
    // 删除详情页图片
    deldetail(val) {
      let newdetailImgUrlarr = this.detailImgUrlarr;
      let newdetailImgIdarr = this.detailImgIdarr; // id列表
      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        if (val == i) {
          newdetailImgUrlarr.splice(i, 1);
          this.detailImgUrlarr1.splice(i, 1);
          newdetailImgIdarr.splice(i, 1); // 删除id
        }
      }
      this.detailImgUrlarr = newdetailImgUrlarr;
      this.flag = this.detailImgUrlarr.length;
      this.detailImgIdarr = newdetailImgIdarr;

      if(this.detailImgIdarr.length > 0) {
        var obj ={
          dtGoodsImg: newdetailImgIdarr.join(',') // 删除后 最新排列顺序
        }
        // 排序接口
        BatchUpdateImgSortNumber(obj).then(data=>{
          if(data.ResultCode == 1){}
        })
      }
    },
    
    // 产品优势
    handleproductyou(file) {
      this.flag2 += 1;
      if (this.flag2 > 30) {
        this.$swal({
          type: "warning",
          text: "最多传入30张图片"
        });
        return false;
      }
      // 判断图片格式
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';
      if (!isJPG) {
        this.$swal({
          type: "warning",
          text: "上传图片只支持jpg、png等格式!"
        });
        return;
      }
      var _this = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function(e) {
        // let obj = {
        //   ImgName: "产品优势",
        //   ImgData: e.target.result,
        //   ImgType: 3
        // };
        // _this.youImgUrlarr.push(obj);
        
        // var obj = {
        //   base64Img:e.target.result,
        //   operId:localStorage.Id,
        //   uploadType:0,
        // }
        // 上传产品优势图片接口
        // UploadImgForDB(obj).then(data=>{
        //   if(data.ResultCode == 1){
        //      _this.youImgUrlarr1.push(localStorage.BaseUrl+data.ResultMsg)
        //      _this.youImgUrlarr.push({
        //         ImgName: "产品优势",
        //         ImgData:String(data.ResultObj),
        //         ImgType: 3
        //      })
        //     _this.youImgIdarr.push(data.ResultObj)
        //     var obj ={
        //       dtGoodsImg: _this.youImgIdarr.join(',') // 最新排列顺序
        //     }
        //     // 排序接口
        //     BatchUpdateImgSortNumber(obj).then(data=>{
        //       if(data.ResultCode == 1){}
        //     })
        //   }
        // })

        /* oss 直传图片 */
        var aaa = {
          type: 20
        };
        getOssFile(aaa).then(data => {
          this.fileName = file.name;
          if (data.resultCode == 1) {
            let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
            let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
            let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
            let ossfile = data.resultObj.directory; // 保存路径
            let ossbucket = data.resultObj.bucket; // bucket
            localStorage.setItem('keyossId',ossId);
            localStorage.setItem('keyossSecret',ossSecret);
            localStorage.setItem('keyossHost',ossHost);
            localStorage.setItem('keyossfile',ossfile);
            localStorage.setItem('keyossbucket',ossbucket);
          }
        })
        var newOssPic = await uploadOSS(file,0);
        _this.youImgUrlarr1.push(newOssPic);
        _this.imgarrCuttingOne = newOssPic.replace(localStorage.BaseOssUrl,'')

        // 上传文件记录并返回id
        var bbb = {
          name: this.fileName,
          url: _this.imgarrCuttingOne,
          uploader: localStorage.Id
        };
        postAddFile(bbb).then(data => {
          if (data.resultCode == 1) {
            _this.youImgUrlarr.push({
              ImgName: "产品优势",
              ImgData:String(data.resultObj),
              ImgType: 3
            })
            _this.youImgIdarr.push(data.resultObj);
            var abc ={
              dtGoodsImg: _this.youImgIdarr.join(',') // 数组转换字符串之后 最新排列顺序
            }
            // 排序接口
            BatchUpdateImgSortNumber(abc).then(data=>{
              if(data.ResultCode == 1){}
            })
          }
        });

      };
    },
    // 产品优势-拖拽方法
    dragAdvantagePic (evt) {
        evt.preventDefault();
      var oldArr = this.youImgIdarr
      var moveId = oldArr.splice(evt.oldIndex, 1)[0]
      oldArr.splice(evt.newIndex, 0, moveId)
      var obj ={
        dtGoodsImg: oldArr.join(',') // 最新排列顺序
      }
      // 排序接口
      BatchUpdateImgSortNumber(obj).then(data=>{
        if(data.ResultCode == 1){} else {
          this.$swal({
            text: "调整失败",
            type: "warning"
          });
        }
      })
      // console.log('拖动前的索引 :' + evt.oldIndex)
      // console.log('拖动后的索引 :' + evt.newIndex)
    },
    //删除产品优势
    delyoushi(val) {
      let newyouImgUrlarr = this.youImgUrlarr;
      let newyouImgIdarr = this.youImgIdarr;
      for (var i = 0; i < newyouImgUrlarr.length; i++) {
        if (val == i) {
          newyouImgUrlarr.splice(i, 1);
          this.youImgUrlarr1.splice(i, 1);
          newyouImgIdarr.splice(i, 1); // 删除id
        }
      }
      this.youImgUrlarr = newyouImgUrlarr;
      this.flag2 = this.youImgUrlarr.length;
      this.youImgIdarr = newyouImgIdarr;
      
      if(this.youImgIdarr.length > 0) {
        var obj ={
          dtGoodsImg: newyouImgIdarr.join(',') // 删除后 最新排列顺序
        }
        // 排序接口
        BatchUpdateImgSortNumber(obj).then(data=>{
          if(data.ResultCode == 1){}
        })
      }
    },
    
    // 产品检测
    handlejiance(file) {
      this.flag3 += 1;
      if (this.flag3 > 30) {
        this.$swal({
          type: "warning",
          text: "最多传入30张图片"
        });
        return false;
      }
      // 判断图片格式
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';
      if (!isJPG) {
        this.$swal({
          type: "warning",
          text: "上传图片只支持jpg、png等格式!"
        });
        return;
      }
      var _this = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function(e) {
        // let obj = {
        //   ImgName: "产品检测",
        //   ImgData: e.target.result,
        //   ImgType: 7
        // };
        // _this.jianceImgUrlarr.push(obj);

        // var obj = {
        //   base64Img:e.target.result,
        //   operId:localStorage.Id,
        //   uploadType:0,
        // }
        // 上传产品检测图片接口
        // UploadImgForDB(obj).then(data=>{
        //   if(data.ResultCode == 1){
        //      _this.jianceImgUrlarr1.push(localStorage.BaseUrl+data.ResultMsg)
        //      _this.jianceImgUrlarr.push({
        //         ImgName: "产品检测",
        //         ImgData:String(data.ResultObj),
        //         ImgType: 7
        //      })
        //     _this.jianceImgIdarr.push(data.ResultObj)
        //     var obj ={
        //       dtGoodsImg: _this.jianceImgIdarr.join(',') // 最新排列顺序
        //     }
        //     // 排序接口
        //     BatchUpdateImgSortNumber(obj).then(data=>{
        //       if(data.ResultCode == 1){}
        //     })
        //   }
        // })

        /* oss 直传图片 */
        var aaa = {
          type: 20
        };
        getOssFile(aaa).then(data => {
          this.fileName = file.name;
          if (data.resultCode == 1) {
            let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
            let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
            let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
            let ossfile = data.resultObj.directory; // 保存路径
            let ossbucket = data.resultObj.bucket; // bucket
            localStorage.setItem('keyossId',ossId);
            localStorage.setItem('keyossSecret',ossSecret);
            localStorage.setItem('keyossHost',ossHost);
            localStorage.setItem('keyossfile',ossfile);
            localStorage.setItem('keyossbucket',ossbucket);
          }
        })
        var newOssPic = await uploadOSS(file,0);
        _this.jianceImgUrlarr1.push(newOssPic);
        _this.imgarrCuttingTwo = newOssPic.replace(localStorage.BaseOssUrl,'')

        // 上传文件记录并返回id
        var bbb = {
          name: this.fileName,
          url: _this.imgarrCuttingTwo,
          uploader: localStorage.Id
        };
        postAddFile(bbb).then(data => {
          if (data.resultCode == 1) {
            _this.jianceImgUrlarr.push({
              ImgName: "产品检测",
              ImgData:String(data.resultObj),
              ImgType: 7
            })
            _this.jianceImgIdarr.push(data.resultObj);
            var abc ={
              dtGoodsImg: _this.jianceImgIdarr.join(',') // 数组转换字符串之后 最新排列顺序
            }
            // 排序接口
            BatchUpdateImgSortNumber(abc).then(data=>{
              if(data.ResultCode == 1){}
            })
          }
        });

      };
    },
    // 产品检测-拖拽方法
    dragTestingPic (evt) {
      evt.preventDefault();
      var oldArr = this.jianceImgIdarr
      var moveId = oldArr.splice(evt.oldIndex, 1)[0]
      oldArr.splice(evt.newIndex, 0, moveId)
      var obj ={
        dtGoodsImg: oldArr.join(',') // 最新排列顺序
      }
      // 排序接口
      BatchUpdateImgSortNumber(obj).then(data=>{
        if(data.ResultCode == 1){} else {
          this.$swal({
            text: "调整失败",
            type: "warning"
          });
        }
      })
      // console.log('拖动前的索引 :' + evt.oldIndex)
      // console.log('拖动后的索引 :' + evt.newIndex)
    },

    //删除检测图片
    deljianceimg(val) {
      let newjianceImgUrlarr = this.jianceImgUrlarr;
      let newjianceImgIdarr = this.jianceImgIdarr;
      for (var i = 0; i < newjianceImgUrlarr.length; i++) {
        if (val == i) {
          newjianceImgUrlarr.splice(i, 1);
          this.jianceImgUrlarr1.splice(i, 1);
          newjianceImgIdarr.splice(i, 1); // 删除id
        }
      }
      this.jianceImgUrlarr = newjianceImgUrlarr;
      this.flag3 = this.jianceImgUrlarr.length;
      this.jianceImgIdarr = newjianceImgIdarr;

      if(this.jianceImgIdarr.length > 0) {
        var obj ={
          dtGoodsImg: newjianceImgIdarr.join(',') // 最新排列顺序
        }
        // 排序接口
        BatchUpdateImgSortNumber(obj).then(data=>{
          if(data.ResultCode == 1){}
        })
      }
    },

    // 确定
    confirmView() {
      if (this.chatid) {
        let url =
          this.show == 1
            ? "/tail"
            : this.show == 2
            ? "/sample"
            : this.show == 3
            ? "/specialSale"
            : this.show == 5
            ? "/advanceSale"
            : this.show == 6
            ? "/vipGoods"
            : "";
        // if (this.show == 1) {
        //   this.editweigoods();
        // } else if (this.show == 2) {
        //   this.edityangpin();
        // } else if (this.show == 3) {
        //   this.edittemai();
        // } else if (this.show == 4) {
        //   this.tuangou();
        // } else if (this.show == 5) {
        //   this.edityushou();
        // } else if (this.show == 6) {
        //   this.editvip();
        // }

        this.$router.push(url);
      } else {
        this.ischaNext = false;
        this.isGoods = true;
      }
    },
    // 改变是否的图片
    changeImg(e, i) {
      let newarr = this.quyuarr;
      let tempId = newarr[e].BaseDatas[i].Id;
      this.GoodsParams[e].DataValue = tempId;
      for (var i = 0; i < newarr.length; i++) {
        if (i == e) {
          // if (newarr[i].sel == 0) {
          //   newarr[i].sel = 1;
          // } else {
          //   newarr[i].sel = 0;
          // }
          newarr[i].sel = !newarr[i].sel;
        }
      }
      this.quyuarr = newarr;
      // this.isOk = !this.isOk;
    },
    hide() {
      this.$refs.mySelect.handleClose();
    },
    hide1() {
      this.$refs.mySelect1.handleClose();
    },
    hide2() {
      this.$refs.mySelect2.handleClose();
    },
    addColor() {
      let obj = {
        ImgName: "",
        ImgData: "",
        ImgType: 2
      };
      this.colorList.push(obj);
    },
    delColor(i) {
      let newccolorList = this.colorList;
      newccolorList.splice(i, 1);
      this.colorList = newccolorList;
    },
    addother() {
      if (this.othertable.length <= 9) {
        let obj = {
          PName: "",
          PValue: ""
        };
        this.othertable.push(obj);
      } else {
        this.addothers = false;
      }
    },
    deleteother() {
      this.othertable = [];
      this.addothers = true;
    },
    addshop() {
      let obj = {
        Name: "",
        Address: ""
      };
      this.shoplist.push(obj);
    },
    delother(i) {
      this.othertable.splice(i, 1);
      if (this.othertable.length < 10) {
        this.addothers = true;
      }
    },
    delshop(i) {
      let newshoplist = this.shoplist;
      newshoplist.splice(i, 1);
      this.shoplist = newshoplist;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    showAdd() {
      this.isAdd = true;
      this.isNext = false;
      // if (this.show == "") {
      //   this.$notify.error({
      //     title: "错误",
      //     message: "请选择销售类型"
      //   });

      //   return false;
      // }
      // if (this.show == 1) {
      //   if (this.form.shichangprice == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入市场价"
      //     });
      //   } else if (this.form.tzprice == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入甄惠装价"
      //     });
      //   } else if (this.form.yongjin == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入佣金比例"
      //     });
      //   } else {
      //        var byIdfindinfo = {
      //    BbId: localStorage.BbId

      // }
      // byIdfindinfo1(byIdfindinfo).then(res=>{
      //   if(res.ResultCode === 1){
      //      this.isAdd = true;
      //      this.isNext = false;
      //   this.newprovinceName = res.ResultObj.ProvinceName
      //   this.newprovinceId = res.ResultObj.ProvinceId
      //   this.newcityName = res.ResultObj.CityName
      //   this.newcityId = res.ResultObj.CityId
      //   this.hezuotype = res.ResultObj.CooperationTypeName
      //   if(res.ResultObj.CooperationTypeId === 1){
      //     this.showtime = false
      //   }else{
      //      this.showtime = true
      //      this.coperdate1 = res.ResultObj.CoStarTime
      //       this.coperdate2 =  res.ResultObj.CoEndTime
      //    }
      //   }else{

      //   }
      // })
      //   }
      // }

      // if (this.show == 2) {
      //   if (this.form.shichangprice == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入市场价"
      //     });
      //   } else if (this.form.tzprice == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入甄惠装价"
      //     });
      //   } else if (this.form.yongjin == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入佣金比例"
      //     });
      //   } else {
      //              var byIdfindinfo = {
      //     BbId : localStorage.BbId

      // }
      // byIdfindinfo1(byIdfindinfo).then(res=>{
      //   if(res.ResultCode === 1){
      //      this.isAdd = true;
      //      this.isNext = false;
      //   this.newprovinceName = res.ResultObj.ProvinceName
      //   this.newprovinceId = res.ResultObj.ProvinceId
      //   this.newcityName = res.ResultObj.CityName
      //   this.newcityId = res.ResultObj.CityId
      //   this.hezuotype = res.ResultObj.CooperationTypeName
      //   if(res.ResultObj.CooperationTypeId === 1){
      //     this.showtime = false
      //   }else{
      //      this.showtime = true
      //      this.coperdate1 = res.ResultObj.CoStarTime
      //       this.coperdate2 =  res.ResultObj.CoEndTime
      //    }
      //   }else{
      //       this.isNext = true;
      //   }
      // })
      //   }
      // }

      // if (this.show == 3) {
      //   if (this.form.shichangprice == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入市场价"
      //     });
      //   } else if (this.form.tzprice == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入甄惠装价"
      //     });
      //   } else if (this.form.yongjin == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入佣金比例"
      //     });
      //   } else if (this.form.ETime == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入截止日期"
      //     });
      //   } else {
      //             var byIdfindinfo = {
      //        BbId : localStorage.BbId

      // }
      // byIdfindinfo1(byIdfindinfo).then(res=>{
      //   if(res.ResultCode === 1){
      //      this.isAdd = true;
      //      this.isNext = false;
      //   this.newprovinceName = res.ResultObj.ProvinceName
      //   this.newprovinceId = res.ResultObj.ProvinceId
      //   this.newcityName = res.ResultObj.CityName
      //   this.newcityId = res.ResultObj.CityId
      //   this.hezuotype = res.ResultObj.CooperationTypeName
      //   if(res.ResultObj.CooperationTypeId === 1){
      //     this.showtime = false
      //   }else{
      //      this.showtime = true
      //      this.coperdate1 = res.ResultObj.CoStarTime
      //       this.coperdate2 =  res.ResultObj.CoEndTime
      //    }
      //   }else{
      //       this.isNext = true;
      //   }
      // })
      //   }
      // }

      // if (this.show == 5) {
      //   if (this.form.shichangprice == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入市场价"
      //     });
      //   } else if (this.form.tzprice == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入甄惠装价"
      //     });
      //   } else if (this.form.yongjin == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入佣金比例"
      //     });
      //   } else if (this.yuETime == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入截止日期"
      //     });
      //   } else {
      //           var byIdfindinfo = {
      //       BbId : localStorage.BbId

      // }
      // byIdfindinfo1(byIdfindinfo).then(res=>{
      //   if(res.ResultCode === 1){
      //      this.isAdd = true;
      //      this.isNext = false;
      //   this.newprovinceName = res.ResultObj.ProvinceName
      //   this.newprovinceId = res.ResultObj.ProvinceId
      //   this.newcityName = res.ResultObj.CityName
      //   this.newcityId = res.ResultObj.CityId
      //   this.hezuotype = res.ResultObj.CooperationTypeName
      //   if(res.ResultObj.CooperationTypeId === 1){
      //     this.showtime = false
      //   }else{
      //      this.showtime = true
      //      this.coperdate1 = res.ResultObj.CoStarTime
      //       this.coperdate2 =  res.ResultObj.CoEndTime
      //    }
      //   }else{
      //       this.isNext = true;
      //   }
      // })
      //   }
      // }

      // if (this.show == 6) {
      //   if (this.form.shichangprice == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入市场价"
      //     });
      //   } else if (this.form.tzprice == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入甄惠装价"
      //     });
      //   } else if (this.form.yongjin == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入佣金比例"
      //     });
      //   } else if (this.VipPrice == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入vip价格"
      //     });
      //   } else if (this.Score == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入积分"
      //     });
      //   } else if (this.SharingDays == "") {
      //     this.$notify.error({
      //       title: "错误",
      //       message: "请输入累计分享免费积分"
      //     });
      //   } else {
      //          var byIdfindinfo = {
      //         BbId : localStorage.BbId

      // }
      // byIdfindinfo1(byIdfindinfo).then(res=>{
      //   if(res.ResultCode === 1){
      //      this.isAdd = true;
      //      this.isNext = false;
      //   this.newprovinceName = res.ResultObj.ProvinceName
      //   this.newprovinceId = res.ResultObj.ProvinceId
      //   this.newcityName = res.ResultObj.CityName
      //   this.newcityId = res.ResultObj.CityId
      //   this.hezuotype = res.ResultObj.CooperationTypeName
      //   if(res.ResultObj.CooperationTypeId === 1){
      //     this.showtime = false
      //   }else{
      //      this.showtime = true
      //      this.coperdate1 = res.ResultObj.CoStarTime
      //       this.coperdate2 =  res.ResultObj.CoEndTime
      //    }
      //   }else{
      //       this.isNext = true;
      //   }
      // })
      //   }
      // }

      // this.isNext = false;
      // this.isAdd = true;
    },
    cancelmodel() {
      this.isNext = false;
      this.isGoods = true;
    },
    editAdd() {
      let that = this;
      if (this.show == "") {

        this.$swal({
          type: "warning",
          text: "请选择销售类型"
        });
        return false
      }
      if (this.show == 1) {

        var byIdfindinfo = {
          BbId: localStorage.BbId
        };
        byIdfindinfo1(byIdfindinfo).then(res => {
          if (res.ResultCode === 1) {
            console.log(res.ResultObj,'1111111');
            this.isAdd = true;
            this.isNext = false;
            this.newprovinceName = res.ResultObj.ProvinceName;
            this.newprovinceId = res.ResultObj.ProvinceId;
            this.newcityName = res.ResultObj.CityName;
            this.newcityId = res.ResultObj.CityId;
            this.hezuotype = res.ResultObj.CooperationTypeName;
            if (res.ResultObj.CooperationTypeId === 1) {
              this.showtime = false;
            } else {
              this.showtime = true;
              this.coperdate1 = res.ResultObj.CoStarTime;
              this.coperdate2 = res.ResultObj.CoEndTime;
              this.valuedata = [
                res.ResultObj.CoStarTime,
                res.ResultObj.CoEndTime
              ];
            }
          } else {
            this.isNext = true;
          }
        })
      }


      if (this.show == 2) {
        var byIdfindinfo = {
          BbId: localStorage.BbId
        };
        byIdfindinfo1(byIdfindinfo).then(res => {
          console.log(res.ResultObj,'222222');
          if (res.ResultCode === 1) {
            this.isAdd = true;
            this.isNext = false;
            this.newprovinceName = res.ResultObj.ProvinceName;
            this.newprovinceId = res.ResultObj.ProvinceId;
            this.newcityName = res.ResultObj.CityName;
            this.newcityId = res.ResultObj.CityId;
            this.hezuotype = res.ResultObj.CooperationTypeName;
            if (res.ResultObj.CooperationTypeId === 1) {
              this.showtime = false;
            } else {
              this.showtime = true;
              this.coperdate1 = res.ResultObj.CoStarTime;
              this.coperdate2 = res.ResultObj.CoEndTime;
              this.valuedata = [
                res.ResultObj.CoStarTime,
                res.ResultObj.CoEndTime
              ];
            }
          } else {
            this.isNext = true;
          }
        })
      }

      if (this.show == 3) {
        var byIdfindinfo = {
          BbId: localStorage.BbId
        };
        byIdfindinfo1(byIdfindinfo).then(res => {
          console.log(res.ResultObj,'333333');
          if (res.ResultCode === 1) {
            this.isAdd = true;
            this.isNext = false;
            this.newprovinceName = res.ResultObj.ProvinceName;
            this.newprovinceId = res.ResultObj.ProvinceId;
            this.newcityName = res.ResultObj.CityName;
            this.newcityId = res.ResultObj.CityId;
            this.hezuotype = res.ResultObj.CooperationTypeName;
            if (res.ResultObj.CooperationTypeId === 1) {
              this.showtime = false;
            } else {
              this.showtime = true;
              this.coperdate1 = res.ResultObj.CoStarTime;
              this.coperdate2 = res.ResultObj.CoEndTime;
              this.valuedata = [
                res.ResultObj.CoStarTime,
                res.ResultObj.CoEndTime
              ];
            }
          } else {
            this.isNext = true;
          }
        })
      }

      if (this.show == 5) {
        var byIdfindinfo = {
          BbId: localStorage.BbId
        };
        byIdfindinfo1(byIdfindinfo).then(res => {
          console.log(res.ResultObj,'444444');
          if (res.ResultCode === 1) {
            this.isAdd = true;
            this.isNext = false;
            this.newprovinceName = res.ResultObj.ProvinceName;
            this.newprovinceId = res.ResultObj.ProvinceId;
            this.newcityName = res.ResultObj.CityName;
            this.newcityId = res.ResultObj.CityId;
            this.hezuotype = res.ResultObj.CooperationTypeName;
            if (res.ResultObj.CooperationTypeId === 1) {
              this.showtime = false;
            } else {
              this.showtime = true;
              this.coperdate1 = res.ResultObj.CoStarTime;
              this.coperdate2 = res.ResultObj.CoEndTime;
              this.valuedata = [
                res.ResultObj.CoStarTime,
                res.ResultObj.CoEndTime
              ];
            }
          } else {
            this.isNext = true;
          }
        })
      }

      if (this.show == 6) {
        var byIdfindinfo = {
          BbId: localStorage.BbId
        };
        byIdfindinfo1(byIdfindinfo).then(res => {
          console.log(res.ResultObj,'555555');
          if (res.ResultCode === 1) {
            this.isAdd = true;
            this.isNext = false;
            this.newprovinceName = res.ResultObj.ProvinceName;
            this.newprovinceId = res.ResultObj.ProvinceId;
            this.newcityName = res.ResultObj.CityName;
            this.newcityId = res.ResultObj.CityId;
            this.hezuotype = res.ResultObj.CooperationTypeName;
            if (res.ResultObj.CooperationTypeId === 1) {
              this.showtime = false;
            } else {
              this.showtime = true;
              this.coperdate1 = res.ResultObj.CoStarTime;
              this.coperdate2 = res.ResultObj.CoEndTime;
              this.valuedata = [
                res.ResultObj.CoStarTime,
                res.ResultObj.CoEndTime
              ];
            }
          } else {
            this.isNext = true;
          }
        })
      }

      that.GoodsParams = goodsinfo;
      that.editgoodsimgs = [];
      that.indexImgUrlarr = [];
      that.detailImgUrlarr = [];
      that.youImgUrlarr = [];
      that.xiaoguoImgUrlarr = [];
      that.xijieImgUrlarr = [];
      that.jianceImgUrlarr = [];
      that.colorList = [];
    },
    // 查看下一步
    chashowAdd() {
      this.ischaNext = true;
      this.ischaAdd = false;
    },
    //判断是否写在手地址 在受店面
    istrue() {
      for (var i = 0; i < this.shoplist.length; i++) {
        if (this.shoplist[i].Name == "") {
          this.$swal({
            type: "warning",
            text: "请添加店面名称"
          });
          return false;
        } else if (this.shoplist[i].Address == "") {
          this.$swal({
            type: "warning",
            text: "请添加店面地址"
          });
          return false;
        }
      }
      for (var i = 0; i < this.othertable.length; i++) {
        if (this.othertable[i].PName == "") {
          this.$swal({
            type: "warning",
            text: "请手动删除为空的自定义参数！"
          });
          return false;
        } else if (this.othertable[i].PValue == "") {
          this.$swal({
            type: "warning",
            text: "请输入值"
          });
          return false;
        }
      }
      for (var i = 0; i < this.colorList.length; i++) {
        if (this.colorList[i].ImgName == "") {
          this.$swal({
            type: "warning",
            text: "请输入颜色名名称"
          });
          return false;
        }
      }
      return true;
    },
    //返回下一部
    endBack() {
      // document.body.scrollTop = document.documentElement.scrollTop = 0;
      if (this.attention() && this.istrue()) {
        this.isNext = true;
        this.isAdd = false;
        this.options = this.$route.query.id
          ? this.$route.query.id
          : this.options;
        // if( document.getElementById("scoll")){
        //    document.documentElement.scrollTop = document.body.scrollTop = window.pageYOffset = 0
        //    alert(documentElement.scrollTop)
        // }
     
        //  document.documentElement.scrollTop = document.body.scrollTop = window.pageYOffset = 0
        //   alert(documentElement.scrollTop)
        if (this.options == 1) {
          this.isSample = true;
          this.isAdvance = false;
          this.isSpecial = false;
          this.isVip = false;
          this.isGroup = false;
          this.show = 1;
        }
        if (this.options == 2) {
          this.isSample = true;
          this.isAdvance = false;
          this.isSpecial = false;
          this.isVip = false;
          this.isGroup = false;
          this.show = 2;
        }
        if (this.options == 5) {
          this.isSample = true;
          this.isAdvance = true;
          this.isSpecial = false;
          this.isVip = false;
          this.isGroup = false;
          this.show = 5;
        }
        if (this.options == 3) {
          this.isSample = true;
          this.isAdvance = false;
          this.isSpecial = true;
          this.isVip = false;
          this.isGroup = false;
          this.show = 3;
        }
        if (this.options == 6) {
          this.isSample = true;
          this.isAdvance = false;
          this.isSpecial = false;
          this.isVip = true;
          this.isGroup = false;
          this.show = 6;
        }
        if (this.options == 4) {
          this.isSample = false;
          this.isAdvance = false;
          this.isSpecial = false;
          this.isVip = false;
          this.isGroup = true;
          this.show = 4;
        }
      } else {
        this.options = this.$route.query.id;
      }
    },
    showGoods() {
      let that = this;
      this.isGoods = true;
      this.isAdd = false;
      this.isNext = false;
      that.editgoodsimgs = [];
      that.indexImgUrlarr = [];
      that.detailImgUrlarr = [];
      that.youImgUrlarr = [];
      that.xiaoguoImgUrlarr = [];
      that.xijieImgUrlarr = [];
      that.jianceImgUrlarr = [];
      that.colorList = [];
    },
    // 新增
    showNext() {
      this.othertable = [];
      this.radio = "1";
      this.money = 0;
      this.options = "";
      this.getnewgoodpinpai();
      var byIdfindinfo = {
        BbId: localStorage.BbId
      };
      byIdfindinfo1(byIdfindinfo).then(res => {
        console.log(res.ResultObj,'666666');
        if (res.ResultCode === 1) {
          this.isAdd = true;
          this.isNext = false;
          this.isNext = false;
          this.isAdd = true;
          this.shownew = true;
          this.isGoods = false;
          this.isVip = false;
          this.isSample = false;
          this.isAdvance = false;
          this.isSpecial = false;
          this.VipPrice = "";
          this.Score = "";
          this.SharingDays = "";
          this.form.shichangprice = "";
          this.form.tzprice = "";
          this.form.yongjin = 8;
          this.yuETime = "";
          this.yuSTime = "";
          this.ETime = "";
          this.Title = "";
          this.Remark = "";
          this.options = "";
          this.editgoodsimgs = [];
          this.indexImgUrlarr = [];
          this.detailImgUrlarr = [];
          this.youImgUrlarr = [];
          this.xiaoguoImgUrlarr = [];
          this.xijieImgUrlarr = [];
          this.jianceImgUrlarr = [];
          this.detailImgUrlarr1 = []
          this.youImgUrlarr1 = []
          this.jianceImgUrlarr1 = []
          this.colorList = [];
          this.hezuotype = "";
          this.GoodModelCode = "";
          this.newpinleiId = "";
          this.newpinpaiId = "";
          this.newprovinceId = "";
          this.newcityId = "";
          this.Slogan = "";
          this.Advantage = "";
          this.danweiId = "";
          (this.wuliuId = ""), (this.shoplist = []);
          this.AfterPolicy = "";
          this.NeedAttention = "";
          this.FreightDesc = "";
          this.form.weistock = "";
          this.GoodsParams = [];
          this.quyuarr = [];
          this.showtime = true;
          this.newprovinceName = res.ResultObj.ProvinceName;
          this.newprovinceId = res.ResultObj.ProvinceId;
          this.newcityName = res.ResultObj.CityName;
          this.newcityId = res.ResultObj.CityId;
          this.hezuotype = res.ResultObj.CooperationTypeName;
          if (res.ResultObj.CooperationTypeId === 1) {
            this.showtime = false;
          } else {
            this.showtime = true;
            this.coperdate1 = res.ResultObj.CoStarTime;
            this.coperdate2 = res.ResultObj.CoEndTime;
            this.valuedata = [
              res.ResultObj.CoStarTime,
              res.ResultObj.CoEndTime
            ];
          }
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getgoodlist();
    },
    // 根据选项显示输入框
    changeOption(date) {
      if (date == 1) {
        this.money = 2000;
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = false;
        this.show = 1;
      }
      if (date == 2) {
        this.money = 2000;
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = false;
        this.show = 2;
      }
      if (date == 5) {
        this.money = 1000;
        this.isSample = true;
        this.isAdvance = true;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = false;
        this.show = 5;
      }
      if (date == 3) {
        this.money = 1000;
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = true;
        this.isVip = false;
        this.isGroup = false;
        this.show = 3;
      }
      if (date == 6) {
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = true;
        this.isGroup = false;
        this.show = 6;
      }
      if (date == 4) {
        this.isSample = false;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = true;
        this.show = 4;
      }
    },
    //获取品类
    getpinlei() {
      let that = this;

      var loginParams = {
        tableName: "tbdgoodsbrandtype",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;

          var obj = {
            Id: -1,
            Name: "全部"
          };
          data.unshift(obj);
          that.pinleiptions = data;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //获取品牌
    getbrand() {
      let that = this;

      var loginParams = {
        tableName: "tbdbrand",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;

          var obj = {
            Id: -1,
            Name: "全部"
          };
          data.unshift(obj);
          that.brandoptions = data;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //商品状态
    getstatus() {
      let that = this;

      var loginParams = {
        tableName: "tBDGoodsStatus",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;

          var obj = {
            Id: -1,
            Name: "全部"
          };
          data.unshift(obj);
          that.statusptions = data;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    selectipre(e) {
      this.isExpire = e;
    },
    // 重置
    fnReset() {
      this.filters = {
        name: "",
        options: "",
        option1: "",
        option2: "",
        pinpaishang: '',
        date1: "",
        date2: "",
        brandId: 0,
        brandTypeId: 0,
        xuanstatusId: -1,
        goodsActiveId: 0
      },
      this.cbId = '';
      this.bcid = '';
      // this.pageIndex = 1;
      // this.getgoodlist();
    },
    // 查询
    onsubmit() {
      this.pageIndex = 1;
      this.getgoodlist();
    },
    p(s) {
      return s < 10 ? "0" + s : s;
    },
    //获取商品
    getgoodlist() {
      let that = this;

      var addParams = {
        keyWord: that.filters.name,
        brandTypeId: that.filters.brandTypeId,
        brandId: that.filters.brandId,
        statusId: that.filters.xuanstatusId,
        pageIndex: that.pageIndex,
        pageSize: that.pageSize,
        cityId: this.cbId,
        bbId: this.bcid,
        goodsActiveId: this.filters.goodsActiveId,
        // sTime: this.filters.date1,
        // eTime: this.filters.date2,
        // isExpire: that.isExpire,
        operId: this.$cookie.get("OperatorId")
      };
      goodslist(addParams)
        .then(data => {
          this.total = data.RowsCount;
          this.users = data.ResultObj;
        })
        .catch(err => {
          this.orderlist = [];
        });
    },

    //获取销售类型
    getxiaoshoutype() {
      let that = this;

      var loginParams = {
        tableName: "tbdgoodsactive",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;
          data.splice(3, 1)
          that.xiaoshouoptions1 = data;
          this.xiaoshouoptions1.unshift({
            Id: 0,
            Name: "全部"
          });
          //  that.xiaoshouoptions =  this.xiaoshouoptions1.shift
        })
        .catch(err => {
          this.logining = false;
        });
    },
    getxiaoshoutype1() {
      let that = this;

      var loginParams = {
        tableName: "tbdgoodsactive",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;
          data.splice(3, 1);
          that.xiaoshouoptions = data;
          that.xiaoshouoptions.unshift({
            Id: 0,
            Name: "请选择"
          });
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //获取新增商品品类
    getnewgoodpinlei() {
      let that = this;
      var loginParams = {
        tableName: "tbdgoodsbrandtype",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;
          that.newpinleioptions = data;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //获取新增商品品牌
    getnewgoodpinpai() {
      let that = this;
      var loginParams = {
        bbid: localStorage.BbId
      };
      byIdfindinfo1(loginParams).then(data => {
          console.log(res.ResultObj,'777777');
          if (data.ResultCode == 1) {
            data = data.ResultObj;
            that.newpinpaioptions = data;
          } else {
            that.newpinpaioptions = [];
          }
          // data = data.ResultObj;
          // that.newpinpaioptions = data;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //获取省
    getprovince() {
      let that = this;

      var loginParams = {
        tableName: "tbdprovince",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;
          that.newprovince = data;
        })
        .catch(err => {
          this.logining = false;
        });
    },

    selectoptions(e) {
      this.getcity();
      this.newcityId = "";
    },
    //获取市
    getcity() {
      let that = this;
      var loginParams = {
        tableName: "tbdcity",
        keyWord: "",
        parentId: this.newprovinceId
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;
          that.newcity = data;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    seleccity(val) {
      this.newcityId = val;
      this.gethezuotype();
    },
    //合作类型
    gethezuotype() {
      let that = this;
      var loginParams = {
        cityId: this.newcityId
      };
      gethezuo(loginParams)
        .then(data => {
          if (data.ResultCode == 4) {
            this.$swal({
              type: "warning",
              text: "该省份没有合作类型，不能添加商品"
            });
          } else {
            data = data.ResultObj;
            that.hezuotype = data.CooperationTypeName;
            if (data.CooperationTypeId == 1) {
              this.showtime = false;
            } else {
              this.showtime = true;
            }
            // that.BbId = data.Id;
            that.coperdate1 = data.CoStarTime;
            that.coperdate2 = data.CoEndTime;
            this.valuedata = [data.CoStarTime, data.CoEndTime];
          }
        })
        .catch(err => {
          this.logining = false;
        });
    },
    selectpinlei() {
      this.getquyu();
    },
    //根据品类id获取所填区域
    getquyu() {
      let that = this;
      if (that.editgoodsid == true) {
        var loginParams = {
          goodsId: "",
          goodsBrandTypeId: this.newpinleiId
        };
      } else {
        var loginParams = {
          goodsId: that.editgoodsid?that.editgoodsid : 0,
          goodsBrandTypeId: this.newpinleiId
        };
      }
      getquyu(loginParams)
        .then(data => {
          data = data.ResultObj;
          let goodsInfo = [];
          let tempInfo = "";
          for (var obj of data) {
            obj.sel = false;
            if (obj.ControlTypeId == 1) {
              tempInfo = {
                Id: obj.Id,
                DataValue: ""
              };
            } else if (obj.ControlTypeId == 2) {
              tempInfo = {
                Id: obj.Id,
                DataValue: 1
              };
            } else if (obj.ControlTypeId == 3) {
              tempInfo = {
                Id: obj.Id,
                DataValue: 2
              };
            }
            goodsInfo.push(tempInfo);
          }
          this.quyuarr = data;
          this.GoodsParams = goodsInfo;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //获取销售单位
    getdanwei() {
      let that = this;

      var loginParams = {
        tableName: "tBDUnit",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;
          that.danwei = data;
          that.danwei.unshift({
            Id: 0,
            Name: "请选择"
          });
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //获取物流方式
    getwuliu() {
      let that = this;
      var loginParams = {
        tableName: "tbdlogisticsmode",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;
          that.wuliu = data;
          that.wuliu.unshift({
            Id: 0,
            Name: "请选择"
          });
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //颜色上传图片
    // upcolorimg(res, file) {
    //   var _this = this;
    //   let newcolorindex = _this.colorindex;
    //   var reader = new FileReader();
    //   reader.readAsDataURL(file[file.length - 1].raw);
    //   reader.onload = function(e) {
    //     _this.colorimg = e.target.result;

    //     let newcolorList = _this.colorList;
    //     for (var i = 0; i < newcolorList.length; i++) {
    //       if (i == newcolorindex) {
    //         newcolorList[i].ImgData = _this.colorimg;
    //       }
    //     }
    //   };
    // },
    imgchaun(index) {
      let that = this;
      that.colorindex = index;
    },

    //
    //首页产品图
    handleshouedetail(res, file) {
      var _this = this;

      var reader = new FileReader();
      reader.readAsDataURL(file[file.length - 1].raw);
      reader.onload = function(e) {
        let obj = {
          ImgName: "首页产品图片",
          ImgData: e.target.result,
          ImgType: 6
        };
        _this.indexImgUrlarr.push(obj);
      };
    },
    //详情页产品
    // handlesgoodstail(res, file) {
    //   var _this = this;
    //   var reader = new FileReader();
    //   reader.readAsDataURL(file[file.length - 1].raw);
    //   reader.onload = function(e) {
    //     let obj = {
    //       ImgName: "详情页产品图片",
    //       ImgData: e.target.result,
    //       ImgType: 1
    //     };
    //     _this.detailImgUrlarr.push(obj);
    //   };
    // },

    //应用效果
    handlexiaoguo(res, file) {
      var _this = this;
      var reader = new FileReader();
      reader.readAsDataURL(file[file.length - 1].raw);
      reader.onload = function(e) {
        let obj = {
          ImgName: "应用效果",
          ImgData: e.target.result,
          ImgType: 4
        };
        _this.xiaoguoImgUrlarr.push(obj);
      };
    },

    handlexijie(res, file) {
      var _this = this;
      var reader = new FileReader();
      reader.readAsDataURL(file[file.length - 1].raw);
      reader.onload = function(e) {
        let obj = {
          ImgName: "产品细节",
          ImgData: e.target.result,
          ImgType: 5
        };
        _this.xijieImgUrlarr.push(obj);
      };
    },
    //删除细节图片
    delxijieimg(val) {
      let newxijieImgUrlarr = this.xijieImgUrlarr;
      for (var i = 0; i < newxijieImgUrlarr.length; i++) {
        if (val == i) {
          newxijieImgUrlarr.splice(i, 1);
        }
      }

      this.xijieImgUrlarr = newxijieImgUrlarr;
    },
    //删除效果图
    delxiaoguo(val) {
      let newxiaoguoImgUrlarr = this.xiaoguoImgUrlarr;
      for (var i = 0; i < newxiaoguoImgUrlarr.length; i++) {
        if (val == i) {
          newxiaoguoImgUrlarr.splice(i, 1);
        }
      }

      this.xiaoguoImgUrlarr = newxiaoguoImgUrlarr;
    },

    //删除首页
    delshou(val) {
      let newindexImgUrlarr = this.indexImgUrlarr;
      for (var i = 0; i < newindexImgUrlarr.length; i++) {
        if (val == i) {
          newindexImgUrlarr.splice(i, 1);
        }
      }
      this.indexImgUrlarr = newindexImgUrlarr;
    },
    //验证是否为整数正则验证
    makeNumber(str) {
      var r = /^\+?[1-9][0-9]*$/; //正整数
      return r.test(str);
    },
    ishavedian(str) {
      var r = /^[0-9]+\.?[0-9]{0,2}$/; //两位小数
      return r.test(str);
    },

    // 保存
    editSubmit() {
      if (this.show == 1) {
        if (this.form.shichangprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入市场价"
          });
          return false;
        } else if(this.form.shichangprice<0.01||this.form.shichangprice>99999999.99){
          this.$swal({
            type: "warning",
            text: "请输入正确的市场价,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
          });
        } else if (this.form.tzprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入甄惠装价"
          });
          return false;
        } else if(this.form.tzprice<0.01||this.form.tzprice>99999999.99){
          this.$swal({
            type: "warning",
            text: "请输入正确的甄惠装价,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
          });
        } else if (this.form.yongjin < 8 || this.form.yongjin > 99) {
          this.$swal({
            type: "warning",
            text: "请输入佣金比例, 范围在 8%~99%"
          });
          return false;
        } else if (this.form.weistock == "") {
          this.$swal({
            type: "warning",
            text: "请输入库存"
          });
          return false;
        } else {
          this.addweigoods();
        }
      } else if (this.show == 2) {
        if (this.form.shichangprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入市场价"
          });
          return false;
        } else if(this.form.shichangprice<0.01||this.form.shichangprice>99999999.99){
          this.$swal({
            type: "warning",
            text: "请输入正确的市场价,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
          });
        } else if (this.form.tzprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入甄惠装价"
          });
          return false;
        } else if(this.form.tzprice<0.01||this.form.tzprice>99999999.99){
          this.$swal({
            type: "warning",
            text: "请输入正确的甄惠装价,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
          });
        } else if (this.form.yongjin < 8 || this.form.yongjin > 99) {
          this.$swal({
            type: "warning",
            text: "请输入佣金比例, 范围在 8%~99%"
          });
          return false;
        } else if (this.form.weistock == "") {
          this.$swal({
            type: "warning",
            text: "请输入库存"
          });
          return false;
        } else {
          this.addyangpin();
        }
      } else if (this.show == 3) {
        if (this.form.shichangprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入市场价"
          });
          return false;
        } else if(this.form.shichangprice<0.01||this.form.shichangprice>99999999.99){
          this.$swal({
            type: "warning",
            text: "请输入正确的市场价,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
          });
          }else if (this.form.tzprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入甄惠装价"
          });
          return false;
        } else if(this.form.tzprice<0.01||this.form.tzprice>99999999.99){
          this.$swal({
            type: "warning",
            text: "请输入正确的甄惠装价,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
          });
          } else if (this.form.yongjin < 8 || this.form.yongjin > 99) {
          this.$swal({
            type: "warning",
            text: "请输入佣金比例, 范围在 8%~99%"
          });
          return false;
        } else if (this.form.weistock == "") {
          this.$swal({
            type: "warning",
            text: "请输入库存"
          });
        } else if (this.ETime == "" || this.ETime == null) {
          this.$swal({
            type: "warning",
            text: "请输入截止日期"
          });
          return false;
        } else {
          this.addtemai();
        }
      } else if (this.show == 4) {
        if (this.form.shichangprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入市场价"
          });
        } else if (this.form.tzprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入截止日期"
          });
        } else if (this.form.yongjin < 8 || this.form.yongjin > 99) {
          this.$swal({
            type: "warning",
            text: "请输入佣金比例, 范围在 8%~99%"
          });
        } else if (this.form.weistock == "") {
          this.$swal({
            type: "warning",
            text: "请输入库存"
          });
        } else if (this.yuETime == "") {
          this.$swal({
            type: "warning",
            text: "请输入截止日期"
          });
        } else {
          this.tuangou();
        }
      } else if (this.show == 5) {
        if (this.form.shichangprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入市场价"
          });
        } else if (this.form.tzprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入甄惠装价"
          });
        } else if (this.form.yongjin < 8 || this.form.yongjin > 99) {
          this.$swal({
            type: "warning",
            text: "请输入佣金比例, 范围在 8%~99%"
          });
        } else if (this.form.weistock == "") {
          this.$swal({
            type: "warning",
            text: "请输入库存"
          });
        } else if (this.yuETime == "") {
          this.$swal({
            type: "warning",
            text: "请输入截止日期"
          });
        } else if (this.yuSTime == "") {
          this.$swal({
            type: "warning",
            text: "请输入发货起始日期"
          });
        } else {
          this.yushou();
        }
      } else if (this.show == 6) {
        if (this.form.shichangprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入市场价"
          });
        } else if (this.radio == 1 && this.money < 100) {
          this.$swal({
            type: "warning",
            text: "请输入内容大于100"
          });
        } else if (this.form.tzprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入甄惠装价"
          });
        } else if (this.form.yongjin < 8 || this.form.yongjin > 99) {
          this.$swal({
            type: "warning",
            text: "请输入佣金比例, 范围在 8%~99%"
          });
        } else if (this.form.weistock == "") {
          this.$swal({
            type: "warning",
            text: "请输入库存"
          });
        } else if (this.VipPrice == "") {
          this.$swal({
            type: "warning",
            text: "请输入vip价格"
          });
        } else if (this.Score == "") {
          this.$swal({
            type: "warning",
            text: "请输入积分"
          });
        } else if (this.SharingDays == "") {
          this.$swal({
            type: "warning",
            text: "请输入截请输入累计分享免费积分止日期"
          });
        } else {
          this.addvip();
        }
      } else {
        this.$swal({
          type: "warning",
          text: "请选择销售类型"
        });
      }
      this.getgoodlist();
    },

    // 编辑保存
    bianSubmit() {
      this.makeNumber();
      if (this.show == 1) {
       
        if (this.form.shichangprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入市场价"
          });
        }else if (this.form.shichangprice <0.01||this.form.shichangprice>99999999.99) {
          this.$swal({
            type: "warning",
            text: "请输入正确的市场价,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
          });
        }  else if (this.radio == 1 && this.money < 100) {
          this.$swal({
            type: "warning",
            text: "请输入内容大于100"
          });
        } else if (this.form.tzprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入甄惠装价"
          });
        }else if (this.form.tzprice <0.01||this.form.tzprice>99999999.99) {
          this.$swal({
            type: "warning",
            text: "请输入正确的甄惠装价,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
          });
        } else if (this.form.yongjin < 8 || this.form.yongjin > 99) {
          this.$swal({
            type: "warning",
            text: "请输入佣金比例, 范围在 8%~99%"
          });
        } else if (this.form.weistock == "") {
          this.$swal({
            type: "warning",
            text: "请输入库存"
          });
        } else {
          this.editweigoods();
        }
      }
      else if (this.show == 2) {
        if (this.form.shichangprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入市场价"
          });
        }else if (this.form.shichangprice <0.01||this.form.shichangprice>99999999.99) {
          this.$swal({
            type: "warning",
            text: "请输入正确的市场价,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
          });
        }  else if (this.radio == 1 && this.money < 100) {
          this.$swal({
            type: "warning",
            text: "请输入内容大于100"
          });
        } else if (this.form.tzprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入甄惠装价"
          });
        } else if (this.form.tzprice <0.01||this.form.tzprice>99999999.99) {
          this.$swal({
            type: "warning",
            text: "请输入正确的甄惠装价,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
          });
        } else if (this.form.yongjin < 8 || this.form.yongjin > 99) {
          this.$swal({
            type: "warning",
            text: "请输入佣金比例, 范围在 8%~99%"
          });
        } else if (this.form.weistock == "") {
          this.$swal({
            type: "warning",
            text: "请输入库存"
          });
        } else {
          this.edityangpin();
        }
      }
      else if (this.show == 3) {
        
        if (this.form.shichangprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入市场价"
          });
        } else if (this.form.shichangprice <0.01||this.form.shichangprice>99999999.99) {
          this.$swal({
            type: "warning",
            text: "请输入正确的市场价,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
          });
        } else if (this.radio == 1 && this.money < 100) {
          this.$swal({
            type: "warning",
            text: "请输入内容大于100"
          });
        } else if (this.form.tzprice == "") {
          this.$swal({
            type: "warning",
            text: "请输入甄惠装价"
          });
        } else if (this.form.tzprice <0.01||this.form.tzprice>99999999.99) {
          this.$swal({
            type: "warning",
            text: "请输入正确的甄惠装价,范围应在 ￥0.01～99999999.99,并且只能保留两位小数"
          });
        } else if (this.form.yongjin < 8 || this.form.yongjin > 99) {
          this.$swal({
            type: "warning",
            text: "请输入佣金比例, 范围在 8%~99%"
          });
        } else if (this.form.weistock == "") {
          this.$swal({
            type: "warning",
            text: "请输入库存"
          });
        } else if (this.ETime == "" || this.ETime == null) {
          this.$swal({
            type: "warning",
            text: "请输入截止日期"
          });
        } else {
          this.edittemai();
        }
      }
      else if (this.show == 4) {
        if (this.form.shichangprice == "") {
          this.$notify.error({
            title: "错误",
            message: "请输入市场价"
          });
        } else if (this.radio == 1 && this.money < 100) {
          this.$notify.error({
            title: "错误",
            message: "请输入内容大于100"
          });
        } else if (this.form.tzprice == "") {
          this.$notify.error({
            title: "错误",
            message: "请输入甄惠装价"
          });
        } else if (this.form.yongjin < 8 || this.form.yongjin > 99) {
          this.$notify.error({
            title: "错误",
            message: "请输入佣金比例, 范围在 8%~99%"
          });
        } else if (this.form.weistock == "") {
          this.$notify.error({
            title: "错误",
            message: "请输入库存"
          });
        } else if (this.ETime == "") {
          this.$notify.error({
            title: "错误",
            message: "请输入截止日期"
          });
        } else {
          this.tuangou();
        }
      } else if (this.show == 5) {
        if (this.form.shichangprice == "") {
          this.$notify.error({
            title: "错误",
            message: "请输入市场价"
          });
        } else if (this.radio == 1 && this.money < 100) {
          this.$notify.error({
            title: "错误",
            message: "请输入内容大于100"
          });
        } else if (this.form.tzprice == "") {
          this.$notify.error({
            title: "错误",
            message: "请输入甄惠装价"
          });
        } else if (this.form.yongjin < 8 || this.form.yongjin > 99) {
          this.$notify.error({
            title: "错误",
            message: "请输入佣金比例, 范围在 8%~99%"
          });
        } else if (this.form.weistock == "") {
          this.$notify.error({
            title: "错误",
            message: "请输入库存"
          });
        } else if (this.yuETime == "") {
          this.$notify.error({
            title: "错误",
            message: "请输入截止日期"
          });
        } else if (this.yuSTime == "") {
          this.$notify.error({
            title: "错误",
            message: "请输入发货起始日期"
          });
        } else {
          this.edityushou();
        }
      } else if (this.show == 6) {
        if (this.form.shichangprice == "") {
          this.$notify.error({
            title: "错误",
            message: "请输入市场价"
          });
        } else if (this.radio == 1 && this.money < 100) {
          this.$notify.error({
            title: "错误",
            message: "请输入内容大于100"
          });
        } else if (this.form.tzprice == "") {
          this.$notify.error({
            title: "错误",
            message: "请输入甄惠装价"
          });
        } else if (this.form.yongjin < 8 || this.form.yongjin > 99) {
          this.$notify.error({
            title: "错误",
            message: "请输入佣金比例, 范围在 8%~99%"
          });
        } else if (this.form.weistock == "") {
          this.$notify.error({
            title: "错误",
            message: "请输入库存"
          });
        } else if (this.VipPrice == "") {
          this.$notify.error({
            title: "错误",
            message: "请输入vip价格"
          });
        } else if (this.Score == "") {
          this.$notify.error({
            title: "错误",
            message: "请输入积分"
          });
        } else if (this.SharingDays == "") {
          this.$notify.error({
            title: "错误",
            message: "请输入累计分享免费积分"
          });
        } else {
          this.editvip();
        }
      }

      // this.editgoodsimgs = [];
      // this.indexImgUrlarr = [];
      // this.detailImgUrlarr = [];
      // this.youImgUrlarr = [];
      // this.xiaoguoImgUrlarr = [];
      // this.xijieImgUrlarr = [];
      // this.colorList = [];
    },

    newbianSubmit() {
      if (this.show == 1) {
        this.editweigoods();
      } else if (this.show == 2) {
        this.edityangpin();
      } else if (this.show == 3) {
        this.edittemai();
      } else if (this.show == 4) {
        this.tuangou();
      } else if (this.show == 5) {
        this.edityushou();
      } else if (this.show == 6) {
        this.editvip();
      }
    },

    attention() {
      let that = this;
      if (that.newpinleiId == "") {
        this.$swal({
          type: "warning",
          text: "请选择品类"
        });

        return false;
      } else if (that.newpinpaiId == "") {
        this.$swal({
          type: "warning",
          text: "请选择品牌"
        });
        return false;
      } else if (that.GoodModelCode == "") {
        this.$swal({
          type: "warning",
          text: "请输入产品型号"
        });
        return false;
      } else if (that.newprovinceId == "") {
        this.$swal({
          type: "warning",
          text: "请选择省"
        });
        return false;
      } else if (that.newcityId == "") {
        this.$swal({
          type: "warning",
          text: "请选择市"
        });
        return false;
      } else if (that.detailImgUrlarr.length == 0) {
        this.$swal({
          type: "warning",
          text: "请上传详情页产品图片"
        });
        return false;
      } else if (that.Title == "") {
        this.$swal({
          type: "warning",
          text: "请输入标题"
        });
        return false;
      }
      for (var i = 0; i < this.colorList.length; i++) {
        if (this.colorList[i].ImgName == "") {
          this.$swal({
            type: "warning",
            text: "请输入颜色名名称"
          });
          return false;
        }
      }
      if (that.form.weistock == "") {
        this.$swal({
          type: "warning",
          text: "请输入库存"
        });
        return false;
      }else if(that.form.weistock<1){
        this.$swal({
          type: "warning",
          text: "请输入正确的库存，并且要是(1~99999999)正整数"
        });
        return false;
      } else if (that.danweiId == "") {
        this.$swal({
          type: "warning",
          text: "请选择单位"
        });
        return false;
        // } else if (that.Remark == "") {
        //   this.$notify({
        //     title: "错误",
        //     message: "请输入备注",
        //     type: "warning"
        //   });
        //   return false;
        // } else if (that.wuliuId == "") {
        //   this.$notify({
        //     title: "错误",
        //     message: "请选择物流方式",
        //     type: "warning"
        //   });
        //   return false;
        // } else if (that.FreightDesc == "") {
        //   this.$notify({
        //     title: "错误",
        //     message: "请输入运费说明",
        //     type: "warning"
        //   });
        //   return false;
        // } else if (that.GoodsParams == "") {
        //   this.$notify({
        //     title: "错误",
        //     message: "请填写商品参数",
        //     type: "warning"
        //   });
        //   return false;
        // } else if (that.youImgUrlarr.length == 0) {
        //   this.$notify({
        //     title: "错误",
        //     message: "请上传产品优势图片",
        //     type: "warning"
        //   });
        //   return false;
        // } else if (that.shoplist.length == 0) {
        //   this.$notify({
        //     title: "错误",
        //     message: "请添加店面信息",
        //     type: "warning"
        //   });
        //   return false;
        // } else if (that.AfterPolicy == "") {
        //   this.$notify({
        //     title: "错误",
        //     message: "请输入售后政策",
        //     type: "warning"
        //   });
        //   return false;
        // } else if (that.NeedAttention == "") {
        //   this.$notify({
        //     title: "错误",
        //     message: "请输入注意事项",
        //     type: "warning"
        //   });
        return false;
      } else if (that.colorList.length == 0) {
        this.$swal({
          type: "warning",
          text: "请添加商品颜色"
        });
        return false;
      } else {
        return true;
      }
    },

    //新增商品 尾贷管理
    addweigoods() {
      this.loading2 = true;
      NProgress.start();
      let that = this;
      let GoodsImgs = [];
      let newindexImgUrlarr = that.indexImgUrlarr;
      let newdetailImgUrlarr = that.detailImgUrlarr;
      let newyouImgUrlarr = that.youImgUrlarr;
      let newxiaoguoImgUrlarr = that.xiaoguoImgUrlarr;
      let newxijieImgUrlarr = that.xijieImgUrlarr;
      let newjianceImgUrlarr = that.jianceImgUrlarr;
      let newcolorList = that.colorList;
      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        GoodsImgs.push(newdetailImgUrlarr[i]);
      }

      for (var i = 0; i < newyouImgUrlarr.length; i++) {
        GoodsImgs.push(newyouImgUrlarr[i]);
      }
      for (var i = 0; i < newxiaoguoImgUrlarr.length; i++) {
        GoodsImgs.push(newxiaoguoImgUrlarr[i]);
      }
      for (var i = 0; i < newxijieImgUrlarr.length; i++) {
        GoodsImgs.push(newxijieImgUrlarr[i]);
      }
      for (var i = 0; i < newcolorList.length; i++) {
        GoodsImgs.push(newcolorList[i]);
      }
      for (var i = 0; i < newjianceImgUrlarr.length; i++) {
        GoodsImgs.push(newjianceImgUrlarr[i]);
      }
        GoodsImgs.unshift({ImgData:that.firstDetail.length?that.firstDetail.split(',')[0]:that.detailImgUrlarr[0].ImgData,ImgType:6})

      let goodsinfo = {};
      goodsinfo.CustomizeParams = that.othertable;
      goodsinfo.GoodModelCode = that.GoodModelCode;
      goodsinfo.BrandTypeId = that.newpinleiId;
      goodsinfo.BrandId = that.newpinpaiId;
      goodsinfo.ProvinceId = that.newprovinceId;
      goodsinfo.BbId = that.BbId;
      goodsinfo.CityId = that.newcityId;
      goodsinfo.Title = that.Title;
      goodsinfo.Slogan = that.Slogan;
      goodsinfo.Advantage = that.Advantage;
      goodsinfo.SaleUnitId = that.danweiId;
      goodsinfo.Remark = that.Remark;
      goodsinfo.LogisticsModeId = that.wuliuId;
      goodsinfo.FreightDesc = that.FreightDesc;
      goodsinfo.GoodsImgs = GoodsImgs;
      goodsinfo.GoodsStores = that.shoplist;
      goodsinfo.GoodsParams = that.GoodsParams;
      goodsinfo.AfterPolicy = that.AfterPolicy;
      goodsinfo.NeedAttention = that.NeedAttention;
      goodsinfo.GoodActiveId = 1;
      goodsinfo.ActiveGoodsTypeId = 1;
      goodsinfo.OperatorId = that.$cookie.get("OperatorId");
      (goodsinfo.isUseCoupon = that.radio),
      (goodsinfo.couponCondtion = Number(that.money));
      if (that.attention()) {
        this.loading = true;
        var addParams = {
          MarketPrice: that.form.shichangprice,
          TzrPrice: that.form.tzprice,
          Stock: that.form.weistock,
          CostRate: that.form.yongjin,
          GoodsInfo: goodsinfo
        };

        // 发送 POST 请求
        this.$http({
          method: "post",
          url: localStorage.BaseUrl + "/goodsService/TailCargo/InsertTailCargo",
          data: addParams,
          headers: { "Content-Type": "application/json; charset=UTF-8" }
        })
          .then(res => {
            this.loading = false;
            NProgress.done();
            this.loading2 = false;
            if (res.data.ResultCode == 1) {
              this.$swal({
                type: "success",
                text: "添加成功"
              });
              if (this.$route.query.id == 1) {
                this.$router.push({
                  path: "/tail"
                });
              } else if (this.$route.query.id == 2) {
                this.$router.push({
                  path: "/sample"
                });
              } else if (this.$route.query.id == 3) {
                this.$router.push({
                  path: "/specialSale"
                });
              }

              that.isNext = false;
              that.isAdd = false;
              that.isGoods = true;
              that.editgoodsimgs = [];
              that.indexImgUrlarr = [];
              that.detailImgUrlarr = [];
              that.youImgUrlarr = [];
              that.xiaoguoImgUrlarr = [];
              that.xijieImgUrlarr = [];
              that.jianceImgUrlarr = [];
              that.colorList = [];
              that.getgoodlist();
            }
          })
          .catch(err => {
            NProgress.done();
            this.loading2 = false;
            this.$swal({
              type: "error",
              text: err.data.ResultMsg
            });
          });
      }
    },
    //新增商品 样品管理
    addyangpin() {
      this.loading2 = true;
      NProgress.start();
      let that = this;
      let GoodsImgs = [];
      let newindexImgUrlarr = that.indexImgUrlarr;
      let newdetailImgUrlarr = that.detailImgUrlarr;
      let newyouImgUrlarr = that.youImgUrlarr;
      let newxiaoguoImgUrlarr = that.xiaoguoImgUrlarr;
      let newxijieImgUrlarr = that.xijieImgUrlarr;
      let newjianceImgUrlarr = that.jianceImgUrlarr;
      let newcolorList = that.colorList;

      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        GoodsImgs.push(newdetailImgUrlarr[i]);
      }

      for (var i = 0; i < newyouImgUrlarr.length; i++) {
        GoodsImgs.push(newyouImgUrlarr[i]);
      }
      for (var i = 0; i < newxiaoguoImgUrlarr.length; i++) {
        GoodsImgs.push(newxiaoguoImgUrlarr[i]);
      }
      for (var i = 0; i < newxijieImgUrlarr.length; i++) {
        GoodsImgs.push(newxijieImgUrlarr[i]);
      }
      for (var i = 0; i < newcolorList.length; i++) {
        GoodsImgs.push(newcolorList[i]);
      }
      for (var i = 0; i < newjianceImgUrlarr.length; i++) {
        GoodsImgs.push(newjianceImgUrlarr[i]);
      }
        GoodsImgs.unshift({ImgData:that.firstDetail.length?that.firstDetail.split(',')[0]:that.detailImgUrlarr[0].ImgData,ImgType:6})
      let goodsinfo = {};
      goodsinfo.CustomizeParams = that.othertable;
      goodsinfo.GoodModelCode = that.GoodModelCode;
      goodsinfo.BrandTypeId = that.newpinleiId;
      goodsinfo.BrandId = that.newpinpaiId;
      goodsinfo.ProvinceId = that.newprovinceId;
      goodsinfo.BbId = that.BbId;
      goodsinfo.CityId = that.newcityId;
      goodsinfo.Title = that.Title;
      goodsinfo.Slogan = that.Slogan;
      goodsinfo.Advantage = that.Advantage;
      goodsinfo.SaleUnitId = that.danweiId;
      goodsinfo.Remark = that.Remark;
      goodsinfo.LogisticsModeId = that.wuliuId;
      goodsinfo.FreightDesc = that.FreightDesc;
      goodsinfo.GoodsImgs = GoodsImgs;
      goodsinfo.GoodsStores = that.shoplist;
      goodsinfo.GoodsParams = that.GoodsParams;
      goodsinfo.AfterPolicy = that.AfterPolicy;
      goodsinfo.NeedAttention = that.NeedAttention;
      goodsinfo.GoodActiveId = 1;
      goodsinfo.ActiveGoodsTypeId = 1;
      goodsinfo.OperatorId = that.$cookie.get("OperatorId");
      (goodsinfo.isUseCoupon = that.radio),
        (goodsinfo.couponCondtion = Number(that.money));
      if (that.attention()) {
        var addParams = {
          MarketPrice: that.form.shichangprice,
          TzrPrice: that.form.tzprice,
          Stock: that.form.weistock,
          CostRate: that.form.yongjin,
          GoodsInfo: goodsinfo
        };

        // 发送 POST 请求
        this.$http({
          method: "post",
          url: localStorage.BaseUrl + "/goodsService/Sample/InsertSample",
          data: addParams,
          headers: { "Content-Type": "text/plain; charset=UTF-8" }
        })
          .then(res => {
            NProgress.done();
            this.loading2 = false;
            if (res.data.ResultCode == 1) {
              this.$swal({
                type: "success",
                text: "添加成功"
              });
              if (this.$route.query.id == 1) {
                this.$router.push({
                  path: "/tail"
                });
              } else if (this.$route.query.id == 2) {
                this.$router.push({
                  path: "/sample"
                });
              } else if (this.$route.query.id == 3) {
                this.$router.push({
                  path: "/specialSale"
                });
              }
              that.isNext = false;
              that.isAdd = false;
              that.isGoods = true;
              that.editgoodsimgs = [];
              that.indexImgUrlarr = [];
              that.detailImgUrlarr = [];
              that.youImgUrlarr = [];
              that.xiaoguoImgUrlarr = [];
              that.xijieImgUrlarr = [];
              that.jianceImgUrlarr = [];
              that.colorList = [];
              that.getgoodlist();
            }
          })
          .catch(err => {
            NProgress.done();
            this.loading2 = false;
            this.$swal({
              type: "error",
              text: err.data.ResultMsg
            });
          });
      }
    },
    p(s) {
      return s < 10 ? "0" + s : s;
    },
    //新增特卖管理
    addtemai() {
      this.loading2 = true;
      NProgress.start();
      let that = this;
      let GoodsImgs = [];
      let newindexImgUrlarr = that.indexImgUrlarr;
      let newdetailImgUrlarr = that.detailImgUrlarr;
      let newyouImgUrlarr = that.youImgUrlarr;
      let newxiaoguoImgUrlarr = that.xiaoguoImgUrlarr;
      let newxijieImgUrlarr = that.xijieImgUrlarr;
      let newjianceImgUrlarr = that.jianceImgUrlarr;
      let newcolorList = that.colorList;


      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        GoodsImgs.push(newdetailImgUrlarr[i]);
      }

      for (var i = 0; i < newyouImgUrlarr.length; i++) {
        GoodsImgs.push(newyouImgUrlarr[i]);
      }
      for (var i = 0; i < newxiaoguoImgUrlarr.length; i++) {
        GoodsImgs.push(newxiaoguoImgUrlarr[i]);
      }
      for (var i = 0; i < newxijieImgUrlarr.length; i++) {
        GoodsImgs.push(newxijieImgUrlarr[i]);
      }
      for (var i = 0; i < newcolorList.length; i++) {
        GoodsImgs.push(newcolorList[i]);
      }
      for (var i = 0; i < newjianceImgUrlarr.length; i++) {
        GoodsImgs.push(newjianceImgUrlarr[i]);
      }
        GoodsImgs.unshift({ImgData:that.firstDetail.length?that.firstDetail.split(',')[0]:that.detailImgUrlarr[0].ImgData,ImgType:6})

        let goodsinfo = {};
      goodsinfo.CustomizeParams = that.othertable;
      goodsinfo.GoodModelCode = that.GoodModelCode;
      goodsinfo.BrandTypeId = that.newpinleiId;
      goodsinfo.BrandId = that.newpinpaiId;
      goodsinfo.ProvinceId = that.newprovinceId;
      goodsinfo.BbId = that.BbId;
      goodsinfo.CityId = that.newcityId;
      goodsinfo.Title = that.Title;
      goodsinfo.Slogan = that.Slogan;
      goodsinfo.Advantage = that.Advantage;
      goodsinfo.SaleUnitId = that.danweiId;
      goodsinfo.Remark = that.Remark;
      goodsinfo.LogisticsModeId = that.wuliuId;
      goodsinfo.FreightDesc = that.FreightDesc;
      goodsinfo.GoodsImgs = GoodsImgs;
      goodsinfo.GoodsStores = that.shoplist;
      goodsinfo.GoodsParams = that.GoodsParams;
      goodsinfo.AfterPolicy = that.AfterPolicy;
      goodsinfo.NeedAttention = that.NeedAttention;
      goodsinfo.GoodActiveId = 1;
      goodsinfo.ActiveGoodsTypeId = 1;
      goodsinfo.OperatorId = that.$cookie.get("OperatorId");
      (goodsinfo.isUseCoupon = that.radio),
        (goodsinfo.couponCondtion = Number(that.money));
      // if (this.ETime != "") {
      //   var date1 =
      //     this.ETime.getFullYear() +
      //     "-" +
      //     this.p(this.ETime.getMonth() + 1) +
      //     "-" +
      //     this.p(this.ETime.getDate());
      // } else {
      //   var date1 = "";
      // }
      if (that.attention()) {
        var addParams = {
          MarketPrice: that.form.shichangprice,
          TzrPrice: that.form.tzprice,
          Stock: that.form.weistock,
          CostRate: that.form.yongjin,
          ETime: this.ETime,
          GoodsInfo: goodsinfo
        };

        // GoodsImgs = JSON.parse(GoodsImgs);

        this.$http({
          method: "post",
          url: localStorage.BaseUrl + "/goodsService/SpecialSale/InsertSpecialSale",
          data: addParams,
          headers: { "Content-Type": "text/plain; charset=UTF-8" }
        })
          .then(res => {
            NProgress.done();
            this.loading2 = false;
            if (res.data.ResultCode == 1) {
              this.$swal({
                type: "success",
                text: "添加成功"
              });
              if (this.$route.query.id == 1) {
                this.$router.push({
                  path: "/tail"
                });
              } else if (this.$route.query.id == 2) {
                this.$router.push({
                  path: "/sample"
                });
              } else if (this.$route.query.id == 3) {
                this.$router.push({
                  path: "/specialSale"
                });
              }
              this.getgoodlist();
              that.isNext = false;
              that.isAdd = false;
              that.isGoods = true;
              that.editgoodsimgs = [];
              that.indexImgUrlarr = [];
              that.detailImgUrlarr = [];
              that.youImgUrlarr = [];
              that.xiaoguoImgUrlarr = [];
              that.xijieImgUrlarr = [];
              thai.jianceImgUrlarr = [];
              that.colorList = [];
              that.getgoodlist();
            }
          })
          .catch(err => {
            this.loading2 = false;
            NProgress.done();
            this.$swal({
              type: "error",
              text: err.data.ResultMsg
            });
          });
      }
    },
    //新增团购
    tuangou() {
      let that = this;
      let GoodsImgs = [];
      let newindexImgUrlarr = that.indexImgUrlarr;
      let newdetailImgUrlarr = that.detailImgUrlarr;
      let newyouImgUrlarr = that.youImgUrlarr;
      let newxiaoguoImgUrlarr = that.xiaoguoImgUrlarr;
      let newxijieImgUrlarr = that.xijieImgUrlarr;
      let newcolorList = that.colorList;

      for (var i = 0; i < newindexImgUrlarr.length; i++) {
        GoodsImgs.push(newindexImgUrlarr[i]);
      }
      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        GoodsImgs.push(newdetailImgUrlarr[i]);
      }

      for (var i = 0; i < newyouImgUrlarr.length; i++) {
        GoodsImgs.push(newyouImgUrlarr[i]);
      }
      for (var i = 0; i < newxiaoguoImgUrlarr.length; i++) {
        GoodsImgs.push(newxiaoguoImgUrlarr[i]);
      }
      for (var i = 0; i < newxijieImgUrlarr.length; i++) {
        GoodsImgs.push(newxijieImgUrlarr[i]);
      }
      for (var i = 0; i < newjianceImgUrlarr.length; i++) {
        GoodsImgs.push(newjianceImgUrlarr[i]);
      }
      let goodsinfo = {};
      goodsinfo.GoodModelCode = that.GoodModelCode;
      goodsinfo.BrandTypeId = that.newpinleiId;
      goodsinfo.BrandId = that.newpinpaiId;
      goodsinfo.ProvinceId = that.newprovinceId;
      goodsinfo.BbId = that.BbId;
      goodsinfo.CityId = that.newcityId;
      goodsinfo.Title = that.Title;
      goodsinfo.Slogan = that.Slogan;
      goodsinfo.Advantage = that.Advantage;
      goodsinfo.SaleUnitId = that.danweiId;
      goodsinfo.Remark = that.Remark;
      goodsinfo.LogisticsModeId = that.wuliuId;
      goodsinfo.FreightDesc = that.FreightDesc;
      goodsinfo.GoodsImgs = GoodsImgs;
      goodsinfo.GoodsStores = that.shoplist;
      goodsinfo.GoodsParams = that.GoodsParams;
      goodsinfo.AfterPolicy = that.AfterPolicy;
      goodsinfo.NeedAttention = that.NeedAttention;
      goodsinfo.GoodActiveId = 1;
      goodsinfo.ActiveGoodsTypeId = 1;
      goodsinfo.OperatorId = that.$cookie.get("OperatorId");
      if (this.ETime != "") {
        var date1 =
          this.ETime.getFullYear() +
          "-" +
          this.p(this.ETime.getMonth() + 1) +
          "-" +
          this.p(this.ETime.getDate());
      } else {
        var date1 = "";
      }
      // GoodsImgs = JSON.parse(GoodsImgs);

      var addParams = {
        MarketPrice: that.form.shichangprice,
        TzrPrice: that.form.tzprice,
        Stock: that.form.weistock,
        CostRate: that.form.yongjin,
        ETime: date1,
        GoodsInfo: goodsinfo
      };
      NProgress.start();
      this.$http({
        method: "post",
        url: localStorage.BaseUrl + "/goodsService/GroupBuy/InsertGroupBuy",
        data: addParams,
        headers: { "Content-Type": "text/plain; charset=UTF-8" }
      })
        .then(res => {
          this.$swal({
            type: "success",
            text: "添加成功"
          });
          NProgress.done();
        })
        .catch(err => {
          NProgress.done();
        });
    },
    yushou() {
      this.loading2 = true;
      let that = this;
      let GoodsImgs = [];
      let newindexImgUrlarr = that.indexImgUrlarr;
      let newdetailImgUrlarr = that.detailImgUrlarr;
      let newyouImgUrlarr = that.youImgUrlarr;
      let newxiaoguoImgUrlarr = that.xiaoguoImgUrlarr;
      let newxijieImgUrlarr = that.xijieImgUrlarr;
      let newjianceImgUrlarr = that.jianceImgUrlarr;
      let newcolorList = that.colorList;

      for (var i = 0; i < newindexImgUrlarr.length; i++) {
        GoodsImgs.push(newindexImgUrlarr[i]);
      }
      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        GoodsImgs.push(newdetailImgUrlarr[i]);
      }

      for (var i = 0; i < newyouImgUrlarr.length; i++) {
        GoodsImgs.push(newyouImgUrlarr[i]);
      }
      for (var i = 0; i < newxiaoguoImgUrlarr.length; i++) {
        GoodsImgs.push(newxiaoguoImgUrlarr[i]);
      }
      for (var i = 0; i < newxijieImgUrlarr.length; i++) {
        GoodsImgs.push(newxijieImgUrlarr[i]);
      }
      for (var i = 0; i < newcolorList.length; i++) {
        GoodsImgs.push(newcolorList[i]);
      }
      for (var i = 0; i < newjianceImgUrlarr.length; i++) {
        GoodsImgs.push(newjianceImgUrlarr[i]);
      }
      let goodsinfo = {};
      goodsinfo.CustomizeParams = that.othertable;
      goodsinfo.GoodModelCode = that.GoodModelCode;
      goodsinfo.BrandTypeId = that.newpinleiId;
      goodsinfo.BrandId = that.newpinpaiId;
      goodsinfo.ProvinceId = that.newprovinceId;
      goodsinfo.BbId = that.BbId;
      goodsinfo.CityId = that.newcityId;
      goodsinfo.Title = that.Title;
      goodsinfo.Slogan = that.Slogan;
      goodsinfo.Advantage = that.Advantage;
      goodsinfo.SaleUnitId = that.danweiId;
      goodsinfo.Remark = that.Remark;
      goodsinfo.LogisticsModeId = that.wuliuId;
      goodsinfo.FreightDesc = that.FreightDesc;
      goodsinfo.GoodsImgs = GoodsImgs;
      goodsinfo.GoodsStores = that.shoplist;
      goodsinfo.GoodsParams = that.GoodsParams;
      goodsinfo.AfterPolicy = that.AfterPolicy;
      goodsinfo.NeedAttention = that.NeedAttention;
      goodsinfo.GoodActiveId = 1;
      goodsinfo.ActiveGoodsTypeId = 1;
      goodsinfo.OperatorId = that.$cookie.get("OperatorId");
      (goodsinfo.isUseCoupon = that.radio),
        (goodsinfo.couponCondtion = Number(that.money));
      if (this.yuSTime != "") {
        var date1 =
          this.yuSTime.getFullYear() +
          "-" +
          this.p(this.yuSTime.getMonth() + 1) +
          "-" +
          this.p(this.yuSTime.getDate());
      } else {
        var date1 = "";
      }
      if (this.yuETime != "") {
        var date2 =
          this.yuETime.getFullYear() +
          "-" +
          this.p(this.yuETime.getMonth() + 1) +
          "-" +
          this.p(this.yuETime.getDate());
      } else {
        var date2 = "";
      }
      // GoodsImgs = JSON.parse(GoodsImgs);

      if (that.attention()) {
        var addParams = {
          MarketPrice: that.form.shichangprice,
          TzrPrice: that.form.tzprice,
          Stock: that.form.weistock,
          CostRate: that.form.yongjin,
          STime: date1,
          ETime: date2,
          GoodsInfo: goodsinfo
        };

        // GoodsImgs = JSON.parse(GoodsImgs);
        NProgress.start();
        this.$http({
          method: "post",
          url: localStorage.BaseUrl + "/goodsService/AdvanceSale/InsertAdvanceSale",
          data: addParams,
          headers: { "Content-Type": "text/plain; charset=UTF-8" }
        })
          .then(res => {
            this.loading2 = false;
            NProgress.done();
            this.$swal({
              type: "success",
              text: "添加成功"
            });
            that.isNext = false;
            that.isAdd = false;
            that.isGoods = true;
            that.editgoodsimgs = [];
            that.indexImgUrlarr = [];
            that.detailImgUrlarr = [];
            that.youImgUrlarr = [];
            that.xiaoguoImgUrlarr = [];
            that.xijieImgUrlarr = [];
            that.jianceImgUrlarr = [];
            that.colorList = [];
            that.getgoodlist();
          })
          .catch(err => {
            this.loading2 = false;
            NProgress.done();
            this.$notify.error({
              title: "错误",
              message: err.data.ResultMsg
            });
          });
      }
    },
    addvip() {
      this.loading2 = true;
      let that = this;
      let GoodsImgs = [];
      let newindexImgUrlarr = that.indexImgUrlarr;
      let newdetailImgUrlarr = that.detailImgUrlarr;
      let newyouImgUrlarr = that.youImgUrlarr;
      let newxiaoguoImgUrlarr = that.xiaoguoImgUrlarr;
      let newxijieImgUrlarr = that.xijieImgUrlarr;
      let newjianceImgUrlarr = that.jianceImgUrlarr;
      let newcolorList = that.colorList;

      for (var i = 0; i < newindexImgUrlarr.length; i++) {
        GoodsImgs.push(newindexImgUrlarr[i]);
      }
      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        GoodsImgs.push(newdetailImgUrlarr[i]);
      }

      for (var i = 0; i < newyouImgUrlarr.length; i++) {
        GoodsImgs.push(newyouImgUrlarr[i]);
      }
      for (var i = 0; i < newxiaoguoImgUrlarr.length; i++) {
        GoodsImgs.push(newxiaoguoImgUrlarr[i]);
      }
      for (var i = 0; i < newxijieImgUrlarr.length; i++) {
        GoodsImgs.push(newxijieImgUrlarr[i]);
      }
      for (var i = 0; i < newcolorList.length; i++) {
        GoodsImgs.push(newcolorList[i]);
      }
      for (var i = 0; i < newjianceImgUrlarr.length; i++) {
        GoodsImgs.push(newjianceImgUrlarr[i]);
      }
      let goodsinfo = {};
      goodsinfo.CustomizeParams = that.othertable;
      goodsinfo.GoodModelCode = that.GoodModelCode;
      goodsinfo.BrandTypeId = that.newpinleiId;
      goodsinfo.BrandId = that.newpinpaiId;
      goodsinfo.ProvinceId = that.newprovinceId;
      goodsinfo.BbId = that.BbId;
      goodsinfo.CityId = that.newcityId;
      goodsinfo.Title = that.Title;
      goodsinfo.Slogan = that.Slogan;
      goodsinfo.Advantage = that.Advantage;
      goodsinfo.SaleUnitId = that.danweiId;
      goodsinfo.Remark = that.Remark;
      goodsinfo.LogisticsModeId = that.wuliuId;
      goodsinfo.FreightDesc = that.FreightDesc;
      goodsinfo.GoodsImgs = GoodsImgs;
      goodsinfo.GoodsStores = that.shoplist;
      goodsinfo.GoodsParams = that.GoodsParams;
      goodsinfo.AfterPolicy = that.AfterPolicy;
      goodsinfo.NeedAttention = that.NeedAttention;
      goodsinfo.GoodActiveId = 1;
      goodsinfo.ActiveGoodsTypeId = 1;
      goodsinfo.OperatorId = that.$cookie.get("OperatorId");
      (goodsinfo.isUseCoupon = that.radio),
        (goodsinfo.couponCondtion = Number(that.money));
      if (that.attention()) {
        var addParams = {
          MarketPrice: that.form.shichangprice,
          TzrPrice: that.form.tzprice,
          Stock: that.form.weistock,
          CostRate: that.form.yongjin,
          GoodsInfo: goodsinfo,
          VipPrice: that.VipPrice,
          Score: that.Score,
          SharingDays: that.SharingDays
        };
        NProgress.start();
        // 发送 POST 请求
        this.$http({
          method: "post",
          url: localStorage.BaseUrl + "/goodsService/VipGoods/InsertVipGoods",
          data: addParams,
          headers: { "Content-Type": "text/plain; charset=UTF-8" }
        })
          .then(res => {
            NProgress.done();
            this.loading2 = false;
            this.$swal({
              type: "success",
              text: "添加成功"
            });
            that.isNext = false;
            that.isAdd = false;
            that.isGoods = true;
            that.editgoodsimgs = [];
            that.indexImgUrlarr = [];
            that.detailImgUrlarr = [];
            that.youImgUrlarr = [];
            that.xiaoguoImgUrlarr = [];
            that.xijieImgUrlarr = [];
            that.jianceImgUrlarr = [];
            that.colorList = [];
            that.getgoodlist();
          }).catch(err => {
            this.loading2 = false;
            NProgress.done();
            this.$notify.error({
              title: "错误",
              message: err.data.ResultMsg
            });
          });
      }
    },

    // 修改商品信息
    endEdit(scope) {
      if (localStorage.BbId == 0) {
        this.$swal({
          type: "warning",
          text: "您所属的品牌商无法编辑信息"
        });
      } else {
        this.getnewgoodpinpai();
        // this.loading3 = true
        if (this.othertable.length >= 10) {
          this.addothers = false;
        }
        let that = this;
        this.editgoodsimgs = [];
        this.indexImgUrlarr = [];
        this.detailImgUrlarr = [];
        this.youImgUrlarr = [];
        this.xiaoguoImgUrlarr = [];
        this.xijieImgUrlarr = [];
        this.jianceImgUrlarr = [];
        this.colorList = [];
        that.editgoodsid = scope.Id;
        if (scope.Id) {
          var loginParams = {
            goodsId: scope.Id
          };
        } else {
          var loginParams = {
            goodsId: scope
          };
        }
        // 编辑回显数据接口
        chagoodinfo(loginParams).then(data => {
          this.detailImgIdarr=[];
          this.youImgIdarr=[];
          this.jianceImgIdarr=[];
          data.ResultObj.GoodsInfo.GoodsImgs.filter((item,index) => {
            if(item.ImgType==1){
              this.detailImgIdarr.push(item.Id)
            }
            if(item.ImgType==3){
              this.youImgIdarr.push(item.Id)
            }
            if(item.ImgType==7){
              this.jianceImgIdarr.push(item.Id)
            }
          })
          let GoodsInfo = data.ResultObj.GoodsInfo;
          that.options = data.ResultObj.GoodsInfo.GoodActiveId;
          let date = data.ResultObj.GoodsInfo.GoodActiveId;
          this.isAdd = true;
          this.isGoods = false;
          this.shownew = false;
          let newgoodparams = GoodsInfo.GoodsParamsModel_Inserts;
          let goodparams = GoodsInfo.GoodsParamsModel_Inserts;
          // this.detailImgIdarr = data.ResultObj.GoodsInfo.ImgIds? data.ResultObj.GoodsInfo.ImgIds.split(','):[] // 字符串转换数组并保存详情图片id
          this.flag = this.detailImgIdarr.length
          // this.youImgIdarr = data.ResultObj.GoodsInfo.PImgs?data.ResultObj.GoodsInfo.PImgs.split(','):[] // 产品优势图片id
          this.flag2 = this.youImgIdarr.length
          // this.jianceImgIdarr = data.ResultObj.GoodsInfo.CerImgs?data.ResultObj.GoodsInfo.CerImgs.split(','):[] // 产品检测图片id
          this.flag3 = this.jianceImgIdarr.length

          let goodsinfo = [];
          for (var obj of goodparams) {
            let tempInfo = {
              Id: obj.Id,
              DataValue: !isNaN(obj.PValue) ? parseInt(obj.PValue) : obj.PValue
            };
            goodsinfo.push(tempInfo);
            }
          that.GoodsParams = goodsinfo;
          for (var i = 0; i < that.GoodsParams.length; i++) {
            if (that.GoodsParams[i].DataValue + "" == "NaN") {
              that.GoodsParams[i].DataValue = "";
            }
          }
          that.othertable = data.ResultObj.GoodsInfo.CustomizeParams;
          that.form.shichangprice = data.ResultObj.MarketPrice;
          that.form.tzprice = data.ResultObj.TzrPrice;
          that.form.yongjin = data.ResultObj.CostRate;
          that.form.weistock = data.ResultObj.Stock;
          that.GoodModelCode = GoodsInfo.GoodModelCode;
          that.newpinleiId = GoodsInfo.BrandTypeId;
          that.radio = String(GoodsInfo.IsUseCoupon);
          that.money = GoodsInfo.CouponCondtion;
          that.quyuarr = GoodsInfo.GoodsParamsModel_Inserts;
          for (var obj of that.quyuarr) {
            if (obj.ControlTypeId == 3) {
              if (obj.PValue == 1) {
                obj.sel = true;
              } else if (obj.PValue == 2) {
                obj.sel = false;
              }
            }
          }
          // that.getquyu();
          // that.GoodsParams = GoodsInfo.GoodsParams;
          that.newpinpaiId = GoodsInfo.BrandId;
          that.newprovinceId = GoodsInfo.ProvinceId;
          that.newcityId = GoodsInfo.CityId;
          that.getcity();
          that.gethezuotype();
          that.BbId = GoodsInfo.BbId;
          that.Title = GoodsInfo.Title;
          that.Slogan = GoodsInfo.Slogan;
          that.Advantage = GoodsInfo.Advantage;
          that.danweiId = GoodsInfo.SaleUnitId;
          that.Remark = GoodsInfo.Remark;
          that.wuliuId = GoodsInfo.LogisticsModeId
          that.FreightDesc = GoodsInfo.FreightDesc;
          that.shoplist = GoodsInfo.GoodsStores;
          that.AfterPolicy = GoodsInfo.AfterPolicy;
          that.NeedAttention = GoodsInfo.NeedAttention;
          let GoodsImgs = GoodsInfo.GoodsImgs;
          that.editgoodsimgs = [];
          // for (var obj of GoodsImgs) {
          //   let tt = obj;
            
          //   main(tt.ImgData, function(base64) {
          //     tt.ImgData = base64;
          //     that.editgoodsimgs.push(tt);
          //   });
          // }
          that.detailImgUrlarr1 = []
          that.detailImgUrlarr = []
          that.youImgUrlarr1 = []
          that.youImgUrlarr = []
          that.jianceImgUrlarr = []
          that.jianceImgUrlarr1 = []
          for (var obj of GoodsImgs) {
            if (obj.ImgType == 1) {
              var obj1 = {}
              obj1.ImgName = "详情页产品图片"
              obj1.ImgData = String(obj.Id),
              obj1.ImgType = 1
              that.detailImgUrlarr.push(obj1);
              that.detailImgUrlarr1.push(obj.ImgData);
            } else if (obj.ImgType == 6) {
              that.indexImgUrlarr.push(obj);
            } else if (obj.ImgType == 2) {
              that.colorList.push(obj);
            } else if (obj.ImgType == 3) {
              var obj1 = {}
              obj1.ImgName = "产品优势"
              obj1.ImgData = String(obj.Id),
              obj1.ImgType = 3
              that.youImgUrlarr.push(obj1);
              that.youImgUrlarr1.push(obj.ImgData);
            } else if (obj.ImgType == 4) {
              that.xiaoguoImgUrlarr.push(obj);
            } else if (obj.ImgType == 5) {
              that.xijieImgUrlarr.push(obj);
            } else if (obj.ImgType == 7) {
              var obj1 = {}
              obj1.ImgName = "产品检测"
              obj1.ImgData = String(obj.Id),
              obj1.ImgType = 7
              that.jianceImgUrlarr.push(obj1);
              that.jianceImgUrlarr1.push(obj.ImgData);
            }
          }
          if (date == 1) {
            this.isSample = true;
            this.isAdvance = false;
            this.isSpecial = false;
            this.isVip = false;
            this.isGroup = false;
            this.show = 1;
          }
          if (date == 2) {
            this.isSample = true;
            this.isAdvance = false;
            this.isSpecial = false;
            this.isVip = false;
            this.isGroup = false;
            this.show = 2;
          }
          if (date == 5) {
            this.isSample = true;
            this.isAdvance = true;
            this.isSpecial = false;
            this.isVip = false;
            this.isGroup = false;
            this.show = 5;
            let time = data.ResultObj.STime.split(" ");
            time = time[0];
            that.yuSTime = time;
            let time1 = data.ResultObj.ETime.split(" ");
            time1 = time1[0];
            that.yuETime = time1;
          }
          if (date == 3) {
            this.isSample = true;
            this.isAdvance = false;
            this.isSpecial = true;
            this.isVip = false;
            this.isGroup = false;
            this.show = 3;
            let time = data.ResultObj.ETime.split(" ");
            time = time[0];
            that.ETime = time;
          }
          if (date == 6) {
            this.isSample = true;
            this.isAdvance = false;
            this.isSpecial = false;
            this.isVip = true;
            this.isGroup = false;
            this.show = 6;
            that.VipPrice = data.ResultObj.VipPrice;
            that.Score = data.ResultObj.Score;
            that.SharingDays = data.ResultObj.SharingDays;
          }
          if (date == 4) {
            this.isSample = false;
            this.isAdvance = false;
            this.isSpecial = false;
            this.isVip = false;
            this.isGroup = true;
            this.show = 4;
          }
          // localStorage.setItem("token", res.token);
        })
      }
    },

    // 新增活动商品的编辑
    newedit() {
      if (localStorage.BbId == 0) {
        this.$swal({
          type: "warning",
          text: "您所属的品牌商无法编辑信息"
        });
      } else {
        let that = this;
        // that.editgoodsid = scope.Id;
        var loginParams = {
          goodsId: that.editgoodsid
        };
        chagoodinfo(loginParams).then(data => {
          let GoodsInfo = data.ResultObj.GoodsInfo;
          that.options = data.ResultObj.GoodsInfo.GoodActiveId;
          let date = data.ResultObj.GoodsInfo.GoodActiveId;
          this.isAdd = true;
          this.isGoods = false;
          this.shownew = false;
          let goodparams = GoodsInfo.GoodsParamsModel_Inserts;

          let goodsinfo = [];
          for (var obj of goodparams) {
            let tempInfo = {
              Id: obj.Id,
              DataValue: !isNaN(obj.PValue)
                ? parseInt(obj.PValue)
                : obj.PValue
            };
            goodsinfo.push(tempInfo);
          }
          that.GoodsParams = goodsinfo;
          for (var i = 0; i < that.GoodsParams.length; i++) {
            if (that.GoodsParams[i].DataValue + "" == "NaN") {
              that.GoodsParams[i].DataValue = "";
            }
          }
          that.othertable = data.ResultObj.GoodsInfo.CustomizeParams;
          that.form.shichangprice = data.ResultObj.MarketPrice;
          that.form.tzprice = data.ResultObj.TzrPrice;
          that.form.yongjin = data.ResultObj.CostRate;
          that.form.weistock = data.ResultObj.Stock;
          that.GoodModelCode = GoodsInfo.GoodModelCode;
          that.newpinleiId = GoodsInfo.BrandTypeId;
          that.radio = String(GoodsInfo.IsUseCoupon);
          that.money = GoodsInfo.CouponCondtion;
          that.quyuarr = GoodsInfo.GoodsParamsModel_Inserts;
          for (var obj of that.quyuarr) {
            if (obj.ControlTypeId == 3) {
              if (obj.PValue == 1) {
                obj.sel = true;
              } else if (obj.PValue == 2) {
                obj.sel = false;
              }
            }
          }
          // that.getquyu();
          // that.GoodsParams = GoodsInfo.GoodsParams;
          that.newpinpaiId = GoodsInfo.BrandId;
          that.newprovinceId = GoodsInfo.ProvinceId;
          that.newcityId = GoodsInfo.CityId;
          that.getcity();
          that.gethezuotype();
          that.BbId = GoodsInfo.BbId;
          that.Title = GoodsInfo.Title;
          that.Slogan = GoodsInfo.Slogan;
          that.Advantage = GoodsInfo.Advantage;
          that.danweiId = GoodsInfo.SaleUnitId;
          that.Remark = GoodsInfo.Remark;
          that.wuliuId = GoodsInfo.LogisticsModeId;
          that.FreightDesc = GoodsInfo.FreightDesc;
          that.shoplist = GoodsInfo.GoodsStores;
          that.AfterPolicy = GoodsInfo.AfterPolicy;
          that.NeedAttention = GoodsInfo.NeedAttention;
          let GoodsImgs = GoodsInfo.GoodsImgs;
          that.editgoodsimgs = [];
          for (var obj of GoodsImgs) {
            let tt = obj;
            main(tt.ImgData, function(base64) {
              tt.ImgData = base64;
              that.editgoodsimgs.push(tt);
            });
          }

          for (var obj of GoodsImgs) {
            if (obj.ImgType == 1) {
              that.detailImgUrlarr.push(obj);
            } else if (obj.ImgType == 6) {
              that.indexImgUrlarr.push(obj);
            } else if (obj.ImgType == 2) {
              that.colorList.push(obj);
            } else if (obj.ImgType == 3) {
              that.youImgUrlarr.push(obj);
            } else if (obj.ImgType == 4) {
              that.xiaoguoImgUrlarr.push(obj);
            } else if (obj.ImgType == 5) {
              that.xijieImgUrlarr.push(obj);
            } else if (obj.ImgType == 7) {
              that.jianceImgUrlarr.push(obj);
            }
          }

          if (date == 1) {
            this.isSample = true;
            this.isAdvance = false;
            this.isSpecial = false;
            this.isVip = false;
            this.isGroup = false;
            this.show = 1;
          }
          if (date == 2) {
            this.isSample = true;
            this.isAdvance = false;
            this.isSpecial = false;
            this.isVip = false;
            this.isGroup = false;
            this.show = 2;
          }
          if (date == 5) {
            this.isSample = true;
            this.isAdvance = true;
            this.isSpecial = false;
            this.isVip = false;
            this.isGroup = false;
            this.show = 5;
            let time = data.ResultObj.STime.split(" ");
            time = time[0];
            that.yuSTime = time;
            let time1 = data.ResultObj.ETime.split(" ");
            time1 = time1[0];
            that.yuETime = time1;
          }
          if (date == 3) {
            this.isSample = true;
            this.isAdvance = false;
            this.isSpecial = true;
            this.isVip = false;
            this.isGroup = false;
            this.show = 3;
            let time = data.ResultObj.ETime.split(" ");
            time = time[0];
            that.ETime = time;
          }
          if (date == 6) {
            this.isSample = true;
            this.isAdvance = false;
            this.isSpecial = false;
            this.isVip = true;
            this.isGroup = false;
            this.show = 6;
            that.VipPrice = data.ResultObj.VipPrice;
            that.Score = data.ResultObj.Score;
            that.SharingDays = data.ResultObj.SharingDays;
          }
          if (date == 4) {
            this.isSample = false;
            this.isAdvance = false;
            this.isSpecial = false;
            this.isVip = false;
            this.isGroup = true;
            this.show = 4;
          }
        })
      }
    },

    // 编辑尾货
    editweigoods() {
      this.loading2 = true;
      let that = this;
      let newindexImgUrlarr = that.indexImgUrlarr;
      let newdetailImgUrlarr = that.detailImgUrlarr;
      let newyouImgUrlarr = that.youImgUrlarr;
      let newxiaoguoImgUrlarr = that.xiaoguoImgUrlarr;
      let newxijieImgUrlarr = that.xijieImgUrlarr;
      let newjianceImgUrlarr = that.jianceImgUrlarr;
      let newcolorList = that.colorList;
      let GoodsImgs = [];
      var allSize = 0;
      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        GoodsImgs.push(newdetailImgUrlarr[i]);
      }
      for (var i = 0; i < newyouImgUrlarr.length; i++) {
        GoodsImgs.push(newyouImgUrlarr[i]);
      }
      for (var i = 0; i < newxiaoguoImgUrlarr.length; i++) {
        GoodsImgs.push(newxiaoguoImgUrlarr[i]);
      }
      for (var i = 0; i < newxijieImgUrlarr.length; i++) {
        GoodsImgs.push(newxijieImgUrlarr[i]);
      }
      for (var i = 0; i < newcolorList.length; i++) {
        GoodsImgs.push(newcolorList[i]);
      }
      for (var i = 0; i < newjianceImgUrlarr.length; i++) {
        GoodsImgs.push(newjianceImgUrlarr[i]);
      }
        GoodsImgs.unshift({ImgData:that.firstDetail.length?that.firstDetail.split(',')[0]:that.detailImgUrlarr[0].ImgData,ImgType:6})
      //  GoodsImgs.unshift({ImgData:that.firstDetail.split(',')[0],ImgType:6})
      let goodsinfo = {};
      goodsinfo.CustomizeParams = that.othertable;
      goodsinfo.GoodModelCode = that.GoodModelCode;
      goodsinfo.BrandTypeId = that.newpinleiId;
      goodsinfo.BrandId = that.newpinpaiId;
      goodsinfo.ProvinceId = that.newprovinceId;
      goodsinfo.BbId = that.BbId;
      goodsinfo.CityId = that.newcityId;
      goodsinfo.Title = that.Title;
      goodsinfo.Slogan = that.Slogan;
      goodsinfo.Advantage = that.Advantage;
      goodsinfo.SaleUnitId = that.danweiId;
      goodsinfo.Remark = that.Remark;
      goodsinfo.LogisticsModeId = that.wuliuId;
      goodsinfo.FreightDesc = that.FreightDesc;
      goodsinfo.GoodsImgs = GoodsImgs;
      goodsinfo.GoodsStores = that.shoplist;
      goodsinfo.GoodsParams = that.GoodsParams;
      goodsinfo.AfterPolicy = that.AfterPolicy;
      goodsinfo.NeedAttention = that.NeedAttention;
      goodsinfo.GoodActiveId = 1;
      goodsinfo.ActiveGoodsTypeId = 1;
      goodsinfo.OperatorId = that.$cookie.get("OperatorId");
      goodsinfo.Id = that.editgoodsid;
      (goodsinfo.isUseCoupon = that.radio),
      (goodsinfo.couponCondtion = Number(that.money));
      var addParams = {
        MarketPrice: that.form.shichangprice,
        TzrPrice: that.form.tzprice,
        Stock: that.form.weistock,
        CostRate: that.form.yongjin,
        GoodsInfo: goodsinfo,
        GoodsId: that.editgoodsid
      };

      // 发送 POST 请求
      NProgress.start();
      this.$http({
        method: "post",
        url: localStorage.BaseUrl + "/goodsService/TailCargo/UpdateTailCargo",
        data: addParams,
        headers: { "Content-Type": "application/json; charset=UTF-8" }
      })
        .then(res => {
          NProgress.done();
          this.loading2 = false;
          if (res.data.ResultCode == 1) {
            this.$swal({
              type: "success",
              text: "修改成功"
            });
            if (that.actid == true) {
              that.isGoods = true;
              that.editgoodsimgs = [];
              that.indexImgUrlarr = [];
              that.detailImgUrlarr = [];
              that.youImgUrlarr = [];
              that.xiaoguoImgUrlarr = [];
              that.xijieImgUrlarr = [];
              that.jianceImgUrlarr = [];
              that.colorList = [];
              this.$router.push({
                path: "/tail"
              });
            } else {
              that.isNext = false;
              that.isAdd = false;
              that.isGoods = true;
              that.editgoodsimgs = [];
              that.indexImgUrlarr = [];
              that.detailImgUrlarr = [];
              that.youImgUrlarr = [];
              that.xiaoguoImgUrlarr = [];
              that.xijieImgUrlarr = [];
              that.jianceImgUrlarr = [];
              that.colorList = [];
            }

            that.getgoodlist();
          }
        })
        .catch(err => {
          NProgress.done();
          this.loading2 = false;
          this.$notify.error({
            title: "错误",
            message: err.data.ResultMsg
          });
        });
    },

    // 编辑特卖
    edittemai() {
      this.loading2 = true;
      let that = this;
      let GoodsImgs = [];
      let newindexImgUrlarr = that.indexImgUrlarr;
      let newdetailImgUrlarr = that.detailImgUrlarr;
      let newyouImgUrlarr = that.youImgUrlarr;
      let newxiaoguoImgUrlarr = that.xiaoguoImgUrlarr;
      let newxijieImgUrlarr = that.xijieImgUrlarr;
      let newjianceImgUrlarr = that.jianceImgUrlarr;
      let newcolorList = that.colorList;
      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        GoodsImgs.push(newdetailImgUrlarr[i]);
      }
      for (var i = 0; i < newyouImgUrlarr.length; i++) {
        GoodsImgs.push(newyouImgUrlarr[i]);
      }
      for (var i = 0; i < newxiaoguoImgUrlarr.length; i++) {
        GoodsImgs.push(newxiaoguoImgUrlarr[i]);
      }
      for (var i = 0; i < newxijieImgUrlarr.length; i++) {
        GoodsImgs.push(newxijieImgUrlarr[i]);
      }
      for (var i = 0; i < newcolorList.length; i++) {
        GoodsImgs.push(newcolorList[i]);
      }
      for (var i = 0; i < newjianceImgUrlarr.length; i++) {
        GoodsImgs.push(newjianceImgUrlarr[i]);
      }
      GoodsImgs.unshift({ImgData:that.firstDetail.length?that.firstDetail.split(',')[0]:that.detailImgUrlarr[0].ImgData,ImgType:6})
      // GoodsImgs.unshift({ImgData:that.firstDetail.split(',')[0],ImgType:6})
      let goodsinfo = {};
      goodsinfo.CustomizeParams = that.othertable;
      goodsinfo.GoodModelCode = that.GoodModelCode;
      goodsinfo.BrandTypeId = that.newpinleiId;
      goodsinfo.BrandId = that.newpinpaiId;
      goodsinfo.ProvinceId = that.newprovinceId;
      goodsinfo.BbId = localStorage.BbId;
      goodsinfo.CityId = that.newcityId;
      goodsinfo.Title = that.Title;
      goodsinfo.Slogan = that.Slogan;
      goodsinfo.Advantage = that.Advantage;
      goodsinfo.SaleUnitId = that.danweiId;
      goodsinfo.Remark = that.Remark;
      goodsinfo.LogisticsModeId = that.wuliuId;
      goodsinfo.FreightDesc = that.FreightDesc;
      goodsinfo.GoodsImgs = GoodsImgs;
      goodsinfo.GoodsStores = that.shoplist;
      goodsinfo.GoodsParams = that.GoodsParams;
      goodsinfo.AfterPolicy = that.AfterPolicy;
      goodsinfo.NeedAttention = that.NeedAttention;
      goodsinfo.GoodActiveId = 1;
      goodsinfo.ActiveGoodsTypeId = 1;
      goodsinfo.OperatorId = that.$cookie.get("OperatorId");
      goodsinfo.Id = that.editgoodsid;
      (goodsinfo.isUseCoupon = that.radio),
        (goodsinfo.couponCondtion = Number(that.money));
      let date1 = "";
      if (that.ETime != "") {
        let reg = /^(\d{4})-(\d{2})-(\d{2})$/;
        if (!reg.test(that.ETime)) {
          date1 =
            that.ETime.getFullYear() +
            "-" +
            that.p(that.ETime.getMonth() + 1) +
            "-" +
            that.p(that.ETime.getDate());
        } else {
          date1 = that.ETime;
        }
      }
      var addParams = {
        MarketPrice: that.form.shichangprice,
        TzrPrice: that.form.tzprice,
        Stock: that.form.weistock,
        CostRate: that.form.yongjin,
        ETime: date1,
        GoodsInfo: goodsinfo,
        GoodsId: that.editgoodsid
      };
      // GoodsImgs = JSON.parse(GoodsImgs);
      NProgress.start();
      this.$http({
        method: "post",
        url: localStorage.BaseUrl + "/goodsService/SpecialSale/UpdateSpecialSale",
        data: addParams,
        headers: { "Content-Type": "text/plain; charset=UTF-8" }
      })
      .then(res => {
        NProgress.done();
        this.loading2 = false;
        if (res.data.ResultCode == 1) {
          this.$swal({
            type: "success",
            text: "修改成功"
          });
          if (that.actid == true) {
            that.isGoods = true;
            that.editgoodsimgs = [];
            that.indexImgUrlarr = [];
            that.detailImgUrlarr = [];
            that.youImgUrlarr = [];
            that.xiaoguoImgUrlarr = [];
            that.xijieImgUrlarr = [];
            that.jianceImgUrlarr = [];
            that.colorList = [];
            that.getgoodlist();
            this.$router.push({
              path: "/specialSale"
            });
          } else {
            that.isNext = false;
            that.isAdd = false;
            that.isGoods = true;
            that.editgoodsimgs = [];
            that.indexImgUrlarr = [];
            that.detailImgUrlarr = [];
            that.youImgUrlarr = [];
            that.xiaoguoImgUrlarr = [];
            that.xijieImgUrlarr = [];
            that.jianceImgUrlarr = [];
            that.colorList = [];
            that.getgoodlist();
          }
        }
      })
      .catch(err => {
        this.loading2 = false;
        NProgress.done();
        this.$notify.error({
          title: "错误",
          message: err.data.ResultMsg
        });
      });
    },

    // 编辑样品管理
    edityangpin() {
      this.loading2 = true;
      let that = this;
      let GoodsImgs = [];
      let newindexImgUrlarr = that.indexImgUrlarr;
      let newdetailImgUrlarr = that.detailImgUrlarr;
      let newyouImgUrlarr = that.youImgUrlarr;
      let newxiaoguoImgUrlarr = that.xiaoguoImgUrlarr;
      let newxijieImgUrlarr = that.xijieImgUrlarr;
      let newjianceImgUrlarr = that.jianceImgUrlarr;
      let newcolorList = that.colorList;
      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        GoodsImgs.push(newdetailImgUrlarr[i]);
      }
      for (var i = 0; i < newyouImgUrlarr.length; i++) {
        GoodsImgs.push(newyouImgUrlarr[i]);
      }
      for (var i = 0; i < newxiaoguoImgUrlarr.length; i++) {
        GoodsImgs.push(newxiaoguoImgUrlarr[i]);
      }
      for (var i = 0; i < newxijieImgUrlarr.length; i++) {
        GoodsImgs.push(newxijieImgUrlarr[i]);
      }
      for (var i = 0; i < newcolorList.length; i++) {
        GoodsImgs.push(newcolorList[i]);
      }
      for (var i = 0; i < newjianceImgUrlarr.length; i++) {
        GoodsImgs.push(newjianceImgUrlarr[i]);
      }
      GoodsImgs.unshift({ImgData:that.firstDetail.length?that.firstDetail.split(',')[0]:that.detailImgUrlarr[0].ImgData,ImgType:6})
      // GoodsImgs.unshift({ImgData:that.firstDetail.split(',')[0],ImgType:6})
      // return
      let goodsinfo = {};
      goodsinfo.CustomizeParams = that.othertable;
      goodsinfo.GoodModelCode = that.GoodModelCode;
      goodsinfo.BrandTypeId = that.newpinleiId;
      goodsinfo.BrandId = that.newpinpaiId;
      goodsinfo.ProvinceId = that.newprovinceId;
      goodsinfo.BbId = localStorage.BbId;
      goodsinfo.CityId = that.newcityId;
      goodsinfo.Title = that.Title;
      goodsinfo.Slogan = that.Slogan;
      goodsinfo.Advantage = that.Advantage;
      goodsinfo.SaleUnitId = that.danweiId;
      goodsinfo.Remark = that.Remark;
      goodsinfo.LogisticsModeId = that.wuliuId;
      goodsinfo.FreightDesc = that.FreightDesc;
      goodsinfo.GoodsImgs = GoodsImgs;
      goodsinfo.GoodsStores = that.shoplist;
      goodsinfo.GoodsParams = that.GoodsParams;
      goodsinfo.AfterPolicy = that.AfterPolicy;
      goodsinfo.NeedAttention = that.NeedAttention;
      goodsinfo.GoodActiveId = 1;
      goodsinfo.ActiveGoodsTypeId = 1;
      goodsinfo.OperatorId = that.$cookie.get("OperatorId");
      goodsinfo.Id = that.editgoodsid;
      (goodsinfo.isUseCoupon = that.radio),
      (goodsinfo.couponCondtion = Number(that.money));
      var addParams = {
        MarketPrice: that.form.shichangprice,
        TzrPrice: that.form.tzprice,
        Stock: that.form.weistock,
        CostRate: that.form.yongjin,
        GoodsInfo: goodsinfo,
        GoodsId: that.editgoodsid
      };

      NProgress.start();
      // 发送 POST 请求
      this.$http({
        method: "post",
        url: localStorage.BaseUrl + "/goodsService/Sample/UpdateSample",
        data: addParams,
        headers: { "Content-Type": "text/plain; charset=UTF-8" }
      })
      .then(res => {
        NProgress.done();
        this.loading2 = false;
        if (res.data.ResultCode == 1) {
          this.$swal({
            type: "success",
            text: "修改成功"
          });
          if (that.actid == true) {
            that.isGoods = true;
            that.editgoodsimgs = [];
            that.indexImgUrlarr = [];
            that.detailImgUrlarr = [];
            that.youImgUrlarr = [];
            that.xiaoguoImgUrlarr = [];
            that.xijieImgUrlarr = [];
            that.jianceImgUrlarr = [];
            that.colorList = [];
            that.getgoodlist();
            this.$router.push({
              path: "/sample"
            });
          } else {
            that.isNext = false;
            that.isAdd = false;
            that.isGoods = true;
            that.editgoodsimgs = [];
            that.indexImgUrlarr = [];
            that.detailImgUrlarr = [];
            that.youImgUrlarr = [];
            that.xiaoguoImgUrlarr = [];
            that.xijieImgUrlarr = [];
            that.jianceImgUrlarr = [];
            that.colorList = [];
            that.getgoodlist();
          }
        }
      })
      .catch(err => {
        NProgress.done();
        this.loading2 = false;
        this.$notify.error({
          title: "错误",
          message: err.data.ResultMsg
        });
      });
    },
    // 编辑预售
    edityushou() {
      this.loading2 = true;
      let that = this;
      let GoodsImgs = [];
      let newindexImgUrlarr = that.indexImgUrlarr;
      let newdetailImgUrlarr = that.detailImgUrlarr;
      let newyouImgUrlarr = that.youImgUrlarr;
      let newxiaoguoImgUrlarr = that.xiaoguoImgUrlarr;
      let newxijieImgUrlarr = that.xijieImgUrlarr;
      let newjianceImgUrlarr = that.jianceImgUrlarr;
      let newcolorList = that.colorList;
      for (var i = 0; i < newindexImgUrlarr.length; i++) {
        GoodsImgs.push(newindexImgUrlarr[i]);
      }
      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        GoodsImgs.push(newdetailImgUrlarr[i]);
      }
      for (var i = 0; i < newyouImgUrlarr.length; i++) {
        GoodsImgs.push(newyouImgUrlarr[i]);
      }
      for (var i = 0; i < newxiaoguoImgUrlarr.length; i++) {
        GoodsImgs.push(newxiaoguoImgUrlarr[i]);
      }
      for (var i = 0; i < newxijieImgUrlarr.length; i++) {
        GoodsImgs.push(newxijieImgUrlarr[i]);
      }
      for (var i = 0; i < newcolorList.length; i++) {
        GoodsImgs.push(newcolorList[i]);
      }
      for (var i = 0; i < newjianceImgUrlarr.length; i++) {
        GoodsImgs.push(newjianceImgUrlarr[i]);
      }
      let goodsinfo = {};
      goodsinfo.CustomizeParams = that.othertable;
      goodsinfo.GoodModelCode = that.GoodModelCode;
      goodsinfo.BrandTypeId = that.newpinleiId;
      goodsinfo.BrandId = that.newpinpaiId;
      goodsinfo.ProvinceId = that.newprovinceId;
      goodsinfo.BbId = localStorage.BbId;
      goodsinfo.CityId = that.newcityId;
      goodsinfo.Title = that.Title;
      goodsinfo.Slogan = that.Slogan;
      goodsinfo.Advantage = that.Advantage;
      goodsinfo.SaleUnitId = that.danweiId;
      goodsinfo.Remark = that.Remark;
      goodsinfo.LogisticsModeId = that.wuliuId;
      goodsinfo.FreightDesc = that.FreightDesc;
      goodsinfo.GoodsImgs = GoodsImgs;
      goodsinfo.GoodsStores = that.shoplist;
      goodsinfo.GoodsParams = that.GoodsParams;
      goodsinfo.AfterPolicy = that.AfterPolicy;
      goodsinfo.NeedAttention = that.NeedAttention;
      goodsinfo.GoodActiveId = 1;
      goodsinfo.ActiveGoodsTypeId = 1;
      goodsinfo.OperatorId = that.$cookie.get("OperatorId");
      goodsinfo.Id = that.editgoodsid;
      (goodsinfo.isUseCoupon = that.radio),
      (goodsinfo.couponCondtion = Number(that.money));
      var date1 = "";
      var date2 = "";
      if (this.yuSTime != "") {
        let reg = /^(\d{4})-(\d{2})-(\d{2})$/;
        if (!reg.test(this.yuSTime)) {
          date1 =
            this.yuSTime.getFullYear() +
            "-" +
            this.p(this.yuSTime.getMonth() + 1) +
            "-" +
            this.p(this.yuSTime.getDate());
        } else {
          date1 = this.yuSTime;
        }
      }
      if (this.yuETime != "") {
        let reg = /^(\d{4})-(\d{2})-(\d{2})$/;
        if (!reg.test(this.yuSTime)) {
          date2 =
            this.yuETime.getFullYear() +
            "-" +
            this.p(this.yuETime.getMonth() + 1) +
            "-" +
            this.p(this.yuETime.getDate());
        } else {
          date2 = this.yuETime;
        }
      }

      var addParams = {
        MarketPrice: that.form.shichangprice,
        TzrPrice: that.form.tzprice,
        Stock: that.form.weistock,
        CostRate: that.form.yongjin,
        STime: date1,
        ETime: date2,
        GoodsInfo: goodsinfo,
        GoodsId: that.editgoodsid
      };

      // GoodsImgs = JSON.parse(GoodsImgs);
      NProgress.start();
      this.$http({
        method: "post",
        url: localStorage.BaseUrl + "/goodsService/AdvanceSale/UpdateAdvanceSale",
        data: addParams,
        headers: { "Content-Type": "text/plain; charset=UTF-8" }
      })
      .then(res => {
        NProgress.done();
        this.loading2 = false;
        this.$swal({
          type: "success",
          text: "修改成功"
        });
        if (that.actid == true) {
          that.isGoods = true;
          that.editgoodsimgs = [];
          that.indexImgUrlarr = [];
          that.detailImgUrlarr = [];
          that.youImgUrlarr = [];
          that.xiaoguoImgUrlarr = [];
          that.xijieImgUrlarr = [];
          that.jianceImgUrlarr = [];
          that.colorList = [];
          that.getgoodlist();
          this.$router.push({
            path: "/advanceSale"
          });
        } else {
          that.isNext = false;
          that.isAdd = false;
          that.isGoods = true;
          that.editgoodsimgs = [];
          that.indexImgUrlarr = [];
          that.detailImgUrlarr = [];
          that.youImgUrlarr = [];
          that.xiaoguoImgUrlarr = [];
          that.xijieImgUrlarr = [];
          that.jianceImgUrlarr = [];
          that.colorList = [];
          that.getgoodlist();
        }
      })
      .catch(err => {
        NProgress.done();
        this.loading2 = false;
        this.$notify.error({
          title: "错误",
          message: err.data.ResultMsg
        });
      });
    },

    // 编辑vip
    editvip() {
      this.loading2 = true;
      let that = this;
      let GoodsImgs = [];
      let newindexImgUrlarr = that.indexImgUrlarr;
      let newdetailImgUrlarr = that.detailImgUrlarr;
      let newyouImgUrlarr = that.youImgUrlarr;
      let newxiaoguoImgUrlarr = that.xiaoguoImgUrlarr;
      let newxijieImgUrlarr = that.xijieImgUrlarr;
      let newjianceImgUrlarr = that.jianceImgUrlarr;
      let newcolorList = that.colorList;
      for (var i = 0; i < newindexImgUrlarr.length; i++) {
        GoodsImgs.push(newindexImgUrlarr[i]);
      }
      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        GoodsImgs.push(newdetailImgUrlarr[i]);
      }
      for (var i = 0; i < newyouImgUrlarr.length; i++) {
        GoodsImgs.push(newyouImgUrlarr[i]);
      }
      for (var i = 0; i < newxiaoguoImgUrlarr.length; i++) {
        GoodsImgs.push(newxiaoguoImgUrlarr[i]);
      }
      for (var i = 0; i < newxijieImgUrlarr.length; i++) {
        GoodsImgs.push(newxijieImgUrlarr[i]);
      }
      for (var i = 0; i < newcolorList.length; i++) {
        GoodsImgs.push(newcolorList[i]);
      }
      for (var i = 0; i < newjianceImgUrlarr.length; i++) {
        GoodsImgs.push(newjianceImgUrlarr[i]);
      }
      let goodsinfo = {};
      goodsinfo.CustomizeParams = that.othertable;
      goodsinfo.GoodModelCode = that.GoodModelCode;
      goodsinfo.BrandTypeId = that.newpinleiId;
      goodsinfo.BrandId = that.newpinpaiId;
      goodsinfo.ProvinceId = that.newprovinceId;
      goodsinfo.BbId = localStorage.BbId;
      goodsinfo.CityId = that.newcityId;
      goodsinfo.Title = that.Title;
      goodsinfo.Slogan = that.Slogan;
      goodsinfo.Advantage = that.Advantage;
      goodsinfo.SaleUnitId = that.danweiId;
      goodsinfo.Remark = that.Remark;
      goodsinfo.LogisticsModeId = that.wuliuId;
      goodsinfo.FreightDesc = that.FreightDesc;
      goodsinfo.GoodsImgs = GoodsImgs;
      goodsinfo.GoodsStores = that.shoplist;
      goodsinfo.GoodsParams = that.GoodsParams;
      goodsinfo.AfterPolicy = that.AfterPolicy;
      goodsinfo.NeedAttention = that.NeedAttention;
      goodsinfo.GoodActiveId = 1;
      goodsinfo.ActiveGoodsTypeId = 1;
      goodsinfo.OperatorId = that.$cookie.get("OperatorId");
      goodsinfo.Id = that.editgoodsid;
      (goodsinfo.isUseCoupon = that.radio),
      (goodsinfo.couponCondtion = Number(that.money));
      var addParams = {
        MarketPrice: that.form.shichangprice,
        TzrPrice: that.form.tzprice,
        Stock: that.form.weistock,
        CostRate: that.form.yongjin,
        GoodsInfo: goodsinfo,
        VipPrice: that.VipPrice,
        Score: that.Score,
        SharingDays: that.SharingDays,
        GoodsId: that.editgoodsid
      };

      NProgress.start();
      // 发送 POST 请求
      this.$http({
        method: "post",
        url: localStorage.BaseUrl + "/goodsService/VipGoods/UpdateVipGoods",
        data: addParams,
        headers: { "Content-Type": "text/plain; charset=UTF-8" }
      })
      .then(res => {
        this.loading2 = false;
        this.$swal({
          type: "success",
          text: "修改成功"
        });
        NProgress.done();
        if (that.actid == true) {
          that.isGoods = true;
          that.editgoodsimgs = [];
          that.indexImgUrlarr = [];
          that.detailImgUrlarr = [];
          that.youImgUrlarr = [];
          that.xiaoguoImgUrlarr = [];
          that.xijieImgUrlarr = [];
          that.jianceImgUrlarr = [];
          that.colorList = [];
          that.getgoodlist();
          this.$router.push({
            path: "/vipGoods"
          });
        } else {
          that.isNext = false;
          that.isAdd = false;
          that.isGoods = true;
          that.editgoodsimgs = [];
          that.indexImgUrlarr = [];
          that.detailImgUrlarr = [];
          that.youImgUrlarr = [];
          that.xiaoguoImgUrlarr = [];
          that.xijieImgUrlarr = [];
          that.jianceImgUrlarr = [];
          that.colorList = [];
          that.getgoodlist();
        }
      })
      .catch(err => {
        NProgress.done();
        this.loading2 = false;
        this.$notify.error({
          title: "错误",
          message: err.data.ResultMsg
        });
      });
    },
    seecancelmodel() {
      this.ischaNext = false;
      this.isGoods = true;
    },

    // 查看商品信息
    chakan(scope) {
      let that = this;
      that.detailImgUrlarr = [];
      that.indexImgUrlarr = [];
      that.colorList = [];
      that.youImgUrlarr = [];
      that.xijieImgUrlarr = [];
      that.jianceImgUrlarr = [];
      that.xiaoguoImgUrlarr = [];
      that.shoplist = [];
      var loginParams = {
        goodsId: scope.Id
      };
      chagoodinfo(loginParams).then(data => {
        let GoodsInfo = data.ResultObj.GoodsInfo;
        that.options = data.ResultObj.GoodsInfo.GoodActiveId;
        let date = data.ResultObj.GoodsInfo.GoodActiveId;
        this.ischaAdd = true;
        this.isGoods = false;
        that.othertable = data.ResultObj.GoodsInfo.CustomizeParams;
        that.form.shichangprice = data.ResultObj.MarketPrice;
        that.form.tzprice = data.ResultObj.TzrPrice;
        that.form.yongjin = data.ResultObj.CostRate;
        that.form.weistock = data.ResultObj.Stock;
        that.GoodModelCode = GoodsInfo.GoodModelCode;
        that.newpinleiId = GoodsInfo.BrandTypeId;
        that.radio = String(GoodsInfo.IsUseCoupon);
        that.money = GoodsInfo.CouponCondtion;
        that.quyuarr = GoodsInfo.GoodsParamsModel_Inserts;

        for (var obj of that.quyuarr) {
          if (obj.ControlTypeId == 3) {
            if (obj.PValue == 1) {
              obj.sel = true;
            } else if (obj.PValue == 2) {
              obj.sel = false;
            }
          }
        }
        that.GoodsParams = GoodsInfo.GoodsParams;
        if (localStorage.BbId == 0) {
          that.newpinpaiId = GoodsInfo.BbName;
        } else {
          that.newpinpaiId = GoodsInfo.BrandId;
        }
        that.newprovinceId = GoodsInfo.ProvinceId;
        that.newcityId = GoodsInfo.CityId;
        that.getcity();

        that.gethezuotype();
        that.BbId = GoodsInfo.BbId;

        that.Title = GoodsInfo.Title;
        that.Slogan = GoodsInfo.Slogan;
        that.Advantage = GoodsInfo.Advantage;
        that.danweiId = GoodsInfo.SaleUnitId;
        that.Remark = GoodsInfo.Remark;
        that.wuliuId = GoodsInfo.LogisticsModeId;
        that.FreightDesc = GoodsInfo.FreightDesc;
        that.AfterPolicy = GoodsInfo.AfterPolicy;
        that.NeedAttention = GoodsInfo.NeedAttention;
        that.shoplist = GoodsInfo.GoodsStores;
        let goodparams = GoodsInfo.GoodsParamsModel_Inserts;
        let goodsinfo = [];
        for (var obj of goodparams) {
          let tempInfo = {
            Id: obj.Id,
            DataValue: !isNaN(obj.PValue) ? parseInt(obj.PValue) : obj.PValue
          };
          goodsinfo.push(tempInfo);
        }

        that.GoodsParams = goodsinfo;
        for (var i = 0; i < that.GoodsParams.length; i++) {
          if (that.GoodsParams[i].DataValue + "" == "NaN") {
            that.GoodsParams[i].DataValue = "";
          }
        }
        let GoodsImgs = GoodsInfo.GoodsImgs;

        for (var obj of GoodsImgs) {
          if (obj.ImgType == 1) {
            that.detailImgUrlarr.push(obj);
          } else if (obj.ImgType == 6) {
            that.indexImgUrlarr.push(obj);
          } else if (obj.ImgType == 2) {
            that.colorList.push(obj);
          } else if (obj.ImgType == 3) {
            that.youImgUrlarr.push(obj);
          } else if (obj.ImgType == 4) {
            that.xiaoguoImgUrlarr.push(obj);
          } else if (obj.ImgType == 5) {
            that.xijieImgUrlarr.push(obj);
          } else if (obj.ImgType == 7) {
            that.jianceImgUrlarr.push(obj);
          }
        }

        if (date == 1) {
          this.isSample = true;
          this.isAdvance = false;
          this.isSpecial = false;
          this.isVip = false;
          this.isGroup = false;
          this.show = 1;
        }
        if (date == 2) {
          this.isSample = true;
          this.isAdvance = false;
          this.isSpecial = false;
          this.isVip = false;
          this.isGroup = false;
          this.show = 2;
        }
        if (date == 5) {
          this.isSample = true;
          this.isAdvance = true;
          this.isSpecial = false;
          this.isVip = false;
          this.isGroup = false;
          this.show = 5;
          that.yuSTime = data.ResultObj.STime;
          that.yuETime = data.ResultObj.ETime;
        }
        if (date == 3) {
          this.isSample = true;
          this.isAdvance = false;
          this.isSpecial = true;
          this.isVip = false;
          this.isGroup = false;
          this.show = 3;
          that.ETime = data.ResultObj.ETime;
        }
        if (date == 6) {
          this.isSample = true;
          this.isAdvance = false;
          this.isSpecial = false;
          this.isVip = true;
          this.isGroup = false;
          this.show = 6;
          that.VipPrice = data.ResultObj.VipPrice;
          that.Score = data.ResultObj.Score;
          that.SharingDays = data.ResultObj.SharingDays;
        }
        if (date == 4) {
          this.isSample = false;
          this.isAdvance = false;
          this.isSpecial = false;
          this.isVip = false;
          this.isGroup = true;
          this.show = 4;
        }
        // localStorage.setItem("token", res.token);
      })
    },

    newchakan() {
      let that = this;
      var loginParams = {
        goodsId: that.editgoodsid
      };
      chagoodinfo(loginParams).then(data => {
          let GoodsInfo = data.ResultObj.GoodsInfo;
          that.options = data.ResultObj.GoodsInfo.GoodActiveId;
          let date = data.ResultObj.GoodsInfo.GoodActiveId;
          // this.ischaNext = true;
          this.isGoods = false;
          that.form.shichangprice = data.ResultObj.MarketPrice;
          that.form.tzprice = data.ResultObj.TzrPrice;
          that.form.yongjin = data.ResultObj.CostRate;
          that.form.weistock = data.ResultObj.Stock;
          that.GoodModelCode = GoodsInfo.GoodModelCode;
          that.newpinleiId = GoodsInfo.BrandTypeId;
          that.radio = String(GoodsInfo.IsUseCoupon);
          that.money = GoodsInfo.CouponCondtion;
          that.quyuarr = GoodsInfo.GoodsParamsModel_Inserts;
          for (var obj of that.quyuarr) {
            if (obj.ControlTypeId == 3) {
              if (obj.PValue == 1) {
                obj.sel = true;
              } else if (obj.PValue == 2) {
                obj.sel = false;
              }
            }
          }
          that.GoodsParams = GoodsInfo.GoodsParams;
          if (localStorage.BbId == 0) {
            that.newpinpaiId = GoodsInfo.BbName;
          } else {
            that.newpinpaiId = GoodsInfo.BrandId;
          }
          that.newprovinceId = GoodsInfo.ProvinceId;
          that.newcityId = GoodsInfo.CityId;
          that.getcity();
          that.gethezuotype();
          that.BbId = GoodsInfo.BbId;

          that.Title = GoodsInfo.Title;
          that.Slogan = GoodsInfo.Slogan;
          that.Advantage = GoodsInfo.Advantage;
          that.danweiId = GoodsInfo.SaleUnitId;
          that.Remark = GoodsInfo.Remark;
          that.wuliuId = GoodsInfo.LogisticsModeId;
          that.FreightDesc = GoodsInfo.FreightDesc;
          that.AfterPolicy = GoodsInfo.AfterPolicy;
          that.NeedAttention = GoodsInfo.NeedAttention;
          that.shoplist = GoodsInfo.GoodsStores;
          let goodparams = GoodsInfo.GoodsParamsModel_Inserts;
          let goodsinfo = [];
          for (var obj of goodparams) {
            let tempInfo = {
              Id: obj.Id,
              DataValue: !isNaN(obj.PValue) ? parseInt(obj.PValue) : obj.PValue
            };
            goodsinfo.push(tempInfo);
          }

          that.GoodsParams = goodsinfo;
          for (var i = 0; i < that.GoodsParams.length; i++) {
            if (that.GoodsParams[i].DataValue + "" == "NaN") {
              that.GoodsParams[i].DataValue = "";
            }
          }
          let GoodsImgs = GoodsInfo.GoodsImgs;
          for (var obj of GoodsImgs) {
            if (obj.ImgType == 1) {
              that.detailImgUrlarr.push(obj);
            } else if (obj.ImgType == 6) {
              that.indexImgUrlarr.push(obj);
            } else if (obj.ImgType == 2) {
              that.colorList.push(obj);
            } else if (obj.ImgType == 3) {
              that.youImgUrlarr.push(obj);
            } else if (obj.ImgType == 4) {
              that.xiaoguoImgUrlarr.push(obj);
            } else if (obj.ImgType == 5) {
              that.xijieImgUrlarr.push(obj);
            } else if (obj.ImgType == 7) {
              that.jianceImgUrlarr.push(obj);
            }
          }

          if (date == 1) {
            this.isSample = true;
            this.isAdvance = false;
            this.isSpecial = false;
            this.isVip = false;
            this.isGroup = false;
            this.show = 1;
          }
          if (date == 2) {
            this.isSample = true;
            this.isAdvance = false;
            this.isSpecial = false;
            this.isVip = false;
            this.isGroup = false;
            this.show = 2;
          }
          if (date == 5) {
            this.isSample = true;
            this.isAdvance = true;
            this.isSpecial = false;
            this.isVip = false;
            this.isGroup = false;
            this.show = 5;

            that.yuSTime = data.ResultObj.STime;

            that.yuETime = data.ResultObj.ETime;
          }
          if (date == 3) {
            this.isSample = true;
            this.isAdvance = false;
            this.isSpecial = true;
            this.isVip = false;
            this.isGroup = false;
            this.show = 3;
            that.ETime = data.ResultObj.ETime;
          }
          if (date == 6) {
            this.isSample = true;
            this.isAdvance = false;
            this.isSpecial = false;
            this.isVip = true;
            this.isGroup = false;
            this.show = 6;
            that.VipPrice = data.ResultObj.VipPrice;
            that.Score = data.ResultObj.Score;
            that.SharingDays = data.ResultObj.SharingDays;
          }
          if (date == 4) {
            this.isSample = false;
            this.isAdvance = false;
            this.isSpecial = false;
            this.isVip = false;
            this.isGroup = true;
            this.show = 4;
          }

          // localStorage.setItem("token", res.token);
        })
        .catch(err => {
        });
    },
    //下架商品
    xiajia(scope) {
      let that = this;
      var loginParams = {
        goodsId: scope.Id,
        statusId: 4,
        operId: that.$cookie.get("OperatorId")
      };
      changegood(loginParams)
        .then(data => {
          if (data.ResultCode == 1) {
            this.$swal({
              text: "操作成功",
              type: "success"
            });
          }
          that.getgoodlist();
          // localStorage.setItem("token", res.token);
        })
        .catch(err => {
        });
    },
    shangjia(scope) {
      let that = this;
      var loginParams = {
        goodsId: scope.Id,
        statusId: 1,
        operId: that.$cookie.get("OperatorId")
      };
      changegood(loginParams)
        .then(data => {
          this.$swal({
            text: "操作成功",
            type: "success"
          });
          that.getgoodlist();
          // localStorage.setItem("token", res.token);
        })
        .catch(err => {
        });
    },
    guoqi(scope) {
      let that = this;
      var loginParams = {
        goodsId: scope.Id,
        statusId: 3,
        operId: that.$cookie.get("OperatorId")
      };
      changegood(loginParams)
        .then(data => {
          if (data.ResultCode == 1) {
            this.$swal({
              type: "success",
              text: "操作成功"
            });
          }
          that.getgoodlist();
          // localStorage.setItem("token", res.token);
        })
        .catch(err => {
        });
    },
    //停用
    tingyong(scope) {
      let that = this;
      var loginParams = {
        goodsId: scope.Id,
        statusId: 3,
        operId: that.$cookie.get("OperatorId")
      };
      changegood(loginParams)
        .then(data => {
          that.getgoodlist();
          // localStorage.setItem("token", res.token);
        })
        .catch(err => {
        });
    }
  },
  mounted() {
    this.BaseUrl = localStorage.BaseUrl
    this.newUserType = localStorage.UserType
    const that1 = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that1.screenWidth = window.screenWidth;
      })();
    };
    this.getbrand();
    this.getBrandType();
    this.getBrandByCityId();
    this.getpinlei();
    this.getstatus();
    //获取商品列表
    this.getgoodlist();
    //获取销售类型
    this.getxiaoshoutype();
    this.getxiaoshoutype1()
    //新增商品品类
    // this.getnewgoodpinlei();
    //新增商品品牌
    // this.getnewgoodpinpai();
    //获取省
    this.getprovince();
    //获取销售单位
    this.getdanwei();
    //获取物流方式
    this.getwuliu();
    this.getbrandarr()
    if (this.$route.query.id) {
      let date = this.$route.query.id;
      this.act = this.$route.query.act;
      this.showNext();
      this.options = this.$route.query.id;
      if (date == 1) {
        this.money = 2000;
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = false;
        this.show = 1;
      }
      if (date == 2) {
        this.money = 2000;
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = false;
        this.show = 2;
      }
      if (date == 5) {
        this.money = 1000;
        this.isSample = true;
        this.isAdvance = true;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = false;
        this.show = 5;
      }
      if (date == 3) {
        this.money = 1000;
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = true;
        this.isVip = false;
        this.isGroup = false;
        this.show = 3;
      }
      if (date == 6) {
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = true;
        this.isGroup = false;
        this.show = 6;
      }
      if (date == 4) {
        this.isSample = false;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = true;
        this.show = 4;
      }
    }
    //活动列表点击编辑
    if (this.$route.query.id && this.$route.query.editid) {
      let date = this.$route.query.id;
      this.actid = this.$route.query.actid;
      this.chatid = this.$route.query.chatid;
      this.editgoodsid = this.$route.query.editid;
      this.options = date;
      if (date == 1) {
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = false;
        this.show = 1;
        this.newedit();
      }
      if (date == 2) {
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = false;
        this.show = 2;
        this.newedit();
      }
      if (date == 5) {
        this.isSample = true;
        this.isAdvance = true;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = false;
        this.show = 5;
        this.newedit();
      }
      if (date == 3) {
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = true;
        this.isVip = false;
        this.isGroup = false;
        this.show = 3;
        this.newedit();
      }
      if (date == 6) {
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = true;
        this.isGroup = false;
        this.show = 6;
        this.newedit();
      }
      if (date == 4) {
        this.isSample = false;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = true;
        this.show = 4;
      }
    }

    if (this.$route.query.chatid) {
      let date = this.$route.query.noid;

      this.editgoodsid = this.$route.query.editid;

      this.options = date;
      this.ischaAdd = true;
      this.isGoods = false;
      this.isNext = false;

      if (date == 1) {
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = false;
        this.show = 1;
        this.newchakan();
      }
      if (date == 2) {
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = false;
        this.show = 2;
        this.newchakan();
      }
      if (date == 5) {
        this.isSample = true;
        this.isAdvance = true;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = false;
        this.show = 5;
        this.newchakan();
      }
      if (date == 3) {
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = true;
        this.isVip = false;
        this.isGroup = false;
        this.show = 3;
        this.newchakan();
      }
      if (date == 6) {
        this.isSample = true;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = true;
        this.isGroup = false;
        this.show = 6;
        this.newchakan();
      }
      if (date == 4) {
        this.isSample = false;
        this.isAdvance = false;
        this.isSpecial = false;
        this.isVip = false;
        this.isGroup = true;
        this.show = 4;
      }
    }
  },
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function() {
          // 打印screenWidth变化的值
          if (that.screenWidth == 1920 || 1919) {
            this.styleId1 = "110px";
          }
          that.timer = false;
        }, 400);
      }
    },
    menuAction: function(val) {
      this.menuAction = val;
    },
    GoodsParams() {
    },
    "form.shichangprice": {
      handler: function(val) {
        if (val.length > 11) {
          this.form.shichangprice = val.slice(0,11);
        }
      },
      deep: true
    },
    "form.tzprice": {
      handler: function(val) {
        if (val.length > 11) {
          this.form.tzprice = val.slice(0, 11);
        }
      },
      deep: true
    },
    "form.yongjin": {
      handler: function(val) {
        if (val.length >= 3) {
          this.form.yongjin = val.slice(0, 2);
        }
      },
      deep: true
    }
  }
};
</script>
<style scoped>
.butstyle {
  margin-right: 10px !important;
  font-size: 12px;
}
.butstyle1 {
  margin-right: 5px !important;
  font-size: 10px;
}
.avatar-uploader1 .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader1 .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon1 {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px solid #eeeeee;
}
.region1 {
  font-size: 18px;
  font-weight: 600;
}
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
}
.otherparameter {
  width: 860px;
  color: #333333;
  height: 78px;
  border: 1px solid #d2d2d2;
  border-top: none;
}
.otherset {
  width: 860px;
  height: 40px;
  border: 1px solid #d2d2d2;
  color: #333333;
}
.goods .toolbar {
  height: auto;
}

.goods .toolbar .el-button {
  background-color: #F56C6C;
  margin-left: 0;
  color: #fff;
  width: 78px;
}
/* goods管理 */
/* 内容表格 */
.goods_table {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 10px;
  position: relative;
  overflow: hidden;
  zoom: 1;
}
/* 标题 */
.goods_table .goods_title {
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #eee;
}
/* goods管理 */
.goods_table .el-col-22 p {
  width: 57px;
  height: 55px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin-left: 22px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
  margin-top: 0;
}
/* 新增按钮 */
.goods_table .el-col-2 p {
  width: 104px;
  height: 36px;
  background-color: #F56C6C;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
/* 表格 */
.goods_tab {
  box-shadow: 0 0 0 0;
  width: 100%;
  margin: 0 auto;
}
/* 表格操作 */
.goods_tab .goods_operations p {
  float: left;
  color: #677c9d;
  width: 25%;
}

/* 新增 下一步页面 */
.add_goods_next {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 20px;
  height: 700px;
  position: relative;
}
.add_goods_next .el-col-24 {
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}

/* 时间图标 */
.next_form img {
  margin-left: 10px;
}
/* 输入框后的文字 */
.add_goods_next .next_form i {
  color: #888;
  font-size: 12px;
  margin-left: 10px;
}
/* 按钮 */
.add_goods_next .next_footer {
  margin-left: 100px;
}
.add_goods_next .next_footer p {
  float: left;
  width: 85px;
  height: 38px;
  background-color: #F56C6C;
  border-radius: 3px;
  cursor: pointer;
  line-height: 38px;
  text-align: center;
  color: #fff;
  margin-right: 10px;
}

/* 商品管理新增页面 */
/* 整体 */
.add_goods {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 20px;
  overflow: hidden;
  zoom: 1;
  position: relative;
}
/*商品管理新增 标题 */
.add_goods .add_title .el-col-24 {
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}
.add_goods .add_title .el-col-24 p {
  width: 85px;
  height: 55px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin: 0;
  margin-left: 20px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
}
/*所有标题 */
.msg_title p {
  font-size: 14px;
  height: 15px;
  line-height: 15px;
  border-left: 2px solid #F56C6C;
  padding-left: 7px;
}
.msg_title1 p {
  font-size: 14px;
  height: 15px;
  line-height: 15px;
  border-left: 2px solid #F56C6C;
  padding-left: 7px;
}
/* 商品基本信息 */
.add_goods .add_all {
  margin-left: 20px;
}

/* 商品基本信息内容 */
.content {
  margin-bottom: 40px;
}
/* 信息内容 */
/* 输入框后文字 */
.msg_form i {
  margin: 0 10px;
  color: #888;
  font-size: 12px;
}
/* 合作类型 */
.cooperation_type {
  overflow: hidden;
  zoom: 1;
}
.cooperation_type .el-form-item {
  float: left;
}
.cooperation_type img {
  margin: 0 10px;
}
.xijie {
  margin-left: 80px;
}

/* 颜色表格 */
.color_table {
  width: 539px;
  height: 103px;
  float: left;
  border-radius: 3px;
  color: #888;
  font-size: 12px;
}
.color_table td {
  text-align: center;
}
/* 第一行标题 */
.color_table .tr_title {
  height: 31px;
  line-height: 30px;
  overflow: hidden;
  zoom: 1;
  color: #333;
}
/* 第二行内容 */
.tr_content {
  width: 100%;
  height: 70px;
}
/* 图片 */
.table_pic {
  position: relative;
}
/* 上传图标 */
.table_pic .el-upload--picture-card i {
  font-size: 14px !important;
  position: absolute;
  top: 10px;
  left: 0px;
}
/* 颜色新增按钮 */
.color_msg .color_btn {
  float: left;
  margin-left: 15px;
  width: 60px;
  height: 30px;
  border-radius: 3px;
  border: solid 1px #e00d1b;
  color: #F56C6C;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
/* 商品详情/参数 */
.parameter_form {
  overflow: hidden;
  zoom: 1;
  width: 1022px;
}
/* 左侧 */
.parameter_form_l {
  overflow: hidden;
  zoom: 1;
  float: left;
  width: 511px;
}
/* 是否可伸缩 带转盘 */
.parameter_form .whether div {
  float: left;
  padding: 0;
  font-size: 12px;
  line-height: 20px;
  margin: 0 42px 0 0;
  vertical-align: middle;
  color: #555;
  line-height: 40px;
}
/* 选择框 */
.parameter_form .whether div i {
  display: inline-block;
  width: 25px;
  height: 20px;
  vertical-align: middle;
}
.parameter_form .whether div i img {
  display: block;
}
/* 右侧 */
.parameter_form_r {
  width: 511px;
  overflow: hidden;
  zoom: 1;
  float: left;
}
/* 产品优势 */
/* 图片 图标 */
.advantage_pic .el-upload--picture-card i {
  font-size: 28px !important;
  position: absolute;
  top: 25px;
  left: 25px;
  font-weight: normal;
}
/* 在售店面 */
.goods_shop {
  overflow: hidden;
  zoom: 1;
}
/* 在售店面表格 */
.goods_shop .shop_table {
  width: 795px;
  height: 103px;
  background-color: #d2d2d2;
  float: left;
}
/* 标题 */
.shop_title {
  height: 32px;
  font-size: 12px;
  font-weight: 200;
  color: #333;
}
/* 内容 */
.shop_content {
  text-align: center;
  color: #888;
}
/* 店铺新增按钮 */
.shop_btn {
  float: left;
  margin-left: 15px;
  width: 60px;
  height: 30px;
  border-radius: 3px;
  border: solid 1px #e00d1b;
  color: #F56C6C;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
/* 底部按钮 */
.add_goods .goods_footer {
  margin-left: 100px;
}
.add_goods .goods_footer p:first-child {
  float: left;
  width: 85px;
  height: 38px;
  background-color: #F56C6C;
  border-radius: 3px;
  cursor: pointer;
  line-height: 38px;
  text-align: center;
  color: #fff;
  margin-right: 10px;
}
.add_goods .goods_footer p {
  float: left;
  width: 85px;
  height: 38px;
  margin-right: 10px;
  border-radius: 3px;
  cursor: pointer;
  line-height: 38px;
  text-align: center;
  border: solid 1px #F56C6C;
  background-color: #fff;
  color: #F56C6C;
}
.upPictures {
  width: 88%;
}
.block {
  width:80px;
  height:80px;
  float:left;
  margin: 5px 10px 5px 0;
}
.tuimg {
  position: relative;
  cursor: pointer;
}
</style>






// WEBPACK FOOTER //
// goods.vue?3ec6f431